/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. BigInt can represent values between -(2^53) + 1 and 2^53 - 1.  */
  BigInt: { input: any; output: any };
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** SetLoadValue scalar type */
  SetLoadValue: { input: any; output: any };
};

export type Address = {
  __typename?: "Address";
  city: Maybe<Scalars["String"]["output"]>;
  country: Maybe<Scalars["String"]["output"]>;
  houseNumberAndStreetName: Maybe<Scalars["String"]["output"]>;
  postCode: Maybe<Scalars["String"]["output"]>;
};

export type AlternateServers = {
  __typename?: "AlternateServers";
  id: Scalars["ID"]["output"];
  serverA: Maybe<Server>;
  serverB: Maybe<Server>;
};

export type Approval = {
  __typename?: "Approval";
  history: Array<FirmwareFileApprovalHistory>;
  state: Scalars["String"]["output"];
};

export type AuthPinAuthorize = {
  __typename?: "AuthPinAuthorize";
  success: Scalars["Boolean"]["output"];
  type: Scalars["Int"]["output"];
};

export type AuthPinConfig = {
  __typename?: "AuthPinConfig";
  numberOfValidEntries: Scalars["Int"]["output"];
  slots: Array<AuthPinSlot>;
};

export type AuthPinSlot = {
  __typename?: "AuthPinSlot";
  auth: AuthPinAuthorize;
  friendlyName: Scalars["String"]["output"];
  userPreferredMode: Scalars["Float"]["output"];
};

export type BmsVersion = {
  __typename?: "BMSVersion";
  version1: Scalars["Int"]["output"];
  version2: Scalars["Int"]["output"];
  version3: Scalars["Int"]["output"];
  version4: Scalars["Int"]["output"];
};

export type Battery = {
  __typename?: "Battery";
  cycles: Maybe<Scalars["Int"]["output"]>;
  heatFoilStatus: Maybe<Scalars["Boolean"]["output"]>;
  number: Scalars["Float"]["output"];
};

export type BatteryCycle = {
  __typename?: "BatteryCycle";
  batteryNo: Scalars["Float"]["output"];
  cycles: Maybe<Scalars["Int"]["output"]>;
};

export enum BatteryMode {
  BATTERY_MODE_AVOID_BOTH = "BATTERY_MODE_AVOID_BOTH",
  BATTERY_MODE_AVOID_CHARGE = "BATTERY_MODE_AVOID_CHARGE",
  BATTERY_MODE_AVOID_DISCHARGE = "BATTERY_MODE_AVOID_DISCHARGE",
  BATTERY_MODE_NONE = "BATTERY_MODE_NONE",
  BATTERY_MODE_WITHIN_GEN = "BATTERY_MODE_WITHIN_GEN",
}

export enum BatteryType {
  MODEL_FRONIUS = "MODEL_FRONIUS",
  MODEL_LIBBI = "MODEL_LIBBI",
  MODEL_WHEC = "MODEL_WHEC",
}

export enum BaudRateInstallType {
  HIGH_BAUD_RATE = "HIGH_BAUD_RATE",
  SERVER_VERSIONS = "SERVER_VERSIONS",
}

export enum BoostEnum {
  CANCEL_MANUAL_BOOST = "CANCEL_MANUAL_BOOST",
  CANCEL_SMART_BOOST = "CANCEL_SMART_BOOST",
  NOT_SET = "NOT_SET",
  START_MANUAL_BOOST = "START_MANUAL_BOOST",
  START_SMART_BOOST = "START_SMART_BOOST",
}

export type BoostTimerCommandParams = {
  __typename?: "BoostTimerCommandParams";
  duration: Scalars["Float"]["output"];
  fridayOn: Scalars["Boolean"]["output"];
  mode: Scalars["Float"]["output"];
  mondayOn: Scalars["Boolean"]["output"];
  rate: Scalars["Float"]["output"];
  saturdayOn: Scalars["Boolean"]["output"];
  slot: Scalars["Float"]["output"];
  startHour: Scalars["Float"]["output"];
  startMinute: Scalars["Float"]["output"];
  sundayOn: Scalars["Boolean"]["output"];
  targetEnergy: Scalars["Float"]["output"];
  thursdayOn: Scalars["Boolean"]["output"];
  tuesdayOn: Scalars["Boolean"]["output"];
  wednesdayOn: Scalars["Boolean"]["output"];
};

export enum BoostType {
  Battery = "Battery",
  Boiler = "Boiler",
  HeatPump = "HeatPump",
  NotBoostable = "NotBoostable",
}

export enum CtSubtype {
  Solar = "Solar",
  Unknown2 = "Unknown2",
  Unknown3 = "Unknown3",
  WindTurbine = "WindTurbine",
}

export enum CtTypes {
  ACBattery = "ACBattery",
  GenerationAndBattery = "GenerationAndBattery",
  GenerationPower = "GenerationPower",
  GridPower = "GridPower",
  HeatPump = "HeatPump",
  InternalLoadCTPower = "InternalLoadCTPower",
  MonitorCTPower = "MonitorCTPower",
  NONE = "NONE",
  StoragePower = "StoragePower",
}

export type ChangeAlternateServersInput = {
  serverAID?: InputMaybe<Scalars["String"]["input"]>;
  serverBID?: InputMaybe<Scalars["String"]["input"]>;
};

export type ChangeRolePermissionsInput = {
  permissions: Array<Permission>;
  type: Scalars["String"]["input"];
};

export type ChangeServerInput = {
  id: Scalars["Int"]["input"];
  ip?: InputMaybe<Scalars["String"]["input"]>;
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  url?: InputMaybe<Scalars["String"]["input"]>;
};

export type ChangeUserInput = {
  id: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export enum ChargeModePowerUp {
  BALANCE = "BALANCE",
  CAPTURE = "CAPTURE",
  CHARGE = "CHARGE",
  DRAIN = "DRAIN",
  MATCH = "MATCH",
  PREVIOUS = "PREVIOUS",
  STOP = "STOP",
}

export type ChargeSessionDataGql = {
  __typename?: "ChargeSessionDataGQL";
  authType: Scalars["Float"]["output"];
  chargeDuration: Scalars["Float"]["output"];
  chargeEnd: Scalars["String"]["output"];
  chargeStart: Scalars["String"]["output"];
  electricity: Scalars["Float"]["output"];
  friendlyName: Scalars["String"]["output"];
  greenElectricity: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  isBusiness: Scalars["Boolean"]["output"];
  pluggedIn: Scalars["String"]["output"];
  unplugged: Scalars["String"]["output"];
  zappiSerialNo: Scalars["Float"]["output"];
};

export type ChargeSessionsGql = {
  __typename?: "ChargeSessionsGQL";
  data: Array<ChargeSessionDataGql>;
  totalCount: Scalars["Float"]["output"];
  totalElectricity: Scalars["Float"]["output"];
  totalGreenElectricity: Scalars["Float"]["output"];
};

export type ChargeSlot = {
  __typename?: "ChargeSlot";
  chargingSlotMode: ChargingSlotModes;
  duration: Scalars["Int"]["output"];
  /** Energy Target in Wh, stops the slot */
  energyTargetWh: Scalars["Int"]["output"];
  /** Per phase flags (bitfield) */
  flags: Array<Scalars["Int"]["output"]>;
  individualPhases: Scalars["Boolean"]["output"];
  /** Sort of device limit charging, per phase / load */
  maxCharge: Array<Scalars["Int"]["output"]>;
  /** Sort of device limit discharging, per phase / load */
  maxDischarge: Array<Scalars["Int"]["output"]>;
  /** Minimum charging/diverting, per phase / load */
  minCharge: Array<Scalars["Int"]["output"]>;
  /** Minimum discharge, per phase / load */
  minDischarge: Array<Scalars["Int"]["output"]>;
  operate3ph: Scalars["Boolean"]["output"];
  priority: Scalars["Int"]["output"];
  recurring: Recurring;
  slotId: Scalars["Int"]["output"];
  /** State of Charge maximum SoC in 0.1% : 0 - 1000 */
  soCHigh: Scalars["Int"]["output"];
  /** State of Charge minimum SoC in 0.1% : 0 - 1000 */
  soCLow: Scalars["Int"]["output"];
  startCTimeUTC: Scalars["Int"]["output"];
  /** Provision for 3 load temperatures, product specific */
  temperatures: Array<Scalars["Int"]["output"]>;
  unit: ChargingSlotUnit;
};

/** Charge slot modes */
export enum ChargingSlotModes {
  /** Balance the grid (no surplus / no import) */
  MODE_BALANCE = "MODE_BALANCE",
  /** Libbi capture mode */
  MODE_CAPTURE = "MODE_CAPTURE",
  /** Charge load / EV operate according to min/max values present later down */
  MODE_CHARGE = "MODE_CHARGE",
  /** Drain load / EV according to min/max values */
  MODE_DRAIN = "MODE_DRAIN",
  /** Zappi eco  mode, always charge at minimum rate, more if surplus */
  MODE_ECO = "MODE_ECO",
  /** Zappi eco+ mode, only charge at MGL rate (Min Green level) */
  MODE_ECO_PLUS = "MODE_ECO_PLUS",
  /** Equivalent to boost timer, charge at max power */
  MODE_FAST = "MODE_FAST",
  /** Libbi match mode */
  MODE_MATCH = "MODE_MATCH",
  /** Stop, do nothing */
  MODE_STOP = "MODE_STOP",
}

/** Charge slot units */
export enum ChargingSlotUnit {
  /** Tenth of an amp */
  TENTH_AMPS = "TENTH_AMPS",
  /** Watts */
  WATTS = "WATTS",
}

export type Client = {
  __typename?: "Client";
  ip: Maybe<Scalars["String"]["output"]>;
  port: Maybe<Scalars["Int"]["output"]>;
  userAgent: Maybe<Scalars["String"]["output"]>;
  xForwardedFor: Maybe<Scalars["String"]["output"]>;
  xForwardedPort: Maybe<Scalars["Int"]["output"]>;
};

export type Command = {
  __typename?: "Command";
  commandInitiated: Scalars["DateTime"]["output"];
  commandInitiatorContext: Maybe<Scalars["String"]["output"]>;
  commandInitiatorService: Maybe<CommandInitiatorService>;
  commandInitiatorUser: Maybe<User>;
  commandLastSent: Maybe<Scalars["DateTime"]["output"]>;
  commandParameters: Maybe<CommandParameters>;
  commandParametersJson: Maybe<Scalars["String"]["output"]>;
  commandState: Maybe<CommandState>;
  commandTries: Scalars["Int"]["output"];
  commandType: Maybe<CommandType>;
  destinationDeviceAddressRaw: Scalars["Int"]["output"];
  destinationDeviceName: Maybe<DeviceName>;
  destinationDeviceSerialNo: Scalars["BigInt"]["output"];
  hubIPAddress: Maybe<Scalars["String"]["output"]>;
  hubNetworkId: Scalars["Int"]["output"];
  hubPort: Scalars["Int"]["output"];
  hubSerialNumber: Scalars["BigInt"]["output"];
  id: Scalars["String"]["output"];
};

/** Micro service which initiated the command */
export enum CommandInitiatorService {
  adminApi = "adminApi",
  appApi = "appApi",
  commandApi = "commandApi",
  dsrApi = "dsrApi",
  hubReceiver = "hubReceiver",
  meLinkAppApi = "meLinkAppApi",
  ocpp = "ocpp",
  openapi = "openapi",
  other = "other",
  phoenix = "phoenix",
  trpcAppApi = "trpcAppApi",
}

export type CommandParameters = {
  __typename?: "CommandParameters";
  authPin: Maybe<AuthPinConfig>;
  batteryDischargeEnabled: Maybe<Scalars["Boolean"]["output"]>;
  boostTimer: Maybe<BoostTimerCommandParams>;
  dsrSetFrequency: Maybe<DsrSetFrequencyCommandParams>;
  dsrSetLoad: Maybe<DsrSetLoadCommandParams>;
  eddiBoostBoostOn: Maybe<Scalars["Float"]["output"]>;
  eddiBoostDurationMinutes: Maybe<Scalars["Float"]["output"]>;
  eddiBoostHeaterNo: Maybe<Scalars["Float"]["output"]>;
  eddiConfig: Maybe<EddiEditableConfig>;
  eddiModeModeNo: Maybe<Scalars["Float"]["output"]>;
  eddiPlusConfig: Maybe<EddiPlusEditableConfig>;
  g100ResetType: Maybe<G100ResetType>;
  heaterPriorityCheckPeriodMinutes: Maybe<Scalars["Float"]["output"]>;
  heaterPriorityHeaterNo: Maybe<Scalars["Float"]["output"]>;
  libbiConfig: Maybe<LibbiEditableConfig>;
  libbiModeModeNo: Maybe<Scalars["Float"]["output"]>;
  lockFunction: Maybe<Scalars["Float"]["output"]>;
  minGreenLevel: Maybe<Scalars["Float"]["output"]>;
  newConfigTime: Maybe<Scalars["Float"]["output"]>;
  ocpp: Maybe<OcppConfig>;
  pinValue: Maybe<Scalars["Float"]["output"]>;
  readChargeSlotId: Maybe<Scalars["Float"]["output"]>;
  rebootTimer: Maybe<Scalars["Float"]["output"]>;
  setMode: Maybe<Scalars["String"]["output"]>;
  setPriority: Maybe<Scalars["Float"]["output"]>;
  writeChargeSlot: Maybe<ChargeSlot>;
  zappi2Config: Maybe<Zappi2EditableConfig>;
  zappiModeControlBits: Maybe<Scalars["Float"]["output"]>;
  zappiModeKWh: Maybe<Scalars["Float"]["output"]>;
  zappiModeModeNo: Maybe<Scalars["Float"]["output"]>;
  zappiModeTargetHour: Maybe<Scalars["Float"]["output"]>;
  zappiModeTargetMinute: Maybe<Scalars["Float"]["output"]>;
};

/** State of command execution */
export enum CommandState {
  failed = "failed",
  inProgress = "inProgress",
  initial = "initial",
  nw_failed = "nw_failed",
  nw_inProgress = "nw_inProgress",
  nw_initial = "nw_initial",
  nw_success = "nw_success",
  success = "success",
}

/** MeLink commands */
export enum CommandType {
  cancelChargeDelay = "cancelChargeDelay",
  downloadBootloader = "downloadBootloader",
  downloadFirmwareAndInstall = "downloadFirmwareAndInstall",
  dsrSetFrequency = "dsrSetFrequency",
  dsrSetLoad = "dsrSetLoad",
  forceBackgroundDownload = "forceBackgroundDownload",
  forceDownload = "forceDownload",
  forceDownloadLibbiArm = "forceDownloadLibbiArm",
  forceDownloadLibbiBms = "forceDownloadLibbiBms",
  forceDownloadLibbiDsp = "forceDownloadLibbiDsp",
  forceInstallApp = "forceInstallApp",
  forceInstallBootloader = "forceInstallBootloader",
  forceInstallLibbiArm = "forceInstallLibbiArm",
  forceInstallLibbiBms = "forceInstallLibbiBms",
  forceInstallLibbiDsp = "forceInstallLibbiDsp",
  forceReboot = "forceReboot",
  g100Reset = "g100Reset",
  libbiCombinedInverterUpdate = "libbiCombinedInverterUpdate",
  readChargingSlot = "readChargingSlot",
  readConfig = "readConfig",
  readG100Events = "readG100Events",
  readRfidConfig = "readRfidConfig",
  setEddiBoost = "setEddiBoost",
  setLock = "setLock",
  setModeEddi = "setModeEddi",
  setModeLibbi = "setModeLibbi",
  setModeZappi = "setModeZappi",
  setPriority = "setPriority",
  writeChargingSlot = "writeChargingSlot",
  writeCommonZappiConfig = "writeCommonZappiConfig",
  writeConfigSetBatteryDischarge = "writeConfigSetBatteryDischarge",
  writeConfigSetBoostTime = "writeConfigSetBoostTime",
  writeConfigSetEddiBoostTime = "writeConfigSetEddiBoostTime",
  writeConfigSetHeaterPriority = "writeConfigSetHeaterPriority",
  writeConfigSetLibbiBoostTime = "writeConfigSetLibbiBoostTime",
  writeConfigSetMinGreenLevel = "writeConfigSetMinGreenLevel",
  writeConfigSetZappiBoostTime = "writeConfigSetZappiBoostTime",
  writeEddiConfig = "writeEddiConfig",
  writeEddiPlusConfig = "writeEddiPlusConfig",
  writeLibbiConfig = "writeLibbiConfig",
  writeRapidZappiConfig = "writeRapidZappiConfig",
  writeRfidConfig = "writeRfidConfig",
  writeZappi2AuthPinConfig = "writeZappi2AuthPinConfig",
  writeZappi2Config = "writeZappi2Config",
  writeZappi2LiteOcppConfig = "writeZappi2LiteOcppConfig",
  writeZappi2OcppConfig = "writeZappi2OcppConfig",
}

export type ConfigReplyBoostTimer = {
  __typename?: "ConfigReplyBoostTimer";
  duration: Scalars["Int"]["output"];
  economy: Scalars["Boolean"]["output"];
  energyTarget: Maybe<Scalars["Int"]["output"]>;
  fridayOn: Scalars["Boolean"]["output"];
  heaterType: Maybe<EddiBoostTimerHeaterType>;
  id: Scalars["ID"]["output"];
  mode: Maybe<LibbiBoostTimerMode>;
  mondayOn: Scalars["Boolean"]["output"];
  rate: Maybe<Scalars["Int"]["output"]>;
  saturdayOn: Scalars["Boolean"]["output"];
  slot: Scalars["Int"]["output"];
  startHour: Scalars["Int"]["output"];
  startMinute: Scalars["Int"]["output"];
  sundayOn: Scalars["Boolean"]["output"];
  temperature: Maybe<Scalars["Int"]["output"]>;
  thursdayOn: Scalars["Boolean"]["output"];
  tuesdayOn: Scalars["Boolean"]["output"];
  wednesdayOn: Scalars["Boolean"]["output"];
};

export type CreateUserInput = {
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
};

export type CtData = {
  __typename?: "CtData";
  ctNumber: Scalars["Int"]["output"];
  current: Maybe<Scalars["Int"]["output"]>;
  isValid: Maybe<Scalars["Boolean"]["output"]>;
  phase: Maybe<Scalars["String"]["output"]>;
  power: Maybe<Scalars["Int"]["output"]>;
  type: Maybe<Scalars["String"]["output"]>;
};

export type CustomerDetails = {
  __typename?: "CustomerDetails";
  email: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Maybe<Scalars["String"]["output"]>;
};

export type DashBoardInfo = {
  __typename?: "DashBoardInfo";
  activeAppUsers: Scalars["Int"]["output"];
  numberOfEddis: Scalars["Int"]["output"];
  numberOfHarvis: Scalars["Int"]["output"];
  numberOfHubs: Scalars["Int"]["output"];
  numberOfLastWeekEddis: Scalars["Int"]["output"];
  numberOfLastWeekHarvis: Scalars["Int"]["output"];
  numberOfLastWeekHubs: Scalars["Int"]["output"];
  numberOfLastWeekLibbis: Scalars["Int"]["output"];
  numberOfLastWeekZappis: Scalars["Int"]["output"];
  numberOfLibbis: Scalars["Int"]["output"];
  numberOfLiveEddis: Scalars["Int"]["output"];
  numberOfLiveHarvis: Scalars["Int"]["output"];
  numberOfLiveHubs: Scalars["Int"]["output"];
  numberOfLiveLibbis: Scalars["Int"]["output"];
  numberOfLiveZappis: Scalars["Int"]["output"];
  numberOfYesterdayEddis: Scalars["Int"]["output"];
  numberOfYesterdayHarvis: Scalars["Int"]["output"];
  numberOfYesterdayHubs: Scalars["Int"]["output"];
  numberOfYesterdayLibbis: Scalars["Int"]["output"];
  numberOfYesterdayZappis: Scalars["Int"]["output"];
  numberOfZappis: Scalars["Int"]["output"];
};

export enum DateFormat {
  DD_MM_YY = "DD_MM_YY",
  MM_DD_YY = "MM_DD_YY",
  YY_MM_DD = "YY_MM_DD",
}

export enum DefaultMode {
  ECO = "ECO",
  ECO_PLUS = "ECO_PLUS",
  FAST = "FAST",
  PREVIOUS = "PREVIOUS",
  STOP = "STOP",
}

export type DeleteOcppChargingProfileInput = {
  chargingProfileId: Scalars["Int"]["input"];
  deviceSerialNo: Scalars["Int"]["input"];
};

export type DeleteOcppChargingProfileResult = {
  __typename?: "DeleteOcppChargingProfileResult";
  success: Scalars["String"]["output"];
};

export type DeviceChannel = {
  __typename?: "DeviceChannel";
  notes: Maybe<Scalars["String"]["output"]>;
  serialNo: Scalars["Int"]["output"];
  setByEmail: Scalars["String"]["output"];
  uid: Scalars["String"]["output"];
};

export type DeviceChannelsResult = {
  __typename?: "DeviceChannelsResult";
  cursor: Maybe<Scalars["String"]["output"]>;
  results: Array<DeviceChannel>;
};

export type DeviceConnection = {
  __typename?: "DeviceConnection";
  connectionTime: Scalars["String"]["output"];
  disconnectionTime: Maybe<Scalars["String"]["output"]>;
};

export type DeviceError = {
  __typename?: "DeviceError";
  code: Scalars["Float"]["output"];
  firstOccurred: Scalars["String"]["output"];
  lastOccurred: Scalars["String"]["output"];
  /** @deprecated Use `firstOccurred` instead */
  timestamp: Scalars["String"]["output"];
};

/** Device Filter Parameter */
export enum DeviceFilter {
  eddi = "eddi",
  eddiPlus = "eddiPlus",
  harvi = "harvi",
  libbi = "libbi",
  zappi1 = "zappi1",
  zappi2 = "zappi2",
}

export type DeviceInfo = {
  __typename?: "DeviceInfo";
  deviceName: Scalars["String"]["output"];
  productCode: Scalars["String"]["output"];
};

export type DeviceLoad = {
  __typename?: "DeviceLoad";
  serialNo: Scalars["Float"]["output"];
  setLoad: Scalars["Float"]["output"];
};

/** Verbose name of the device */
export enum DeviceName {
  eddi = "eddi",
  eddiPlus = "eddiPlus",
  harvi = "harvi",
  hub = "hub",
  libbi = "libbi",
  rapidZappi = "rapidZappi",
  zappi1 = "zappi1",
  zappi2 = "zappi2",
}

export type DevicePin = {
  __typename?: "DevicePin";
  pin: Maybe<Scalars["String"]["output"]>;
};

export enum DeviceType {
  eddi = "eddi",
  harvi = "harvi",
  hub = "hub",
  libbi = "libbi",
  zappi = "zappi",
}

export type DsrData = {
  __typename?: "DsrData";
  ack: Maybe<Scalars["Boolean"]["output"]>;
  csn: Maybe<Scalars["Int"]["output"]>;
  daf: Maybe<Scalars["Int"]["output"]>;
  ddf: Maybe<Scalars["Int"]["output"]>;
  fda: Maybe<Scalars["Boolean"]["output"]>;
  fde: Maybe<Scalars["Boolean"]["output"]>;
  fdn: Maybe<Scalars["Boolean"]["output"]>;
  fua: Maybe<Scalars["Boolean"]["output"]>;
  fue: Maybe<Scalars["Boolean"]["output"]>;
  fun: Maybe<Scalars["Boolean"]["output"]>;
  lca: Maybe<Scalars["Boolean"]["output"]>;
  lce: Maybe<Scalars["Boolean"]["output"]>;
  load: Maybe<Scalars["Int"]["output"]>;
  seconds: Maybe<Scalars["Int"]["output"]>;
  uaf: Maybe<Scalars["Int"]["output"]>;
  udf: Maybe<Scalars["Int"]["output"]>;
};

export type DsrSetFrequencyCommandParams = {
  __typename?: "DsrSetFrequencyCommandParams";
  /** Turn DOWN Activate Frequency in hundredths of a Hertz. */
  DAF: Scalars["Int"]["output"];
  /** Turn DOWN Deactivate Frequency in hundredths of a Hertz. */
  DDF: Scalars["Int"]["output"];
  /** Turn UP Activate Frequency in hundredths of a Hertz. */
  UAF: Scalars["Int"]["output"];
  /** Turn UP Deactivate Frequency in hundredths of a Hertz. */
  UDF: Scalars["Int"]["output"];
};

export type DsrSetLoadCommandParams = {
  __typename?: "DsrSetLoadCommandParams";
  /** Address of destination devices */
  deviceAddresses: Array<Scalars["Int"]["output"]>;
  /** Time to live in minutes */
  ttl: Scalars["Int"]["output"];
  /** The load to be set in Watts or MIN, MAX, NODSR keyword */
  value: Scalars["SetLoadValue"]["output"];
};

export enum ESenseBoostEnableMode {
  BOOST_1 = "BOOST_1",
  BOOST_1_AND_2 = "BOOST_1_AND_2",
  BOOST_2 = "BOOST_2",
}

export enum ESenseBoostMode {
  ESENSE_1 = "ESENSE_1",
  ESENSE_1_AND_2 = "ESENSE_1_AND_2",
  ESENSE_2 = "ESENSE_2",
}

export enum ESenseHeaterEnableMode {
  HEATER_1 = "HEATER_1",
  HEATER_1_AND_2 = "HEATER_1_AND_2",
  HEATER_2 = "HEATER_2",
}

export enum ESenseInput {
  ESENSE_BOOST = "ESENSE_BOOST",
  ESENSE_BOOST_ENABLED = "ESENSE_BOOST_ENABLED",
  ESENSE_CURTAILMENT = "ESENSE_CURTAILMENT",
  ESENSE_DISABLED = "ESENSE_DISABLED",
  ESENSE_STOP = "ESENSE_STOP",
}

export enum ESenseMode {
  ESENSE_BOOST = "ESENSE_BOOST",
  ESENSE_BOOST_ENABLE = "ESENSE_BOOST_ENABLE",
  ESENSE_DISABLED = "ESENSE_DISABLED",
  ESENSE_HEATER_ENABLE = "ESENSE_HEATER_ENABLE",
  ESENSE_RELAY_CONTROL = "ESENSE_RELAY_CONTROL",
}

export enum ESenseRelayControlMode {
  RELAY_1 = "RELAY_1",
  RELAY_1_AND_2 = "RELAY_1_AND_2",
  RELAY_2 = "RELAY_2",
}

export enum Earthing {
  IT = "IT",
  TTOrTN = "TTOrTN",
}

export enum EarthingArrangement {
  IT = "IT",
  TTOrTN = "TTOrTN",
}

export type Eddi = {
  __typename?: "Eddi";
  boostManual: Maybe<Scalars["Boolean"]["output"]>;
  boostTimed: Maybe<Scalars["Boolean"]["output"]>;
  bootLoaderVersion: Maybe<Scalars["Int"]["output"]>;
  chargeEnergy: Maybe<Scalars["Float"]["output"]>;
  commandSeqNo: Scalars["Int"]["output"];
  configReply: Maybe<EddiConfigReply>;
  createdAt: Scalars["DateTime"]["output"];
  ct1: Maybe<CtData>;
  ct2: Maybe<CtData>;
  ct3: Maybe<CtData>;
  ct4: Maybe<CtData>;
  ct5: Maybe<CtData>;
  ct6: Maybe<CtData>;
  currentBoostRemaining: Maybe<Scalars["Int"]["output"]>;
  currentVersion: Maybe<Scalars["Int"]["output"]>;
  deviceAddressRaw: Scalars["Int"]["output"];
  deviceClass: Scalars["String"]["output"];
  deviceConfigTime: Maybe<Scalars["BigInt"]["output"]>;
  deviceInfo: DeviceInfo;
  deviceInstance: Maybe<Scalars["Int"]["output"]>;
  diverted: Scalars["Int"]["output"];
  dsrData: DsrData;
  ethernetLink: Maybe<Scalars["Boolean"]["output"]>;
  expansionBoardData: ExpansionBoardData;
  frequency: Maybe<Scalars["Int"]["output"]>;
  generatorPower: Maybe<Scalars["Int"]["output"]>;
  gridCTPhase1Fitted: Scalars["Boolean"]["output"];
  gridCTPhase2Fitted: Scalars["Boolean"]["output"];
  gridCTPhase3Fitted: Scalars["Boolean"]["output"];
  gridPower: Maybe<Scalars["Int"]["output"]>;
  heaterNo: Scalars["Int"]["output"];
  heaterType1: Maybe<Scalars["String"]["output"]>;
  heaterType2: Maybe<Scalars["String"]["output"]>;
  highPower: Maybe<Scalars["Boolean"]["output"]>;
  isThreePhase: Scalars["Boolean"]["output"];
  maxPower: Maybe<Scalars["Int"]["output"]>;
  melibVersion: Maybe<Scalars["Int"]["output"]>;
  melinkVersion: Maybe<Scalars["Int"]["output"]>;
  microprocessorTI: Maybe<Scalars["Boolean"]["output"]>;
  minPower: Maybe<Scalars["Int"]["output"]>;
  newAppAvailable: Maybe<Scalars["Boolean"]["output"]>;
  newBootloaderAvailable: Maybe<Scalars["Boolean"]["output"]>;
  phase: Maybe<Scalars["Int"]["output"]>;
  priority: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use deviceInfo.productCode instead */
  productCode: Maybe<Scalars["Int"]["output"]>;
  pt1: Maybe<PtData>;
  pt2: Maybe<PtData>;
  relayBoardData: RelayBoardData;
  serialNo: Scalars["BigInt"]["output"];
  serverConfigTime: Maybe<Scalars["BigInt"]["output"]>;
  state: Maybe<Scalars["String"]["output"]>;
  stubLoaderVersion: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  vHub: Maybe<Scalars["Boolean"]["output"]>;
  voltage: Maybe<Scalars["Int"]["output"]>;
  wifiFirmwareVersion: Maybe<Scalars["Int"]["output"]>;
  wifiLink: Maybe<Scalars["Boolean"]["output"]>;
};

/** EddiBoostTimerHeaterType */
export enum EddiBoostTimerHeaterType {
  heater1 = "heater1",
  heater2 = "heater2",
  relay1 = "relay1",
  relay2 = "relay2",
}

export type EddiConfig = {
  __typename?: "EddiConfig";
  backlight: Scalars["Int"]["output"];
  batteryDischargeEnabled: Scalars["Boolean"]["output"];
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Array<ConfigReplyBoostTimer>;
  contrast: Scalars["Int"]["output"];
  ct1GroupLimit: Scalars["Int"]["output"];
  ct1Subtype: Maybe<CtSubtype>;
  ct1Type: Maybe<CtTypes>;
  ct2GroupLimit: Scalars["Int"]["output"];
  ct2Subtype: Maybe<CtSubtype>;
  ct2Type: Maybe<CtTypes>;
  ct3GroupLimit: Scalars["Int"]["output"];
  ctDetection: Scalars["Boolean"]["output"];
  ctExternal1Group: Scalars["Int"]["output"];
  ctExternal2Group: Scalars["Int"]["output"];
  ctInternal1Group: Scalars["Int"]["output"];
  dateFormat: Maybe<DateFormat>;
  deviceLimit: Scalars["Float"]["output"];
  dstOn: Scalars["Boolean"]["output"];
  esense: EsenseData;
  expRelay1: EddiExpansionRelayData;
  expRelay2: EddiExpansionRelayData;
  exportLimit: Scalars["Int"]["output"];
  exportMargin: Scalars["Int"]["output"];
  gridLimit: Scalars["Int"]["output"];
  heaterPriority: Scalars["Int"]["output"];
  heaterType1: Maybe<EddiHeaterType>;
  heaterType2: Maybe<EddiHeaterType>;
  hotTime: Scalars["Int"]["output"];
  icons: Maybe<GenTypeIconEddi>;
  language: Maybe<Language>;
  masterLostDetection: Scalars["Boolean"]["output"];
  masterLostThreshold: Scalars["Int"]["output"];
  minimumExport: Scalars["Int"]["output"];
  minimumExportTime: Scalars["Int"]["output"];
  neutralLimit: Scalars["Int"]["output"];
  passcode: Scalars["String"]["output"];
  powerLimit: Scalars["Float"]["output"];
  priorityCheckPeriod: Scalars["Int"]["output"];
  timeFromCloud: Scalars["Boolean"]["output"];
  timeZone: Maybe<TimeZone>;
  /** @deprecated Use timeFromCloud instead */
  updateFromCloud: Scalars["Boolean"]["output"];
};

export type EddiConfigPartial = {
  __typename?: "EddiConfigPartial";
  deviceConfigTime: Scalars["BigInt"]["output"];
  g100LockoutState: G100LockoutState;
  id: Scalars["ID"]["output"];
  serverConfigTime: Maybe<Scalars["BigInt"]["output"]>;
};

export type EddiConfigReply = {
  __typename?: "EddiConfigReply";
  eddiConfigReplyData: Maybe<EddiConfigPartial>;
  eddiPlusConfigReplyData: Maybe<EddiPlusConfigPartial>;
  id: Scalars["ID"]["output"];
};

export type EddiEditableBoostTimer = {
  __typename?: "EddiEditableBoostTimer";
  duration: Maybe<Scalars["Float"]["output"]>;
  economy: Maybe<Scalars["Boolean"]["output"]>;
  fridayOn: Maybe<Scalars["Boolean"]["output"]>;
  mondayOn: Maybe<Scalars["Boolean"]["output"]>;
  saturdayOn: Maybe<Scalars["Boolean"]["output"]>;
  slot: Scalars["Int"]["output"];
  startHour: Maybe<Scalars["Float"]["output"]>;
  startMinute: Maybe<Scalars["Float"]["output"]>;
  sundayOn: Maybe<Scalars["Boolean"]["output"]>;
  thursdayOn: Maybe<Scalars["Boolean"]["output"]>;
  tuesdayOn: Maybe<Scalars["Boolean"]["output"]>;
  wednesdayOn: Maybe<Scalars["Boolean"]["output"]>;
};

export type EddiEditableBoostTimerInput = {
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  economy?: InputMaybe<Scalars["Boolean"]["input"]>;
  fridayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  mondayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  saturdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  slot: Scalars["Int"]["input"];
  startHour?: InputMaybe<Scalars["Float"]["input"]>;
  startMinute?: InputMaybe<Scalars["Float"]["input"]>;
  sundayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  thursdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  tuesdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  wednesdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type EddiEditableConfig = {
  __typename?: "EddiEditableConfig";
  backlight: Maybe<Scalars["Int"]["output"]>;
  batteryDischargeEnabled: Maybe<Scalars["Boolean"]["output"]>;
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Maybe<Array<EddiEditableBoostTimer>>;
  contrast: Maybe<Scalars["Int"]["output"]>;
  ct1GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct1Type: Maybe<CtTypes>;
  ct2GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct2Type: Maybe<CtTypes>;
  ct3GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ctDetection: Maybe<Scalars["Boolean"]["output"]>;
  ctExternal1Group: Maybe<Scalars["Int"]["output"]>;
  ctExternal2Group: Maybe<Scalars["Int"]["output"]>;
  ctInternal1Group: Maybe<Scalars["Int"]["output"]>;
  dateFormat: Maybe<DateFormat>;
  deviceLimit: Maybe<Scalars["Float"]["output"]>;
  dstOn: Maybe<Scalars["Boolean"]["output"]>;
  esense: Maybe<EddiEditableEsenseData>;
  expRelay1: Maybe<EddiEditableExpansionRelayData>;
  expRelay2: Maybe<EddiEditableExpansionRelayData>;
  exportLimit: Maybe<Scalars["Int"]["output"]>;
  exportMargin: Maybe<Scalars["Int"]["output"]>;
  gridLimit: Maybe<Scalars["Int"]["output"]>;
  heaterPriority: Maybe<Scalars["Int"]["output"]>;
  heaterType1: Maybe<EddiHeaterType>;
  heaterType2: Maybe<EddiHeaterType>;
  hotTime: Maybe<Scalars["Int"]["output"]>;
  icons: Maybe<GenTypeIconEddi>;
  language: Maybe<Language>;
  masterLostDetection: Maybe<Scalars["Boolean"]["output"]>;
  masterLostThreshold: Maybe<Scalars["Int"]["output"]>;
  minimumExport: Maybe<Scalars["Int"]["output"]>;
  minimumExportTime: Maybe<Scalars["Int"]["output"]>;
  neutralLimit: Maybe<Scalars["Int"]["output"]>;
  passcode: Maybe<Scalars["String"]["output"]>;
  powerLimit: Maybe<Scalars["Int"]["output"]>;
  priorityCheckPeriod: Maybe<Scalars["Int"]["output"]>;
  timeFromCloud: Maybe<Scalars["Boolean"]["output"]>;
  timeZone: Maybe<TimeZone>;
};

export type EddiEditableConfigInput = {
  backlight?: InputMaybe<Scalars["Int"]["input"]>;
  batteryDischargeEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  batteryMode?: InputMaybe<BatteryMode>;
  boostTimers?: InputMaybe<Array<EddiEditableBoostTimerInput>>;
  contrast?: InputMaybe<Scalars["Int"]["input"]>;
  ct1GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct1Type?: InputMaybe<CtTypes>;
  ct2GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct2Type?: InputMaybe<CtTypes>;
  ct3GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ctDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  ctExternal1Group?: InputMaybe<Scalars["Int"]["input"]>;
  ctExternal2Group?: InputMaybe<Scalars["Int"]["input"]>;
  ctInternal1Group?: InputMaybe<Scalars["Int"]["input"]>;
  dateFormat?: InputMaybe<DateFormat>;
  deviceLimit?: InputMaybe<Scalars["Float"]["input"]>;
  dstOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  esense?: InputMaybe<EddiEditableEsenseDataInput>;
  expRelay1?: InputMaybe<EddiEditableExpansionRelayDataInput>;
  expRelay2?: InputMaybe<EddiEditableExpansionRelayDataInput>;
  exportLimit?: InputMaybe<Scalars["Int"]["input"]>;
  exportMargin?: InputMaybe<Scalars["Int"]["input"]>;
  gridLimit?: InputMaybe<Scalars["Int"]["input"]>;
  heaterPriority?: InputMaybe<Scalars["Int"]["input"]>;
  heaterType1?: InputMaybe<EddiHeaterType>;
  heaterType2?: InputMaybe<EddiHeaterType>;
  hotTime?: InputMaybe<Scalars["Int"]["input"]>;
  icons?: InputMaybe<GenTypeIconEddi>;
  language?: InputMaybe<Language>;
  masterLostDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  masterLostThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  minimumExport?: InputMaybe<Scalars["Int"]["input"]>;
  minimumExportTime?: InputMaybe<Scalars["Int"]["input"]>;
  neutralLimit?: InputMaybe<Scalars["Int"]["input"]>;
  passcode?: InputMaybe<Scalars["String"]["input"]>;
  powerLimit?: InputMaybe<Scalars["Int"]["input"]>;
  priorityCheckPeriod?: InputMaybe<Scalars["Int"]["input"]>;
  timeFromCloud?: InputMaybe<Scalars["Boolean"]["input"]>;
  timeZone?: InputMaybe<TimeZone>;
};

export type EddiEditableEsenseData = {
  __typename?: "EddiEditableEsenseData";
  boostEnableMode: Maybe<ESenseBoostEnableMode>;
  boostMode: Maybe<ESenseBoostMode>;
  heaterEnableMode: Maybe<ESenseHeaterEnableMode>;
  hysteresis1: Maybe<Scalars["Int"]["output"]>;
  hysteresis2: Maybe<Scalars["Int"]["output"]>;
  mode: Maybe<ESenseMode>;
  relayControlMode: Maybe<ESenseRelayControlMode>;
  setPoints1: Maybe<Scalars["Int"]["output"]>;
  setPoints2: Maybe<Scalars["Int"]["output"]>;
};

export type EddiEditableEsenseDataInput = {
  boostEnableMode?: InputMaybe<ESenseBoostEnableMode>;
  boostMode?: InputMaybe<ESenseBoostMode>;
  heaterEnableMode?: InputMaybe<ESenseHeaterEnableMode>;
  hysteresis1?: InputMaybe<Scalars["Int"]["input"]>;
  hysteresis2?: InputMaybe<Scalars["Int"]["input"]>;
  mode?: InputMaybe<ESenseMode>;
  relayControlMode?: InputMaybe<ESenseRelayControlMode>;
  setPoints1?: InputMaybe<Scalars["Int"]["input"]>;
  setPoints2?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EddiEditableExpansionRelayData = {
  __typename?: "EddiEditableExpansionRelayData";
  boostType: Maybe<BoostType>;
  heating: Maybe<RelayHeating>;
  includeDiverted: Maybe<Scalars["Boolean"]["output"]>;
  minimumOffTime: Maybe<Scalars["Int"]["output"]>;
  minimumOnTime: Maybe<Scalars["Int"]["output"]>;
  mode: Maybe<RelayMode>;
  offThreshold: Maybe<Scalars["Int"]["output"]>;
  onThreshold: Maybe<Scalars["Int"]["output"]>;
};

export type EddiEditableExpansionRelayDataInput = {
  boostType?: InputMaybe<BoostType>;
  heating?: InputMaybe<RelayHeating>;
  includeDiverted?: InputMaybe<Scalars["Boolean"]["input"]>;
  minimumOffTime?: InputMaybe<Scalars["Int"]["input"]>;
  minimumOnTime?: InputMaybe<Scalars["Int"]["input"]>;
  mode?: InputMaybe<RelayMode>;
  offThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  onThreshold?: InputMaybe<Scalars["Int"]["input"]>;
};

export type EddiExpansionRelayData = {
  __typename?: "EddiExpansionRelayData";
  boostType: BoostType;
  heating: Maybe<RelayHeating>;
  includeDiverted: Scalars["Boolean"]["output"];
  minimumOffTime: Scalars["Int"]["output"];
  minimumOnTime: Scalars["Int"]["output"];
  mode: Maybe<RelayMode>;
  offThreshold: Scalars["Int"]["output"];
  onThreshold: Scalars["Int"]["output"];
};

export enum EddiHeaterType {
  BUFFER = "BUFFER",
  NONE = "NONE",
  POOL = "POOL",
  RADIATOR = "RADIATOR",
  TANK_1 = "TANK_1",
  TANK_2 = "TANK_2",
  UNDERFLOOR = "UNDERFLOOR",
}

export type EddiMonitoringJStatus = {
  __typename?: "EddiMonitoringJStatus";
  batteryDischargeEnabled: Scalars["Boolean"]["output"];
  bsm: Maybe<Scalars["Int"]["output"]>;
  bst: Maybe<Scalars["Int"]["output"]>;
  dat: Scalars["String"]["output"];
  deviceClass: Scalars["String"]["output"];
  div: Maybe<Scalars["Int"]["output"]>;
  dst: Maybe<Scalars["Int"]["output"]>;
  ect1p: Maybe<Scalars["Int"]["output"]>;
  ect2p: Maybe<Scalars["Int"]["output"]>;
  ect3p: Maybe<Scalars["Int"]["output"]>;
  ectp1: Maybe<Scalars["Int"]["output"]>;
  ectp2: Maybe<Scalars["Int"]["output"]>;
  ectp3: Maybe<Scalars["Int"]["output"]>;
  ectp4: Maybe<Scalars["Int"]["output"]>;
  ectp5: Maybe<Scalars["Int"]["output"]>;
  ectp6: Maybe<Scalars["Int"]["output"]>;
  ectt1: Maybe<Scalars["String"]["output"]>;
  ectt2: Maybe<Scalars["String"]["output"]>;
  ectt3: Maybe<Scalars["String"]["output"]>;
  ectt4: Maybe<Scalars["String"]["output"]>;
  ectt5: Maybe<Scalars["String"]["output"]>;
  ectt6: Maybe<Scalars["String"]["output"]>;
  frq: Maybe<Scalars["Float"]["output"]>;
  g100LockoutState: G100LockoutState;
  gen: Maybe<Scalars["Int"]["output"]>;
  grd: Maybe<Scalars["Int"]["output"]>;
  hno: Maybe<Scalars["Int"]["output"]>;
  hpri: Maybe<Scalars["Int"]["output"]>;
  ht1: Maybe<Scalars["String"]["output"]>;
  ht2: Maybe<Scalars["String"]["output"]>;
  pha: Maybe<Scalars["Int"]["output"]>;
  pri: Maybe<Scalars["Int"]["output"]>;
  r1a: Maybe<Scalars["Int"]["output"]>;
  r1b: Maybe<Scalars["Int"]["output"]>;
  r2a: Maybe<Scalars["Int"]["output"]>;
  r2b: Maybe<Scalars["Int"]["output"]>;
  rbc: Maybe<Scalars["Int"]["output"]>;
  rbt: Maybe<Scalars["Int"]["output"]>;
  sno: Scalars["Int"]["output"];
  sta: Maybe<Scalars["Int"]["output"]>;
  tim: Scalars["String"]["output"];
  tp1: Maybe<Scalars["Int"]["output"]>;
  tp2: Maybe<Scalars["Int"]["output"]>;
  tz: Maybe<Scalars["Int"]["output"]>;
  vol: Maybe<Scalars["Int"]["output"]>;
};

export type EddiPlusConfig = {
  __typename?: "EddiPlusConfig";
  backlight: Scalars["Int"]["output"];
  batteryDischargeEnabled: Scalars["Boolean"]["output"];
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Array<ConfigReplyBoostTimer>;
  contrast: Scalars["Int"]["output"];
  ct1GroupLimit: Scalars["Int"]["output"];
  ct1Subtype: Maybe<CtSubtype>;
  ct1Type: Maybe<CtTypes>;
  ct2GroupLimit: Scalars["Int"]["output"];
  ct2Subtype: Maybe<CtSubtype>;
  ct2Type: Maybe<CtTypes>;
  ct3GroupLimit: Scalars["Int"]["output"];
  ct3Subtype: Maybe<CtSubtype>;
  ct3Type: Maybe<CtTypes>;
  ct4GroupLimit: Scalars["Int"]["output"];
  ctDetection: Scalars["Boolean"]["output"];
  ctExternal1Group: Scalars["Int"]["output"];
  ctExternal2Group: Scalars["Int"]["output"];
  ctExternal3Group: Scalars["Int"]["output"];
  ctInternal1Group: Scalars["Int"]["output"];
  ctInternal2Group: Scalars["Int"]["output"];
  ctInternal3Group: Scalars["Int"]["output"];
  dateFormat: Maybe<DateFormat>;
  deviceLimit: Scalars["Float"]["output"];
  dstOn: Scalars["Boolean"]["output"];
  esense: EsenseData;
  expRelay1: EddiExpansionRelayData;
  expRelay2: EddiExpansionRelayData;
  exportLimit: Scalars["Int"]["output"];
  exportMargin: Scalars["Int"]["output"];
  genPt1TempLimit: Scalars["Int"]["output"];
  genPt2TempLimit: Scalars["Int"]["output"];
  gridLimit: Scalars["Int"]["output"];
  heatPumpSize: Scalars["Int"]["output"];
  heaterPriority: Scalars["Int"]["output"];
  heaterType1: Maybe<EddiHeaterType>;
  heaterType2: Maybe<EddiHeaterType>;
  heatersAvailableCount: Scalars["Int"]["output"];
  hotTime: Scalars["Int"]["output"];
  icons: Maybe<GenTypeIconEddi>;
  language: Maybe<Language>;
  masterLostDetection: Scalars["Boolean"]["output"];
  masterLostThreshold: Scalars["Int"]["output"];
  minimumExport: Scalars["Int"]["output"];
  minimumExportTime: Scalars["Int"]["output"];
  neutralLimit: Scalars["Int"]["output"];
  passcode: Scalars["String"]["output"];
  powerLimit: Scalars["Float"]["output"];
  priorityCheckPeriod: Scalars["Int"]["output"];
  relayBoardPreset: RelayBoardPreset;
  timeFromCloud: Scalars["Boolean"]["output"];
  timeZone: Maybe<TimeZone>;
  /** @deprecated Use timeFromCloud instead */
  updateFromCloud: Scalars["Boolean"]["output"];
};

export type EddiPlusConfigPartial = {
  __typename?: "EddiPlusConfigPartial";
  deviceConfigTime: Scalars["BigInt"]["output"];
  g100LockoutState: G100LockoutState;
  heatersAvailableCount: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  serverConfigTime: Maybe<Scalars["BigInt"]["output"]>;
};

export type EddiPlusEditableConfig = {
  __typename?: "EddiPlusEditableConfig";
  backlight: Maybe<Scalars["Int"]["output"]>;
  batteryDischargeEnabled: Maybe<Scalars["Boolean"]["output"]>;
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Maybe<Array<EddiEditableBoostTimer>>;
  contrast: Maybe<Scalars["Int"]["output"]>;
  ct1GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct1Type: Maybe<CtTypes>;
  ct2GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct2Type: Maybe<CtTypes>;
  ct3GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct3Type: Maybe<CtTypes>;
  ct4GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ctDetection: Maybe<Scalars["Boolean"]["output"]>;
  ctExternal1Group: Maybe<Scalars["Int"]["output"]>;
  ctExternal2Group: Maybe<Scalars["Int"]["output"]>;
  ctExternal3Group: Maybe<Scalars["Int"]["output"]>;
  ctInternal1Group: Maybe<Scalars["Int"]["output"]>;
  ctInternal2Group: Maybe<Scalars["Int"]["output"]>;
  ctInternal3Group: Maybe<Scalars["Int"]["output"]>;
  dateFormat: Maybe<DateFormat>;
  deviceLimit: Maybe<Scalars["Float"]["output"]>;
  dstOn: Maybe<Scalars["Boolean"]["output"]>;
  esense: Maybe<EddiEditableEsenseData>;
  expRelay1: Maybe<EddiEditableExpansionRelayData>;
  expRelay2: Maybe<EddiEditableExpansionRelayData>;
  exportLimit: Maybe<Scalars["Int"]["output"]>;
  exportMargin: Maybe<Scalars["Int"]["output"]>;
  genPt1TempLimit: Maybe<Scalars["Int"]["output"]>;
  genPt2TempLimit: Maybe<Scalars["Int"]["output"]>;
  gridLimit: Maybe<Scalars["Int"]["output"]>;
  heatPumpSize: Maybe<Scalars["Int"]["output"]>;
  heaterPriority: Maybe<Scalars["Int"]["output"]>;
  heaterType1: Maybe<EddiHeaterType>;
  heaterType2: Maybe<EddiHeaterType>;
  hotTime: Maybe<Scalars["Int"]["output"]>;
  icons: Maybe<GenTypeIconEddi>;
  language: Maybe<Language>;
  masterLostDetection: Maybe<Scalars["Boolean"]["output"]>;
  masterLostThreshold: Maybe<Scalars["Int"]["output"]>;
  minimumExport: Maybe<Scalars["Int"]["output"]>;
  minimumExportTime: Maybe<Scalars["Int"]["output"]>;
  neutralLimit: Maybe<Scalars["Int"]["output"]>;
  passcode: Maybe<Scalars["String"]["output"]>;
  powerLimit: Maybe<Scalars["Int"]["output"]>;
  priorityCheckPeriod: Maybe<Scalars["Int"]["output"]>;
  relayBoardPreset: Maybe<RelayBoardPreset>;
  timeFromCloud: Maybe<Scalars["Boolean"]["output"]>;
  timeZone: Maybe<TimeZone>;
};

export type EddiPlusEditableConfigInput = {
  backlight?: InputMaybe<Scalars["Int"]["input"]>;
  batteryDischargeEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  batteryMode?: InputMaybe<BatteryMode>;
  boostTimers?: InputMaybe<Array<EddiEditableBoostTimerInput>>;
  contrast?: InputMaybe<Scalars["Int"]["input"]>;
  ct1GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct1Type?: InputMaybe<CtTypes>;
  ct2GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct2Type?: InputMaybe<CtTypes>;
  ct3GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct3Type?: InputMaybe<CtTypes>;
  ct4GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ctDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  ctExternal1Group?: InputMaybe<Scalars["Int"]["input"]>;
  ctExternal2Group?: InputMaybe<Scalars["Int"]["input"]>;
  ctExternal3Group?: InputMaybe<Scalars["Int"]["input"]>;
  ctInternal1Group?: InputMaybe<Scalars["Int"]["input"]>;
  ctInternal2Group?: InputMaybe<Scalars["Int"]["input"]>;
  ctInternal3Group?: InputMaybe<Scalars["Int"]["input"]>;
  dateFormat?: InputMaybe<DateFormat>;
  deviceLimit?: InputMaybe<Scalars["Float"]["input"]>;
  dstOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  esense?: InputMaybe<EddiEditableEsenseDataInput>;
  expRelay1?: InputMaybe<EddiEditableExpansionRelayDataInput>;
  expRelay2?: InputMaybe<EddiEditableExpansionRelayDataInput>;
  exportLimit?: InputMaybe<Scalars["Int"]["input"]>;
  exportMargin?: InputMaybe<Scalars["Int"]["input"]>;
  genPt1TempLimit?: InputMaybe<Scalars["Int"]["input"]>;
  genPt2TempLimit?: InputMaybe<Scalars["Int"]["input"]>;
  gridLimit?: InputMaybe<Scalars["Int"]["input"]>;
  heatPumpSize?: InputMaybe<Scalars["Int"]["input"]>;
  heaterPriority?: InputMaybe<Scalars["Int"]["input"]>;
  heaterType1?: InputMaybe<EddiHeaterType>;
  heaterType2?: InputMaybe<EddiHeaterType>;
  hotTime?: InputMaybe<Scalars["Int"]["input"]>;
  icons?: InputMaybe<GenTypeIconEddi>;
  language?: InputMaybe<Language>;
  masterLostDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  masterLostThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  minimumExport?: InputMaybe<Scalars["Int"]["input"]>;
  minimumExportTime?: InputMaybe<Scalars["Int"]["input"]>;
  neutralLimit?: InputMaybe<Scalars["Int"]["input"]>;
  passcode?: InputMaybe<Scalars["String"]["input"]>;
  powerLimit?: InputMaybe<Scalars["Int"]["input"]>;
  priorityCheckPeriod?: InputMaybe<Scalars["Int"]["input"]>;
  relayBoardPreset?: InputMaybe<RelayBoardPreset>;
  timeFromCloud?: InputMaybe<Scalars["Boolean"]["input"]>;
  timeZone?: InputMaybe<TimeZone>;
};

export enum EddiVariant {
  PLUS = "PLUS",
  STANDARD = "STANDARD",
}

export type EndFirmwareReleaseInput = {
  channel: Scalars["String"]["input"];
  upc: Scalars["String"]["input"];
};

export type EsenseData = {
  __typename?: "EsenseData";
  boostEnableMode: Maybe<ESenseBoostEnableMode>;
  boostMode: Maybe<ESenseBoostMode>;
  heaterEnableMode: Maybe<ESenseHeaterEnableMode>;
  hysteresis1: Scalars["Int"]["output"];
  hysteresis2: Scalars["Int"]["output"];
  mode: Maybe<ESenseMode>;
  relayControlMode: Maybe<ESenseRelayControlMode>;
  setPoints1: Scalars["Int"]["output"];
  setPoints2: Scalars["Int"]["output"];
};

export type ExecutionContextId = {
  __typename?: "ExecutionContextId";
  client: Maybe<Client>;
  commandId: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Float"]["output"]>;
};

export type ExistingDevice = {
  __typename?: "ExistingDevice";
  hubDeviceSerialNumber: Maybe<Scalars["String"]["output"]>;
  hubDeviceType: Maybe<DeviceType>;
  isPaired: Maybe<Scalars["Boolean"]["output"]>;
  masterDeviceSerialNumber: Maybe<Scalars["String"]["output"]>;
  masterDeviceType: Maybe<DeviceType>;
};

export type ExpansionBoardData = {
  __typename?: "ExpansionBoardData";
  boardType: Maybe<Scalars["String"]["output"]>;
  ethernetFitted: Maybe<Scalars["Boolean"]["output"]>;
  ethernetMacAddress: Maybe<Scalars["String"]["output"]>;
  ethernetSpeed: Maybe<Scalars["String"]["output"]>;
};

export type ExponentialRolloutRate = {
  baseRatePerMinute: Scalars["Int"]["input"];
  incrementFactor: Scalars["Float"]["input"];
  rateIncreaseCriteria: RateIncreaseCriteria;
};

export type FilterOptions = {
  deviceFilters?: InputMaybe<Array<DeviceFilter>>;
  hubFilters?: InputMaybe<Array<HubFilter>>;
};

export type FindHubRowEddi = {
  __typename?: "FindHubRowEddi";
  serialNo: Scalars["BigInt"]["output"];
  variant: EddiVariant;
};

export type FindHubRowGql = {
  __typename?: "FindHubRowGql";
  currentVersion: Maybe<Scalars["Int"]["output"]>;
  eddis: Array<FindHubRowEddi>;
  harvis: Array<FindHubRowHarvi>;
  isBlocked: Scalars["Boolean"]["output"];
  libbis: Array<FindHubRowLibbi>;
  productCode: Scalars["String"]["output"];
  registered: Scalars["Boolean"]["output"];
  serialNo: Scalars["BigInt"]["output"];
  zappis: Array<FindHubRowZappi>;
};

export type FindHubRowHarvi = {
  __typename?: "FindHubRowHarvi";
  serialNo: Scalars["BigInt"]["output"];
};

export type FindHubRowLibbi = {
  __typename?: "FindHubRowLibbi";
  serialNo: Scalars["BigInt"]["output"];
};

export type FindHubRowZappi = {
  __typename?: "FindHubRowZappi";
  serialNo: Scalars["BigInt"]["output"];
  variant: ZappiVariant;
};

export type FirmwareFile = {
  __typename?: "FirmwareFile";
  approval: Approval;
  createdAt: Scalars["String"]["output"];
  fileMd5: Scalars["String"]["output"];
  fileName: Scalars["String"]["output"];
  releaseNotes: Maybe<Scalars["String"]["output"]>;
  sizeBytes: Scalars["Int"]["output"];
  version: Scalars["String"]["output"];
};

export type FirmwareFileApprovalHistory = {
  __typename?: "FirmwareFileApprovalHistory";
  date: Scalars["String"]["output"];
  reason: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  userEmail: Scalars["String"]["output"];
};

export type FirmwareFilesResult = {
  __typename?: "FirmwareFilesResult";
  cursor: Maybe<Scalars["String"]["output"]>;
  results: Array<FirmwareFile>;
};

export type FrequencyResponse = {
  __typename?: "FrequencyResponse";
  DAF: Scalars["Int"]["output"];
  DDF: Scalars["Int"]["output"];
  UAF: Scalars["Int"]["output"];
  UDF: Scalars["Int"]["output"];
};

export type G100Event = {
  __typename?: "G100Event";
  time: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type G100EventCounter = {
  __typename?: "G100EventCounter";
  type: Scalars["String"]["output"];
  value: Scalars["Int"]["output"];
};

export type G100Events = {
  __typename?: "G100Events";
  eventCounters: Array<G100EventCounter>;
  events: Array<G100Event>;
};

export enum G100LockoutState {
  LOCAL = "LOCAL",
  MANUFACTURER = "MANUFACTURER",
  NONE = "NONE",
}

export enum G100ResetType {
  Local = "Local",
  Manufacturer = "Manufacturer",
}

export enum GenTypeIconEddi {
  NONE = "NONE",
  PV = "PV",
  WIND = "WIND",
}

export enum GenTypeIconLibbi {
  PV = "PV",
  WIND = "WIND",
}

export enum GenTypeIconZappi {
  PV = "PV",
  WIND = "WIND",
}

export type GetProductsFirmwareVersionsResult = {
  __typename?: "GetProductsFirmwareVersionsResult";
  results: Array<Scalars["JSON"]["output"]>;
};

export enum GridSubdivisionCountryCode {
  GB = "GB",
  NI = "NI",
}

export type Harvi = {
  __typename?: "Harvi";
  createdAt: Scalars["DateTime"]["output"];
  ct1: Maybe<CtData>;
  ct2: Maybe<CtData>;
  ct3: Maybe<CtData>;
  ct4: Maybe<CtData>;
  ct5: Maybe<CtData>;
  ct6: Maybe<CtData>;
  currentVersion: Maybe<Scalars["Int"]["output"]>;
  deviceClass: Scalars["String"]["output"];
  deviceInfo: DeviceInfo;
  serialNo: Scalars["BigInt"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type History = {
  __typename?: "History";
  historyJson: Scalars["String"]["output"];
};

export enum HistoryEnergyUnit {
  both = "both",
  energy = "energy",
  power = "power",
}

export enum HistoryResolution {
  halfHour = "halfHour",
  hour = "hour",
  minute = "minute",
}

export type Hub = {
  __typename?: "Hub";
  appPassword: Maybe<Scalars["String"]["output"]>;
  australia: Scalars["Boolean"]["output"];
  blockedReason: Maybe<Scalars["String"]["output"]>;
  cloudIPOverrideServer: Maybe<Server>;
  commandSeqNo: Scalars["Int"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  currentVersion: Maybe<Scalars["Int"]["output"]>;
  deviceClass: Scalars["String"]["output"];
  deviceInfo: DeviceInfo;
  eddis: Array<Eddi>;
  encrypted: Scalars["Boolean"]["output"];
  frequencyResponse: FrequencyResponse;
  harvis: Array<Harvi>;
  hasBeenConnected: Scalars["Boolean"]["output"];
  hubFirmwareVersions: Maybe<Array<HubFirmwareVersions>>;
  iPAddress: Maybe<Scalars["String"]["output"]>;
  isBlocked: Scalars["Boolean"]["output"];
  keyValueStore: Maybe<Scalars["JSON"]["output"]>;
  lastAuth: Maybe<Scalars["DateTime"]["output"]>;
  libbis: Array<Libbi>;
  loadControl: LoadControl;
  masterDeviceClass: Maybe<Scalars["String"]["output"]>;
  masterDeviceRawAddress: Maybe<Scalars["Int"]["output"]>;
  microprocessorTI: Maybe<Scalars["Boolean"]["output"]>;
  networkId: Scalars["Int"]["output"];
  noDevices: Maybe<Scalars["Int"]["output"]>;
  port: Scalars["Int"]["output"];
  radioChannel: Maybe<Scalars["Int"]["output"]>;
  regPassword: Scalars["String"]["output"];
  registrationDate: Maybe<Scalars["DateTime"]["output"]>;
  serialNo: Scalars["BigInt"]["output"];
  serverLastHeard: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  uptime: Maybe<Scalars["Int"]["output"]>;
  vHub: Maybe<Scalars["Boolean"]["output"]>;
  zappis: Array<Zappi>;
};

/** Hub Filter Parameter */
export enum HubFilter {
  aggregator = "aggregator",
  beta = "beta",
  blocked = "blocked",
  firmwareUpToDate = "firmwareUpToDate",
  notRegistered = "notRegistered",
  oldFirmware = "oldFirmware",
  registered = "registered",
}

export type HubFirmwareVersions = {
  __typename?: "HubFirmwareVersions";
  optionCode: Scalars["Float"]["output"];
  productCode: Scalars["Float"]["output"];
  productName: Scalars["String"]["output"];
  versionCode: Scalars["Float"]["output"];
};

export type InitialCommandsDeletionResult = {
  __typename?: "InitialCommandsDeletionResult";
  deletedFromPostgresCount: Scalars["Int"]["output"];
  deletedFromRedisCount: Scalars["Int"]["output"];
};

export type Installation = {
  __typename?: "Installation";
  installationDetails: Maybe<InstallationDetails>;
  installer: Maybe<Installer>;
  otherSettings: Maybe<OtherSettings>;
  supplyAndLimits: Maybe<SupplyAndLimits>;
};

export type InstallationDetails = {
  __typename?: "InstallationDetails";
  address: Maybe<Address>;
  customerDetails: Maybe<CustomerDetails>;
  devicePin: Maybe<DevicePin>;
  existingDevice: Maybe<ExistingDevice>;
  isComplete: Maybe<Scalars["Boolean"]["output"]>;
  renewableEnergy: Maybe<RenewableEnergy>;
};

export type Installer = {
  __typename?: "Installer";
  acceptedPrivacyOn: Maybe<Scalars["String"]["output"]>;
  acceptedTermsOn: Maybe<Scalars["String"]["output"]>;
  appVersion: Maybe<Scalars["String"]["output"]>;
  createdOn: Maybe<Scalars["String"]["output"]>;
  email: Maybe<Scalars["String"]["output"]>;
  firstName: Maybe<Scalars["String"]["output"]>;
  lastName: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  verifiedPhoneNumber: Maybe<Scalars["String"]["output"]>;
};

export enum InstallerWizardState {
  INV_REBOOT_COMPLETE = "INV_REBOOT_COMPLETE",
  READY_FOR_INV_REBOOT = "READY_FOR_INV_REBOOT",
  STARTUP = "STARTUP",
}

export type IntegratorDataGql = {
  __typename?: "IntegratorDataGql";
  integratorId: Scalars["String"]["output"];
  integratorName: Scalars["String"]["output"];
};

export type IntegratorsGql = {
  __typename?: "IntegratorsGql";
  integratorData: IntegratorDataGql;
  webhooks: Array<WebhookGql>;
};

export enum InverterFirmwareUpgradeStatus {
  ARM_IN_PROGRESS = "ARM_IN_PROGRESS",
  DSP_IN_PROGRESS = "DSP_IN_PROGRESS",
  NOT_IN_PROGRESS = "NOT_IN_PROGRESS",
}

export enum InverterFwInstallType {
  ARM = "ARM",
  BMS = "BMS",
  DSP = "DSP",
  NONE = "NONE",
}

export type JobRolloutConfig = {
  exponentialRate?: InputMaybe<ExponentialRolloutRate>;
  maximumPerMinute: Scalars["Int"]["input"];
};

export enum Language {
  de = "de",
  en = "en",
  fr = "fr",
  nl = "nl",
  sv = "sv",
}

export type Libbi = {
  __typename?: "Libbi";
  armVersion: Maybe<Scalars["Int"]["output"]>;
  backupEnabled: Scalars["Boolean"]["output"];
  batteryDischargingBoost: Scalars["Boolean"]["output"];
  bmsVersion: Maybe<BmsVersion>;
  bootLoaderVersion: Maybe<Scalars["Int"]["output"]>;
  chargeAmount: Scalars["Float"]["output"];
  chargeRate: Scalars["Int"]["output"];
  commandSeqNo: Scalars["Int"]["output"];
  configReply: Maybe<LibbiConfigReply>;
  createdAt: Scalars["DateTime"]["output"];
  ct1: Maybe<CtData>;
  ct2: Maybe<CtData>;
  ct3: Maybe<CtData>;
  ct4: Maybe<CtData>;
  ct5: Maybe<CtData>;
  ct6: Maybe<CtData>;
  currentVersion: Maybe<Scalars["Int"]["output"]>;
  deviceAddressRaw: Scalars["Int"]["output"];
  deviceClass: Scalars["String"]["output"];
  deviceConfigTime: Maybe<Scalars["BigInt"]["output"]>;
  deviceInfo: DeviceInfo;
  deviceInstance: Scalars["Int"]["output"];
  dischargeRate: Scalars["Int"]["output"];
  diverted: Scalars["Int"]["output"];
  dspVersion: Maybe<Scalars["Int"]["output"]>;
  ethernetLink: Scalars["Boolean"]["output"];
  frequency: Scalars["Int"]["output"];
  generatorPower: Maybe<Scalars["Int"]["output"]>;
  gridCTPhase1Fitted: Scalars["Boolean"]["output"];
  gridCTPhase2Fitted: Scalars["Boolean"]["output"];
  gridCTPhase3Fitted: Scalars["Boolean"]["output"];
  gridPower: Maybe<Scalars["Int"]["output"]>;
  isSolarPresent: Scalars["Boolean"]["output"];
  libbiMode: Scalars["String"]["output"];
  maxBatteryCapacity: Maybe<Scalars["Int"]["output"]>;
  maxInverterCapacity: Maybe<Scalars["Int"]["output"]>;
  maximumChargingPower: Scalars["Int"]["output"];
  melibVersion: Maybe<Scalars["Int"]["output"]>;
  melinkVersion: Maybe<Scalars["Int"]["output"]>;
  minimumChargingPower: Scalars["Int"]["output"];
  newAppAvailable: Scalars["Boolean"]["output"];
  newBootloaderAvailable: Scalars["Boolean"]["output"];
  normalisedStateOfCharge: Scalars["Float"]["output"];
  phase: Maybe<Scalars["Int"]["output"]>;
  phaseCapability: Scalars["String"]["output"];
  priority: Scalars["Int"]["output"];
  productCode: Maybe<Scalars["Int"]["output"]>;
  pvConnected: Scalars["Boolean"]["output"];
  serialNo: Scalars["BigInt"]["output"];
  state: Scalars["String"]["output"];
  stateOfCharge: Scalars["Float"]["output"];
  statusCode: Scalars["Float"]["output"];
  stubLoaderVersion: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
  vHub: Scalars["Boolean"]["output"];
  voltage: Maybe<Scalars["Int"]["output"]>;
  wifiFirmwareVersion: Maybe<Scalars["Int"]["output"]>;
  wifiLink: Scalars["Boolean"]["output"];
};

export enum LibbiBoostTimerMode {
  BALANCE = "BALANCE",
  CHARGE = "CHARGE",
  DRAIN = "DRAIN",
  STOP = "STOP",
}

export type LibbiConfigPartial = {
  __typename?: "LibbiConfigPartial";
  calibrationChargeComplete: Scalars["Boolean"]["output"];
  g100LockoutState: G100LockoutState;
  id: Scalars["ID"]["output"];
  lastArmVersion: Scalars["Int"]["output"];
  lastBaudRateInstallType: BaudRateInstallType;
  lastDspVersion: Scalars["Int"]["output"];
  lastInverterFwInstallType: InverterFwInstallType;
  wizardState: InstallerWizardState;
};

export type LibbiConfigReply = {
  __typename?: "LibbiConfigReply";
  id: Scalars["ID"]["output"];
  libbiConfigReplyData: Maybe<LibbiConfigPartial>;
};

export type LibbiConfigReplyData = {
  __typename?: "LibbiConfigReplyData";
  backlightOnTime: Scalars["Float"]["output"];
  backupEnable: Scalars["Boolean"]["output"];
  batteryMode: BatteryMode;
  batteryType: BatteryType;
  boostTimers: Array<ConfigReplyBoostTimer>;
  calibrationChargeComplete: Scalars["Boolean"]["output"];
  chargeLimit: Scalars["Float"]["output"];
  chargeModePowerUp: ChargeModePowerUp;
  commsDeviceId: Scalars["Float"]["output"];
  contrastLevel: Scalars["Float"]["output"];
  countryCode: LibbiCountryCode;
  /** @deprecated  Use `ctInternal1Group` instead */
  ct1Group: Scalars["Int"]["output"];
  ct1GroupLimit: Scalars["Float"]["output"];
  ct1Subtype: CtSubtype;
  ct1Type: CtTypes;
  /** @deprecated  Use `ctExternal1Group` instead */
  ct2Group: Scalars["Int"]["output"];
  ct2GroupLimit: Scalars["Float"]["output"];
  ct2Subtype: CtSubtype;
  ct2Type: CtTypes;
  /** @deprecated  Use `ctExternal2Group` instead */
  ct3Group: Scalars["Int"]["output"];
  ct3GroupLimit: Scalars["Float"]["output"];
  ct3Subtype: CtSubtype;
  ct3Type: CtTypes;
  /** @deprecated  Use `ctExternal3Group` instead */
  ct4Group: Scalars["Int"]["output"];
  ct4GroupLimit: Scalars["Float"]["output"];
  ctDetection: Scalars["Boolean"]["output"];
  ctExternal1Group: Scalars["Int"]["output"];
  ctExternal2Group: Scalars["Int"]["output"];
  ctExternal3Group: Scalars["Int"]["output"];
  ctInternal1Group: Scalars["Int"]["output"];
  ctPrimary: Scalars["Float"]["output"];
  dateFormat: DateFormat;
  deviceConfigTime: Scalars["BigInt"]["output"];
  /** @deprecated Use `chargeLimit` instead */
  deviceLimit: Scalars["Float"]["output"];
  dischargeLimit: Scalars["Float"]["output"];
  drainToDevices: Scalars["Boolean"]["output"];
  dstOn: Scalars["Boolean"]["output"];
  earthing: Earthing;
  exportLimit: Scalars["Float"]["output"];
  exportMargin: Scalars["Float"]["output"];
  g100LockoutState: G100LockoutState;
  genTypeIcon: GenTypeIconLibbi;
  gridLimit: Scalars["Float"]["output"];
  gridSubdivide: GridSubdivisionCountryCode;
  id: Scalars["ID"]["output"];
  internalGenGroup: Scalars["Float"]["output"];
  inverterFirmwareUpgradeStatus: InverterFirmwareUpgradeStatus;
  inverterIP: Scalars["String"]["output"];
  language: LibbiLanguage;
  masterLostDetection: Scalars["Boolean"]["output"];
  masterLostThreshold: Scalars["Float"]["output"];
  maxReserveSoc: Scalars["Float"]["output"];
  minReserveSoc: Scalars["Float"]["output"];
  modbusTimeoutEnabled: Scalars["Boolean"]["output"];
  neutralLimit: Scalars["Float"]["output"];
  passcode: Scalars["String"]["output"];
  phaseReturn: PhaseReturn;
  powerLimit: Scalars["Float"]["output"];
  pvDirectlyConnected: Scalars["Boolean"]["output"];
  pvInputMode: PvMpptInputMode;
  serverConfigTime: Maybe<Scalars["Int"]["output"]>;
  signature: Scalars["BigInt"]["output"];
  threePhaseMonitoring: Scalars["Boolean"]["output"];
  timeFromCloud: Scalars["Boolean"]["output"];
  timeZone: TimeZone;
};

export enum LibbiCountryCode {
  AUS = "AUS",
  AUT = "AUT",
  AU_WA = "AU_WA",
  BANGKOK = "BANGKOK",
  BEL = "BEL",
  BRA = "BRA",
  CHL = "CHL",
  CHN = "CHN",
  DEU = "DEU",
  DNK = "DNK",
  ESP = "ESP",
  FRA = "FRA",
  GBR = "GBR",
  GRC = "GRC",
  HUN = "HUN",
  IRL = "IRL",
  ISR = "ISR",
  ITA = "ITA",
  LOCAL = "LOCAL",
  OTHER = "OTHER",
  POL = "POL",
  SIXTY_HZ = "SIXTY_HZ",
  SWE = "SWE",
  THA = "THA",
  VDE0126 = "VDE0126",
  ZAF = "ZAF",
}

export type LibbiDcPowerRecords = {
  __typename?: "LibbiDcPowerRecords";
  pvPower1: Scalars["Float"]["output"];
};

export type LibbiEditableBoostTimer = {
  __typename?: "LibbiEditableBoostTimer";
  duration: Maybe<Scalars["Float"]["output"]>;
  energyTarget: Maybe<Scalars["Float"]["output"]>;
  fridayOn: Maybe<Scalars["Boolean"]["output"]>;
  mode: Maybe<LibbiBoostTimerMode>;
  mondayOn: Maybe<Scalars["Boolean"]["output"]>;
  rate: Maybe<Scalars["Float"]["output"]>;
  saturdayOn: Maybe<Scalars["Boolean"]["output"]>;
  slot: Scalars["Int"]["output"];
  startHour: Maybe<Scalars["Float"]["output"]>;
  startMinute: Maybe<Scalars["Float"]["output"]>;
  sundayOn: Maybe<Scalars["Boolean"]["output"]>;
  thursdayOn: Maybe<Scalars["Boolean"]["output"]>;
  tuesdayOn: Maybe<Scalars["Boolean"]["output"]>;
  wednesdayOn: Maybe<Scalars["Boolean"]["output"]>;
};

export type LibbiEditableBoostTimerInput = {
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  energyTarget?: InputMaybe<Scalars["Float"]["input"]>;
  fridayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  mode?: InputMaybe<LibbiBoostTimerMode>;
  mondayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  rate?: InputMaybe<Scalars["Float"]["input"]>;
  saturdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  slot: Scalars["Int"]["input"];
  startHour?: InputMaybe<Scalars["Float"]["input"]>;
  startMinute?: InputMaybe<Scalars["Float"]["input"]>;
  sundayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  thursdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  tuesdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  wednesdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type LibbiEditableConfig = {
  __typename?: "LibbiEditableConfig";
  backlightOnTime: Maybe<Scalars["Float"]["output"]>;
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Maybe<Array<LibbiEditableBoostTimer>>;
  chargeLimit: Maybe<Scalars["Float"]["output"]>;
  contrastLevel: Maybe<Scalars["Float"]["output"]>;
  countryCode: Maybe<LibbiCountryCode>;
  ct1GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct1Type: Maybe<CtTypes>;
  ct2GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct2Type: Maybe<CtTypes>;
  ct3GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct3Type: Maybe<CtTypes>;
  ct4GroupLimit: Maybe<Scalars["Float"]["output"]>;
  ctDetection: Maybe<Scalars["Boolean"]["output"]>;
  ctExternal1Group: Maybe<Scalars["Float"]["output"]>;
  ctExternal2Group: Maybe<Scalars["Float"]["output"]>;
  ctExternal3Group: Maybe<Scalars["Float"]["output"]>;
  ctInternal1Group: Maybe<Scalars["Float"]["output"]>;
  ctPrimary: Maybe<Scalars["Float"]["output"]>;
  dateFormat: Maybe<DateFormat>;
  dischargeLimit: Maybe<Scalars["Float"]["output"]>;
  dstOn: Maybe<Scalars["Boolean"]["output"]>;
  earthing: Maybe<Earthing>;
  exportLimit: Maybe<Scalars["Int"]["output"]>;
  exportMargin: Maybe<Scalars["Float"]["output"]>;
  genTypeIcon: Maybe<GenTypeIconLibbi>;
  gridLimit: Maybe<Scalars["Int"]["output"]>;
  gridSubdivide: Maybe<GridSubdivisionCountryCode>;
  language: Maybe<LibbiLanguage>;
  masterLostDetection: Maybe<Scalars["Boolean"]["output"]>;
  masterLostThreshold: Maybe<Scalars["Int"]["output"]>;
  maxReserveSoc: Maybe<Scalars["Float"]["output"]>;
  minReserveSoc: Maybe<Scalars["Float"]["output"]>;
  modbusTimeoutEnabled: Maybe<Scalars["Boolean"]["output"]>;
  neutralLimit: Maybe<Scalars["Int"]["output"]>;
  passcode: Maybe<Scalars["String"]["output"]>;
  phaseReturn: Maybe<PhaseReturn>;
  powerLimit: Maybe<Scalars["Int"]["output"]>;
  pvInputMode: Maybe<PvMpptInputMode>;
  threePhaseMonitoring: Maybe<Scalars["Boolean"]["output"]>;
  timeFromCloud: Maybe<Scalars["Boolean"]["output"]>;
  timeZone: Maybe<TimeZone>;
};

export type LibbiEditableConfigInput = {
  backlightOnTime?: InputMaybe<Scalars["Float"]["input"]>;
  batteryMode?: InputMaybe<BatteryMode>;
  boostTimers?: InputMaybe<Array<LibbiEditableBoostTimerInput>>;
  chargeLimit?: InputMaybe<Scalars["Float"]["input"]>;
  contrastLevel?: InputMaybe<Scalars["Float"]["input"]>;
  countryCode?: InputMaybe<LibbiCountryCode>;
  ct1GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct1Type?: InputMaybe<CtTypes>;
  ct2GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct2Type?: InputMaybe<CtTypes>;
  ct3GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct3Type?: InputMaybe<CtTypes>;
  ct4GroupLimit?: InputMaybe<Scalars["Float"]["input"]>;
  ctDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  ctExternal1Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctExternal2Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctExternal3Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctInternal1Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctPrimary?: InputMaybe<Scalars["Float"]["input"]>;
  dateFormat?: InputMaybe<DateFormat>;
  dischargeLimit?: InputMaybe<Scalars["Float"]["input"]>;
  dstOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  earthing?: InputMaybe<Earthing>;
  exportLimit?: InputMaybe<Scalars["Int"]["input"]>;
  exportMargin?: InputMaybe<Scalars["Float"]["input"]>;
  genTypeIcon?: InputMaybe<GenTypeIconLibbi>;
  gridLimit?: InputMaybe<Scalars["Int"]["input"]>;
  gridSubdivide?: InputMaybe<GridSubdivisionCountryCode>;
  language?: InputMaybe<LibbiLanguage>;
  masterLostDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  masterLostThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  maxReserveSoc?: InputMaybe<Scalars["Float"]["input"]>;
  minReserveSoc?: InputMaybe<Scalars["Float"]["input"]>;
  modbusTimeoutEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  neutralLimit?: InputMaybe<Scalars["Int"]["input"]>;
  passcode?: InputMaybe<Scalars["String"]["input"]>;
  phaseReturn?: InputMaybe<PhaseReturn>;
  powerLimit?: InputMaybe<Scalars["Int"]["input"]>;
  pvInputMode?: InputMaybe<PvMpptInputMode>;
  threePhaseMonitoring?: InputMaybe<Scalars["Boolean"]["input"]>;
  timeFromCloud?: InputMaybe<Scalars["Boolean"]["input"]>;
  timeZone?: InputMaybe<TimeZone>;
};

export type LibbiExternalCtData = {
  __typename?: "LibbiExternalCtData";
  externalCtNegPower1: Maybe<Scalars["Float"]["output"]>;
  externalCtNegPower2: Maybe<Scalars["Float"]["output"]>;
  externalCtNegPower3: Scalars["Float"]["output"];
  externalCtPosPower1: Maybe<Scalars["Float"]["output"]>;
  externalCtPosPower2: Maybe<Scalars["Float"]["output"]>;
  externalCtPosPower3: Scalars["Float"]["output"];
  externalCtType1: Maybe<Scalars["Int"]["output"]>;
  externalCtType2: Maybe<Scalars["Int"]["output"]>;
  externalCtType3: Scalars["Float"]["output"];
};

/** MeLink libbi inverter commands */
export enum LibbiInverterCommandType {
  combinedUpdate = "combinedUpdate",
  forceDownloadLibbiArm = "forceDownloadLibbiArm",
  forceDownloadLibbiBms = "forceDownloadLibbiBms",
  forceDownloadLibbiDsp = "forceDownloadLibbiDsp",
  forceInstallLibbiArm = "forceInstallLibbiArm",
  forceInstallLibbiBms = "forceInstallLibbiBms",
  forceInstallLibbiDsp = "forceInstallLibbiDsp",
}

export type LibbiInverterExportPowerData = {
  __typename?: "LibbiInverterExportPowerData";
  inverterExportPower1: Scalars["Float"]["output"];
  inverterExportPower2: Scalars["Float"]["output"];
  inverterExportPower3: Scalars["Float"]["output"];
};

export type LibbiInverterImportPowerData = {
  __typename?: "LibbiInverterImportPowerData";
  inverterImportPower1: Scalars["Float"]["output"];
  inverterImportPower2: Scalars["Float"]["output"];
  inverterImportPower3: Scalars["Float"]["output"];
};

export enum LibbiLanguage {
  de = "de",
  en = "en",
  es = "es",
  fr = "fr",
  it = "it",
  nl = "nl",
  sv = "sv",
}

export type LibbiMinute = {
  __typename?: "LibbiMinute";
  ambientTemp: Scalars["Float"]["output"];
  batteries: Array<Battery>;
  /** @deprecated Use batteries instead */
  batteryCycles: Array<BatteryCycle>;
  batteryRadiatorTemp: Scalars["Float"]["output"];
  batteryTemp: Scalars["Float"]["output"];
  controllerTemp: Scalars["Float"]["output"];
  dcPowerRecords: LibbiDcPowerRecords;
  exportPower: Scalars["Float"]["output"];
  externalCtData: LibbiExternalCtData;
  frequency: Scalars["Float"]["output"];
  genNegPw: Scalars["Float"]["output"];
  genPosPw: Scalars["Float"]["output"];
  heatFoil1: Maybe<Scalars["Boolean"]["output"]>;
  heatFoil2: Maybe<Scalars["Boolean"]["output"]>;
  heatFoil3: Maybe<Scalars["Boolean"]["output"]>;
  heatFoil4: Maybe<Scalars["Boolean"]["output"]>;
  importPower: Scalars["Float"]["output"];
  inverterExport: LibbiInverterExportPowerData;
  inverterImport: LibbiInverterImportPowerData;
  inverterTemperature: Scalars["Float"]["output"];
  noSeconds: Scalars["Float"]["output"];
  serialNo: Scalars["BigInt"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  voltageData: VoltageData;
};

export type LibbiMonitoringJStatus = {
  __typename?: "LibbiMonitoringJStatus";
  batteryDischargingBoost: Scalars["Boolean"]["output"];
  dat: Scalars["String"]["output"];
  deviceClass: Scalars["String"]["output"];
  div: Scalars["Int"]["output"];
  dst: Maybe<Scalars["Int"]["output"]>;
  ect1p: Maybe<Scalars["Int"]["output"]>;
  ect2p: Maybe<Scalars["Int"]["output"]>;
  ect3p: Maybe<Scalars["Int"]["output"]>;
  ectp1: Maybe<Scalars["Int"]["output"]>;
  ectp2: Maybe<Scalars["Int"]["output"]>;
  ectp3: Maybe<Scalars["Int"]["output"]>;
  ectp4: Maybe<Scalars["Int"]["output"]>;
  ectp5: Maybe<Scalars["Int"]["output"]>;
  ectp6: Maybe<Scalars["Int"]["output"]>;
  ectt1: Maybe<Scalars["String"]["output"]>;
  ectt2: Maybe<Scalars["String"]["output"]>;
  ectt3: Maybe<Scalars["String"]["output"]>;
  ectt4: Maybe<Scalars["String"]["output"]>;
  ectt5: Maybe<Scalars["String"]["output"]>;
  ectt6: Maybe<Scalars["String"]["output"]>;
  frq: Scalars["Float"]["output"];
  g100LockoutState: G100LockoutState;
  gen: Maybe<Scalars["Int"]["output"]>;
  grd: Maybe<Scalars["Int"]["output"]>;
  isp: Scalars["Boolean"]["output"];
  lmo: Scalars["String"]["output"];
  mbc: Maybe<Scalars["Int"]["output"]>;
  mic: Maybe<Scalars["Int"]["output"]>;
  pha: Maybe<Scalars["Int"]["output"]>;
  pri: Scalars["Int"]["output"];
  pvDirectlyConnected: Scalars["Boolean"]["output"];
  sno: Scalars["Int"]["output"];
  soc: Scalars["Int"]["output"];
  sta: Scalars["Int"]["output"];
  tim: Scalars["String"]["output"];
  tz: Maybe<Scalars["Int"]["output"]>;
  vol: Maybe<Scalars["Int"]["output"]>;
};

export type LoadControl = {
  __typename?: "LoadControl";
  deviceLoads: Array<DeviceLoad>;
  flags: LoadControlFlags;
  generation: Maybe<Scalars["Int"]["output"]>;
  gridCurrentsHundredthsPhase1: Maybe<Scalars["Int"]["output"]>;
  gridCurrentsHundredthsPhase2: Maybe<Scalars["Int"]["output"]>;
  gridCurrentsHundredthsPhase3: Maybe<Scalars["Int"]["output"]>;
  gridImportExport: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
};

export type LoadControlFlags = {
  __typename?: "LoadControlFlags";
  genCTOnNetwork: Maybe<Scalars["Boolean"]["output"]>;
  gridLimits: Maybe<Scalars["Boolean"]["output"]>;
  gridValid: Maybe<Scalars["Boolean"]["output"]>;
  hubOnNetwork: Maybe<Scalars["Boolean"]["output"]>;
  netPhases: Maybe<Scalars["Boolean"]["output"]>;
};

export type ManageFileApprovalInput = {
  action: Scalars["String"]["input"];
  fileName: Scalars["String"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
  releaseNotes?: InputMaybe<Scalars["String"]["input"]>;
  upc: Scalars["String"]["input"];
};

export type MonitoringConfig = {
  __typename?: "MonitoringConfig";
  active: Scalars["Boolean"]["output"];
  endTime: Scalars["DateTime"]["output"];
  serialNumber: Scalars["Int"]["output"];
  startTime: Scalars["DateTime"]["output"];
};

export type MonitoringJStatus =
  | EddiMonitoringJStatus
  | LibbiMonitoringJStatus
  | ZappiMonitoringJStatus
  | HarviMonitoringJStatus;

export type MqttConnection = {
  __typename?: "MqttConnection";
  connected: Scalars["Boolean"]["output"];
  disconnectReason: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["String"]["output"];
};

export type MqttConnectionResult = {
  __typename?: "MqttConnectionResult";
  cursor: Maybe<Scalars["String"]["output"]>;
  results: Array<MqttConnection>;
};

export type Mutation = {
  __typename?: "Mutation";
  /**
   * Creates 3rd party integrator.
   *   Required permissions: - integratorManagement
   */
  createThirdPartyIntegrator: ThirdPartyClient;
  /**
   * Creates a new user if the given email address does not already exist.
   *
   *   Required permissions:
   *
   *   - userManagement
   */
  createUser: User;
  /**
   *
   *       Delete connection between given device and its hub.
   *
   *       Required permissions:
   *
   *       - deviceDelete
   *
   *       Gives back true, if delete connection was successful
   */
  deleteDevice: Scalars["Boolean"]["output"];
  /**
   * Delete all initial commands for a device from Redis and from command table
   *     Required permissions:
   *     - deleteInitialCommands
   *     Returns an object detailing the number of commands deleted from redis and from postgres.
   *     If an error occurs during deletion the associated count value will be -1, and the error will be logged
   */
  deleteInitialCommands: InitialCommandsDeletionResult;
  /** Ocpp Status for a device */
  deleteOcppChargingProfile: DeleteOcppChargingProfileResult;
  /**
   * Deletes server of given id.
   *
   *   Required permissions:
   *
   *   - manageServers
   */
  deleteServer: Scalars["String"]["output"];
  /**
   * Deletes 3rd party integrator with given id.
   *     Required permissions: - integratorManagement
   */
  deleteThirdPartyIntegrator: ThirdPartyDeleteResponse;
  /**
   * Deletes user of given id.
   *
   *   Required permissions:
   *
   *   - userManagement
   *
   *       AND
   *
   *   - querier has different id than the input id
   */
  deleteUser: Scalars["String"]["output"];
  /**
   * Download the latest Bootloader
   *     Required permissions:
   *     - downloadBootloader
   *     Returns true if the command was initialised.
   */
  downloadBootloader: Scalars["Boolean"]["output"];
  endFirmwareRelease: Scalars["String"]["output"];
  /**
   * Forces a background download check to start immediately
   *     Required permissions:
   *     - forceBackgroundDownload
   *     Returns true if the command was initialised.
   *
   */
  forceBackgroundDownload: Scalars["Boolean"]["output"];
  /**
   * Force reading a device config.
   *
   *   Required permissions:
   *
   *   - deviceConfigEdit
   */
  forceConfigRead: Scalars["Boolean"]["output"];
  /**
   * Forces a installation of app start immediately
   *     Required permissions:
   *     - forceInstallApp
   *     Returns true if the command was initialised.
   *
   */
  forceInstallApp: Scalars["Boolean"]["output"];
  /**
   * Force Reboot the device
   *     Required permissions:
   *     - forceReboot
   *     Returns true if the command was initialised.
   */
  forceReboot: Scalars["Boolean"]["output"];
  /**
   * Perform a G100 reset for a device
   *     Required permissions:
   *     - g100Reset
   *     Returns true if the command was initialised.
   *
   */
  g100Reset: Scalars["Boolean"]["output"];
  /**
   * Sets appPassword and registrationDate to NULL.
   *
   *   Required permissions:
   *
   *   - hubDeregister
   */
  hubDeregister: Scalars["Boolean"]["output"];
  /**
   * Install the Bootloader on flash
   *     Required permissions:
   *     - forceInstallBootloader
   *     Returns true if the command was initialised.
   */
  installBootloader: Scalars["Boolean"]["output"];
  manageFileApproval: Scalars["Boolean"]["output"];
  /**
   * Endpoint for selecting the default alternate servers. (Default A and B servers.) Return true if successful.
   *
   *   Required permissions:
   *
   *   - manageServers
   */
  mutateAlternateServers: Scalars["Boolean"]["output"];
  /**
   * Changes hub settings of given id.
   *
   *   Required permissions:
   *
   *   - deviceBlock
   *
   *   Gives back true or false signalling the success of the mutation
   */
  mutateHub: Scalars["Boolean"]["output"];
  /**
   * Mutates the permissions for a given user role.
   *
   *   Required permissions:
   *
   *   - userManagement
   */
  mutatePermissions: UserAccess;
  /**
   * Modifies server info for given id
   *
   *   Required permissions:
   *
   *   - manageServers
   */
  mutateServerInfo: Server;
  /**
   * Mutates user data.
   *
   *   Required permissions:
   *
   *   - userManagement
   */
  mutateUser: Scalars["Boolean"]["output"];
  /**
   * Requests G100 events for a device
   *     Required permissions:
   *     - g100Reset
   *     Returns true if the command was initialised.
   *
   */
  readG100Events: Scalars["Boolean"]["output"];
  /**
   * Rotates/re-generates client-secret for 3rd party integrator with given id.
   *     Required permissions: - integratorManagement
   */
  rotateClientSecret: ThirdPartyRotateSecretResponse;
  setDeviceChannel: Scalars["Boolean"]["output"];
  /**
   *
   *   Set a partial device config.
   *   The included properties will be merged with the existing full config and sent to the device.
   *
   */
  setEddiConfig: SetDeviceConfigResult;
  /**
   *
   *   Set a partial device config.
   *   The included properties will be merged with the existing full config and sent to the device.
   *
   */
  setEddiPlusConfig: SetDeviceConfigResult;
  /**
   * Sets and initialises the libbi combined inverter update command
   *     Required permissions:
   *     - firmwareManagement
   *     Returns true if the command was initialised.
   */
  setLibbiCombinedInverterUpdateCommand: Scalars["Boolean"]["output"];
  /**
   *
   *   Set a partial device config.
   *   The included properties will be merged with the existing full config and sent to the device.
   *
   */
  setLibbiConfig: SetDeviceConfigResult;
  /**
   * Sets and initialises the specified libbi inverter command
   *     Required permissions:
   *     - firmwareManagement
   *     Returns true if the command was initialised.
   */
  setLibbiInverterCommand: Scalars["Boolean"]["output"];
  /**
   * Sets the detailed monitoring config in redis for a hub
   * Required permissions:
   * - hubMonitoring
   */
  setMonitoringConfig: Scalars["String"]["output"];
  /** Update Ocpp Config for a device */
  setOcppConfig: SetOcppConfigResult;
  /**
   *
   *   Set a partial device config.
   *   The included properties will be merged with the existing full config and sent to the device.
   *
   */
  setRapidZappiConfig: SetDeviceConfigResult;
  /**
   *
   *   Set a partial device config.
   *   The included properties will be merged with the existing full config and sent to the device.
   *
   */
  setZappi2Config: SetDeviceConfigResult;
  /**
   * Set the mode of the Zappi.
   *
   *   Required permissions:
   *
   *   - deviceConfigEdit
   */
  setZappiMode: Scalars["Boolean"]["output"];
  startFirmwareRelease: Scalars["String"]["output"];
  /**
   * Updates 3rd party integrator with given id.
   *   Required permissions: - integratorManagement
   */
  updateThirdPartyIntegrator: ThirdPartyUpdateResponse;
};

export type MutationCreateThirdPartyIntegratorArgs = {
  input: ThirdPartyCreateClientInput;
};

export type MutationCreateUserArgs = {
  newUser: CreateUserInput;
};

export type MutationDeleteDeviceArgs = {
  deviceType: DeviceType;
  serialNo: Scalars["Float"]["input"];
};

export type MutationDeleteInitialCommandsArgs = {
  deviceName: DeviceName;
  hubSerialNo: Scalars["Int"]["input"];
  serialNo: Scalars["Int"]["input"];
};

export type MutationDeleteOcppChargingProfileArgs = {
  input: DeleteOcppChargingProfileInput;
};

export type MutationDeleteServerArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteThirdPartyIntegratorArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDeleteUserArgs = {
  id: Scalars["String"]["input"];
};

export type MutationDownloadBootloaderArgs = {
  deviceName: DeviceName;
  serialNo: Scalars["BigInt"]["input"];
};

export type MutationEndFirmwareReleaseArgs = {
  input: EndFirmwareReleaseInput;
};

export type MutationForceBackgroundDownloadArgs = {
  deviceName: DeviceName;
  serialNo: Scalars["BigInt"]["input"];
};

export type MutationForceConfigReadArgs = {
  deviceType: DeviceType;
  serialNo: Scalars["Int"]["input"];
  structureId: Scalars["String"]["input"];
};

export type MutationForceInstallAppArgs = {
  deviceName: DeviceName;
  serialNo: Scalars["BigInt"]["input"];
};

export type MutationForceRebootArgs = {
  deviceName: DeviceName;
  serialNo: Scalars["BigInt"]["input"];
};

export type MutationG100ResetArgs = {
  deviceName: DeviceName;
  resetType: G100ResetType;
  serialNo: Scalars["Float"]["input"];
};

export type MutationHubDeregisterArgs = {
  serialNo: Scalars["BigInt"]["input"];
};

export type MutationInstallBootloaderArgs = {
  deviceName: DeviceName;
  serialNo: Scalars["BigInt"]["input"];
};

export type MutationManageFileApprovalArgs = {
  input: ManageFileApprovalInput;
};

export type MutationMutateAlternateServersArgs = {
  input: ChangeAlternateServersInput;
};

export type MutationMutateHubArgs = {
  updatedHub: UpdatedHubInput;
};

export type MutationMutatePermissionsArgs = {
  input: ChangeRolePermissionsInput;
};

export type MutationMutateServerInfoArgs = {
  input: ChangeServerInput;
};

export type MutationMutateUserArgs = {
  input: ChangeUserInput;
};

export type MutationReadG100EventsArgs = {
  deviceName: DeviceName;
  serialNo: Scalars["Float"]["input"];
};

export type MutationRotateClientSecretArgs = {
  id: Scalars["String"]["input"];
};

export type MutationSetDeviceChannelArgs = {
  input: SetDeviceChannelInput;
};

export type MutationSetEddiConfigArgs = {
  config: EddiEditableConfigInput;
  serialNo: Scalars["Float"]["input"];
};

export type MutationSetEddiPlusConfigArgs = {
  config: EddiPlusEditableConfigInput;
  serialNo: Scalars["Float"]["input"];
};

export type MutationSetLibbiCombinedInverterUpdateCommandArgs = {
  serialNo: Scalars["Float"]["input"];
  updateType: BaudRateInstallType;
};

export type MutationSetLibbiConfigArgs = {
  config: LibbiEditableConfigInput;
  serialNo: Scalars["Float"]["input"];
};

export type MutationSetLibbiInverterCommandArgs = {
  commandType: LibbiInverterCommandType;
  serialNo: Scalars["Float"]["input"];
};

export type MutationSetMonitoringConfigArgs = {
  active: Scalars["Boolean"]["input"];
  extendTimeDays: Scalars["Float"]["input"];
  hubSerial: Scalars["Float"]["input"];
};

export type MutationSetOcppConfigArgs = {
  input: OcppConfigurationInput;
};

export type MutationSetRapidZappiConfigArgs = {
  config: RapidZappiEditableConfigInput;
  serialNo: Scalars["Float"]["input"];
};

export type MutationSetZappi2ConfigArgs = {
  config: Zappi2EditableConfigInput;
  serialNo: Scalars["Float"]["input"];
};

export type MutationSetZappiModeArgs = {
  mode: ZappiModeInput;
  serialNo: Scalars["Float"]["input"];
};

export type MutationStartFirmwareReleaseArgs = {
  input: StartFirmwareReleaseInput;
};

export type MutationUpdateThirdPartyIntegratorArgs = {
  id: Scalars["String"]["input"];
  input: ThirdPartyUpdateClientInput;
};

export type OcppChargingProfile = {
  __typename?: "OcppChargingProfile";
  chargingProfileId: Scalars["Int"]["output"];
  createdAt: Scalars["String"]["output"];
  deviceSerialNo: Scalars["Int"]["output"];
  rawChargingProfile: Scalars["String"]["output"];
  slotIds: Array<Scalars["Int"]["output"]>;
  transactionId: Scalars["Int"]["output"];
  updatedAt: Scalars["String"]["output"];
};

export type OcppConfig = {
  __typename?: "OcppConfig";
  /** Allows charging in free vend (unlocked zappi) when device is offline */
  allowOfflineTxForUnknownId: Scalars["Boolean"]["output"];
  /** Shows app name to user on display */
  appName: Scalars["String"]["output"];
  /** Shows the ID of the charger on the display */
  chargerID: Scalars["String"]["output"];
  /** Shows EVSE Name to user on display */
  chargerName: Scalars["String"]["output"];
  commercialMode: Scalars["Boolean"]["output"];
  /** INT16 Value in 0.001 units 1234 = £1.234 */
  connectionFee: Scalars["Int"]["output"];
  /** Currency string (4 bytes, 3 characters and NULL termination) GBP, EUR, AUD etc */
  currency: Scalars["String"]["output"];
  /** True : Currency is shown after value, False : before value */
  currencyAfterValue: Scalars["Boolean"]["output"];
  /** True : Display Commercial screen 1, False : a display with pricing will be shown */
  freeVendScreen: Scalars["Boolean"]["output"];
  /** Indicates if a payment terminal is available */
  hasPaymentTerminal: Scalars["Boolean"]["output"];
  /** Shows Idle fee if value is greater than 0 */
  idleFee: Scalars["Int"]["output"];
  /** Shows unavailable screen and rejects all charging sessions. Sends status notification of unavailable on initial setting and on each reset. */
  isOperative: Scalars["Boolean"]["output"];
  /** Allows use of whitelist when device is offline even if LocalWhiteListEN is disabled */
  localAuthorizeOffline: Scalars["Boolean"]["output"];
  /** Determines whether the Zappi is allowed to use the whitelist or not (provided it has PINs). */
  localWhiteListEnabled: Scalars["Boolean"]["output"];
  /** Allows the use of master PIN code (from main_config) to access charger menus */
  maintenanceMode: Scalars["Boolean"]["output"];
  /** The interval at which the Zappi sends MeterValue packets. */
  meterValueInterval: Scalars["Int"]["output"];
  /** The Zappi only sends OCPP-specific messages if this flag is enabled. */
  ocppEnabled: Scalars["Boolean"]["output"];
  /** Generates QR code on zappi display for payment */
  paymentURL: Scalars["String"]["output"];
  /** Prices in £0.001 units, 1234 = £1.234 */
  priceMinute: Scalars["Int"]["output"];
  /** Prices in £0.001 units, 1234 = £1.234 */
  pricekWh: Scalars["Int"]["output"];
  /** Shows contact number to user if in fault mode */
  supportContact: Scalars["String"]["output"];
  /** Tariff types for pricing */
  tariffType: Array<Scalars["Int"]["output"]>;
  unlockOnEVSideDisconnect: Scalars["Boolean"]["output"];
};

export type OcppConfiguration = {
  __typename?: "OcppConfiguration";
  AllowOfflineTxForUnknownId: Maybe<Scalars["Boolean"]["output"]>;
  AllowPINCode: Maybe<Scalars["Boolean"]["output"]>;
  AppName: Maybe<Scalars["String"]["output"]>;
  AuthorizationKey: Maybe<Scalars["String"]["output"]>;
  AuthorizeRemoteTxRequests: Maybe<Scalars["Boolean"]["output"]>;
  ChargerID: Maybe<Scalars["String"]["output"]>;
  ChargerName: Maybe<Scalars["String"]["output"]>;
  ClockAlignedDataInterval: Scalars["Int"]["output"];
  CommercialMode: Maybe<Scalars["Boolean"]["output"]>;
  ConnectionFee: Maybe<Scalars["Float"]["output"]>;
  ConnectionTimeOut: Scalars["Int"]["output"];
  ConnectorPhaseRotation: Maybe<Scalars["String"]["output"]>;
  Currency: Maybe<Scalars["String"]["output"]>;
  CurrencyAfterValue: Maybe<Scalars["Boolean"]["output"]>;
  FreeCharging: Scalars["Boolean"]["output"];
  FreeVendScreen: Maybe<Scalars["Boolean"]["output"]>;
  GetConfigurationMaxKeys: Maybe<Scalars["Float"]["output"]>;
  HasPaymentTerminal: Maybe<Scalars["Boolean"]["output"]>;
  HeartbeatInterval: Scalars["Int"]["output"];
  IdleFee: Maybe<Scalars["Float"]["output"]>;
  IsOperative: Maybe<Scalars["Boolean"]["output"]>;
  LocalAuthListEnabled: Scalars["Boolean"]["output"];
  LocalAuthListMaxLength: Scalars["Int"]["output"];
  LocalAuthorizeOffline: Scalars["Boolean"]["output"];
  LocalPreAuthorize: Scalars["Boolean"]["output"];
  MaintenanceMode: Maybe<Scalars["Boolean"]["output"]>;
  MeterValueSampleInterval: Scalars["Int"]["output"];
  MeterValuesAlignedData: Scalars["String"]["output"];
  MeterValuesSampledData: Scalars["String"]["output"];
  NumberOfConnectors: Scalars["Int"]["output"];
  OCPPChargeMode: Scalars["String"]["output"];
  PaymentURL: Maybe<Scalars["String"]["output"]>;
  PlugAndChargeID: Maybe<Scalars["String"]["output"]>;
  PriceMinute: Maybe<Scalars["Float"]["output"]>;
  PricekWh: Maybe<Scalars["Float"]["output"]>;
  RandomSmartChargeDelay: Scalars["Int"]["output"];
  ResetRetries: Scalars["Int"]["output"];
  SendLocalListMaxLength: Scalars["Int"]["output"];
  StopTransactionOnEVSideDisconnect: Scalars["Boolean"]["output"];
  StopTransactionOnInvalidId: Scalars["Boolean"]["output"];
  StopTxnAlignedData: Scalars["String"]["output"];
  StopTxnSampledData: Scalars["String"]["output"];
  SupportContact: Maybe<Scalars["String"]["output"]>;
  SupportedFeatureProfiles: Scalars["String"]["output"];
  TariffType: Maybe<Scalars["String"]["output"]>;
  TransactionMessageAttempts: Scalars["Int"]["output"];
  TransactionMessageRetryInterval: Scalars["Int"]["output"];
  UnlockConnectorOnEVSideDisconnect: Scalars["Boolean"]["output"];
  created_at: Scalars["String"]["output"];
  device_serial_no: Scalars["Int"]["output"];
  id: Scalars["Int"]["output"];
  ocppEnabled: Scalars["Boolean"]["output"];
  updated_at: Scalars["String"]["output"];
  username: Scalars["String"]["output"];
  wss_uri: Scalars["String"]["output"];
};

export type OcppConfigurationInput = {
  AuthorizationKey?: InputMaybe<Scalars["String"]["input"]>;
  device_serial_no: Scalars["Int"]["input"];
  ocppEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  username: Scalars["String"]["input"];
  wss_uri: Scalars["String"]["input"];
};

export type OcppLogMessage = {
  __typename?: "OcppLogMessage";
  group: Maybe<Scalars["String"]["output"]>;
  payload: Scalars["String"]["output"];
  timestamp: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
};

export type OcppStatus = {
  __typename?: "OcppStatus";
  ocppStatus: Scalars["String"]["output"];
};

export type OtherSettings = {
  __typename?: "OtherSettings";
  earthingArrangement: Maybe<EarthingArrangement>;
  mpan: Maybe<Scalars["String"]["output"]>;
  radioChannelId: Maybe<Scalars["Int"]["output"]>;
  vHub: Maybe<Scalars["Boolean"]["output"]>;
};

export type PaginatedSearchFindHubRowGqlResponse = {
  __typename?: "PaginatedSearchFindHubRowGqlResponse";
  rows: Array<FindHubRowGql>;
  totalCount: Scalars["Int"]["output"];
};

export type PaginatedSearchInput = {
  filterOptions?: InputMaybe<FilterOptions>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  orderDirection?: InputMaybe<Scalars["String"]["input"]>;
};

/** Permissions related to User access rights */
export enum Permission {
  aggregatorAssignedDevicesView = "aggregatorAssignedDevicesView",
  aggregatorManagement = "aggregatorManagement",
  aggregatorView = "aggregatorView",
  chargeLogsRead = "chargeLogsRead",
  customerEdit = "customerEdit",
  customerLiveView = "customerLiveView",
  customerView = "customerView",
  dashboardUpdateBoxManagement = "dashboardUpdateBoxManagement",
  dashboardView = "dashboardView",
  dataMigration = "dataMigration",
  deleteCustomer = "deleteCustomer",
  deleteInitialCommands = "deleteInitialCommands",
  deleteMyAccountDevices = "deleteMyAccountDevices",
  deviceAccessGroupsEdit = "deviceAccessGroupsEdit",
  deviceAccessGroupsView = "deviceAccessGroupsView",
  deviceBlock = "deviceBlock",
  deviceConfigEdit = "deviceConfigEdit",
  deviceConfigView = "deviceConfigView",
  deviceDelete = "deviceDelete",
  deviceSetFirmware = "deviceSetFirmware",
  downloadBootloader = "downloadBootloader",
  firmwareManagement = "firmwareManagement",
  firmwarePrerelease = "firmwarePrerelease",
  firmwareRelease = "firmwareRelease",
  firmwareView = "firmwareView",
  forceBackgroundDownload = "forceBackgroundDownload",
  forceDownload = "forceDownload",
  forceInstallApp = "forceInstallApp",
  forceInstallBootloader = "forceInstallBootloader",
  forceReboot = "forceReboot",
  g100Reset = "g100Reset",
  goodwillWarrantyEdit = "goodwillWarrantyEdit",
  hubDeregister = "hubDeregister",
  hubDetailsView = "hubDetailsView",
  hubMonitor = "hubMonitor",
  hubMonitoring = "hubMonitoring",
  hubView = "hubView",
  integratorManagement = "integratorManagement",
  integratorView = "integratorView",
  manageInstallers = "manageInstallers",
  manageServers = "manageServers",
  ocppDeviceEdit = "ocppDeviceEdit",
  ocppDeviceView = "ocppDeviceView",
  registrationDateEdit = "registrationDateEdit",
  userManagement = "userManagement",
  userView = "userView",
}

export enum PhaseReturn {
  PHASE_RETURN_L1 = "PHASE_RETURN_L1",
  PHASE_RETURN_L2 = "PHASE_RETURN_L2",
  PHASE_RETURN_L3 = "PHASE_RETURN_L3",
  PHASE_RETURN_MODULO = "PHASE_RETURN_MODULO",
  PHASE_RETURN_N = "PHASE_RETURN_N",
}

export enum Preconditioning {
  FULL_POWER = "FULL_POWER",
  NORMAL = "NORMAL",
  OFF = "OFF",
}

export type PtData = {
  __typename?: "PtData";
  absent: Maybe<Scalars["Int"]["output"]>;
  hyst: Maybe<Scalars["Int"]["output"]>;
  ptNumber: Scalars["Int"]["output"];
  setPoint: Maybe<Scalars["Int"]["output"]>;
  temp: Maybe<Scalars["Int"]["output"]>;
};

export type PulseWidthModulationData = {
  __typename?: "PulseWidthModulationData";
  /** Pulse with Modulation in percentage */
  pulseWidthModulationInPercentage: Maybe<Scalars["Float"]["output"]>;
  /** AC in nano Amps */
  rcdACInNanoAmps: Maybe<Scalars["Int"]["output"]>;
  /** DC in nano Amps */
  rcdDCInNanoAmps: Maybe<Scalars["Int"]["output"]>;
  /** Return AC in nano Amps */
  returnRcdACInNanoAmps: Maybe<Scalars["Int"]["output"]>;
  /** Zappi application state name */
  state: Maybe<Scalars["String"]["output"]>;
  /** Zappi application state */
  stateCpu: Maybe<Scalars["Int"]["output"]>;
  /** Zappi state engine version */
  stateEngineVersion: Maybe<Scalars["Int"]["output"]>;
  /** Zappi RCD protection board state */
  stateRCDBoard: Maybe<Scalars["Int"]["output"]>;
};

export enum PvMpptInputMode {
  INDEPENDENT = "INDEPENDENT",
  PARALLEL = "PARALLEL",
}

export type Query = {
  __typename?: "Query";
  chargeSessions: Maybe<ChargeSessionsGql>;
  /**
   *  Information about active devices, device counts and active app users
   *   Required permissions:
   *
   *   - dashboardView
   */
  dashboardInfo: DashBoardInfo;
  /**
   *
   * Returns connection history for the given device serial number and device type.
   *
   * Connections will be ordered ascending by most recent.
   *
   * Required permissions:
   * - hubDetailsView
   *
   */
  deviceConnections: Array<DeviceConnection>;
  /**
   * Returns Eddi config details for given Eddi serial.
   * Required permissions:
   * - hubView, deviceConfigView
   */
  eddiConfig: EddiConfig;
  /**
   * Returns Eddi+ config details for given Eddi+ serial.
   * Required permissions:
   * - hubView, deviceConfigView
   */
  eddiPlusConfig: EddiPlusConfig;
  /**
   *
   * Returns error history for the given device type and serial number.
   *
   * Errors will be ordered ascending by most recent.
   *
   * Required permissions:
   * - hubDetailsView
   *
   */
  errorHistory: Array<DeviceError>;
  /**
   * Returns execution context id for the given command.
   *     Required permissions:
   *     - hubDetailsView
   */
  executionContextId: ExecutionContextId;
  /**
   * Returns an object with 2 fields:
   *     events (array of objects containing event type and time)
   *     eventCounters (array of objects containing counter type and value).
   *     Params:
   *     - deviceName: DeviceName
   *     - serialNo: number
   *
   *     Required permissions:
   *     - g100Reset
   */
  g100Events: G100Events;
  /**
   * Returns alternate server info.
   *
   *   Required permissions:
   *
   *   - manageServers
   */
  getAlternateServersInfo: AlternateServers;
  getDeviceChannels: DeviceChannelsResult;
  /** Get all enabled Ocpp configs */
  getEnabledOcppConfigs: Maybe<Array<OcppConfiguration>>;
  getFirmwareFiles: FirmwareFilesResult;
  /**
   * Gets the detailed monitoring config in redis for a hub
   * Required permissions:
   * - hubMonitoring
   */
  getMonitoringConfig: Maybe<MonitoringConfig>;
  /**
   * Fetches JStatus monitoring data.
   * Required permissions:
   * - hubMonitoring
   */
  getMonitoringJStatus: Array<MonitoringJStatus>;
  /**
   *
   * Returns mqtt connection history for the given device serial number.
   *
   * Mqtt connections will be ordered ascending by most recent.
   *
   * Required permissions:
   * - hubDetailsView
   *
   */
  getMqttConnectionHistory: MqttConnectionResult;
  /** Ocpp Status for a device */
  getOcppChargingProfiles: Array<OcppChargingProfile>;
  /** Ocpp Config for a device */
  getOcppConfig: Maybe<OcppConfiguration>;
  /** Ocpp log messages of a device */
  getOcppLogMessages: Array<OcppLogMessage>;
  /** Ocpp Status for a device */
  getOcppStatus: OcppStatus;
  getProductsFirmwareVersions: GetProductsFirmwareVersionsResult;
  /**
   * Returns all server info: ips, defaults, etc.
   *
   *   Required permissions:
   *
   *   - manageServers
   */
  getServersInfo: Array<Server>;
  /**
   * Returns connections for a 3rd party integrators.
   *   Required permissions: - integratorView
   */
  getThirdPartyClientConnections: ThirdPartyClientConnections;
  /**
   * Returns data for all 3rd party connections
   *       to the Customer page on Admin Portal.
   *       Required permissions: - integratorView
   */
  getThirdPartyConnectionsByCognitoSubs: Array<ThirdPartyConnections>;
  /**
   * Returns 3rd party integrator data for given id.
   *   Required permissions: - integratorView
   */
  getThirdPartyIntegrator: ThirdPartyClient;
  /**
   * Returns data for all 3rd party integrators.
   *   Required permissions: - integratorView
   */
  getThirdPartyIntegrators: Array<ThirdPartyClients>;
  getUploadFirmwareUrl: UploadFirmwareUrl;
  /**
   * Returns all user roles and their permissions.
   *
   *   Required permissions:
   *
   *   - userView
   */
  getUserRoles: Array<UserAccess>;
  /**
   * Returns webhooks and integrators
   *       to the Device page on Admin Portal.
   *       Required permissions: - integratorView
   */
  getWebhooksByDeviceSerialNo: ThirdPartyWebhooksAndIntegratorGql;
  /**
   * Returns whether device has any pending commands (any initial commands queued, or a command in-progress).
   *     Required permissions:
   *     - hubDetailsView
   */
  hasPendingCommands: Scalars["Boolean"]["output"];
  /**
   * Returns history for device.
   * Required permissions:
   * - hubDetailsView
   */
  history: History;
  /**
   * Returns hub details for given hub serialNo.
   *
   *   Required permissions:
   *
   *   - hubView
   */
  hubDetails: Maybe<Hub>;
  /**
   * Returns all data for hubs.
   *
   *   Required permissions:
   *
   *   - hubView
   */
  hubs: PaginatedSearchFindHubRowGqlResponse;
  /**
   * Returns the details of the installation associated with the given device serial number.
   *
   *   Required permissions:
   *
   *   - manageInstallers
   */
  installation: Maybe<Installation>;
  /**
   * Returns Libbi Config details for given Libbi serialNo.
   * Required permissions:
   * - hubView, deviceConfigView
   */
  libbiConfig: LibbiConfigReplyData;
  /** Fetch the latest minute of a libbi by serialNo */
  libbiMinute: LibbiMinute;
  /**
   * Returns Rapid Zappi Config details for given Zappi serialNo.
   * Required permissions:
   * - hubView, deviceConfigView
   */
  rapidZappiConfig: RapidZappiConfig;
  /**
   * Returns recent commands for the given device name and serial.
   *     Params:
   *     - deviceName: DeviceName
   *     - serialNo: number
   *     - limit: number (default: 20)
   *     - offset: number (default: 0)
   *
   *     Required permissions:
   *     - hubDetailsView
   */
  recentCommands: Array<Command>;
  /**
   * Returns rig data for device serial.
   * Required permissions:
   * - hubDetailsView
   */
  rigData: Maybe<RigData>;
  /**
   * Returns hub serial number, device serial number, device name if connected, based on the given serial number.
   *
   *   Required permissions:
   *
   *   - hubView
   */
  searchHubOrDevice: SearchResult;
  /**
   * Returns user data for given id.
   *
   *     Required permissions:
   *
   * - userView
   *
   *       OR
   *
   * - querier has the same id as the input id
   */
  user: User;
  /**
   * Returns all user data.
   *
   *   Required permissions:
   *
   *   - userView
   */
  users: Array<User>;
  /**
   * Returns Zappi 1 Config details for given Zappi serialNo.
   * Required permissions:
   * - hubView, deviceConfigView
   */
  zappi1Config: Zappi1Config;
  /**
   * Returns Zappi 2 Config details for given Zappi serialNo.
   * Required permissions:
   * - hubView, deviceConfigView
   */
  zappi2Config: Zappi2Config;
};

export type QueryChargeSessionsArgs = {
  authTypeFilter: InputMaybe<Scalars["Int"]["input"]>;
  end: InputMaybe<Scalars["String"]["input"]>;
  friendlyNamesFilter: InputMaybe<Array<Scalars["String"]["input"]>>;
  isBusinessUsageFilter: InputMaybe<Scalars["Boolean"]["input"]>;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  offset: InputMaybe<Scalars["Int"]["input"]>;
  serialNo: Scalars["Int"]["input"];
  start: Scalars["String"]["input"];
};

export type QueryDashboardInfoArgs = {
  timezone: Scalars["String"]["input"];
};

export type QueryDeviceConnectionsArgs = {
  deviceType: DeviceType;
  limit: Scalars["Float"]["input"];
  serialNo: Scalars["Float"]["input"];
};

export type QueryEddiConfigArgs = {
  serialNo: Scalars["Float"]["input"];
};

export type QueryEddiPlusConfigArgs = {
  serialNo: Scalars["Float"]["input"];
};

export type QueryErrorHistoryArgs = {
  deviceType: DeviceType;
  serialNo: Scalars["Float"]["input"];
};

export type QueryExecutionContextIdArgs = {
  commandId: Scalars["String"]["input"];
};

export type QueryG100EventsArgs = {
  deviceName: DeviceName;
  serialNo: Scalars["Float"]["input"];
};

export type QueryGetDeviceChannelsArgs = {
  channel: Scalars["String"]["input"];
  cursor: InputMaybe<Scalars["String"]["input"]>;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  upc: Scalars["String"]["input"];
};

export type QueryGetFirmwareFilesArgs = {
  cursor: InputMaybe<Scalars["String"]["input"]>;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  upc: Scalars["String"]["input"];
};

export type QueryGetMonitoringConfigArgs = {
  hubSerial: Scalars["Float"]["input"];
};

export type QueryGetMonitoringJStatusArgs = {
  deviceClass: Scalars["String"]["input"];
  deviceSerial: Scalars["Float"]["input"];
  hubSerial: Scalars["Float"]["input"];
  startTime: Scalars["Float"]["input"];
};

export type QueryGetMqttConnectionHistoryArgs = {
  cursor: InputMaybe<Scalars["String"]["input"]>;
  limit: InputMaybe<Scalars["Int"]["input"]>;
  serialNo: Scalars["Int"]["input"];
};

export type QueryGetOcppChargingProfilesArgs = {
  deviceSerialNo: Scalars["Float"]["input"];
};

export type QueryGetOcppConfigArgs = {
  deviceSerialNo: Scalars["Float"]["input"];
};

export type QueryGetOcppLogMessagesArgs = {
  deviceSerialNo: Scalars["Float"]["input"];
};

export type QueryGetOcppStatusArgs = {
  deviceSerialNo: Scalars["Float"]["input"];
};

export type QueryGetThirdPartyClientConnectionsArgs = {
  input: ThirdPartyClientConnectionsInput;
};

export type QueryGetThirdPartyConnectionsByCognitoSubsArgs = {
  cognitoSubs: Array<Scalars["String"]["input"]>;
};

export type QueryGetThirdPartyIntegratorArgs = {
  id: Scalars["String"]["input"];
};

export type QueryGetUploadFirmwareUrlArgs = {
  fileName: Scalars["String"]["input"];
  md5Base64: Scalars["String"]["input"];
};

export type QueryGetWebhooksByDeviceSerialNoArgs = {
  deviceSerialNo: Scalars["String"]["input"];
};

export type QueryHasPendingCommandsArgs = {
  deviceType: DeviceType;
  hubSerialNo: Scalars["Int"]["input"];
  serialNo: Scalars["Int"]["input"];
};

export type QueryHistoryArgs = {
  deviceType: DeviceType;
  end: InputMaybe<Scalars["String"]["input"]>;
  energyUnit: InputMaybe<HistoryEnergyUnit>;
  includeMinMax: InputMaybe<Scalars["Boolean"]["input"]>;
  resolution: HistoryResolution;
  serialNo: Scalars["Float"]["input"];
  start: Scalars["String"]["input"];
};

export type QueryHubDetailsArgs = {
  serialNo: Scalars["Float"]["input"];
};

export type QueryHubsArgs = {
  input: PaginatedSearchInput;
};

export type QueryInstallationArgs = {
  deviceType: DeviceType;
  serialNo: Scalars["BigInt"]["input"];
};

export type QueryLibbiConfigArgs = {
  serialNo: Scalars["Float"]["input"];
};

export type QueryLibbiMinuteArgs = {
  serialNo: Scalars["Float"]["input"];
};

export type QueryRapidZappiConfigArgs = {
  serialNo: Scalars["Float"]["input"];
};

export type QueryRecentCommandsArgs = {
  deviceName: DeviceName;
  hubSerialNo: Scalars["Float"]["input"];
  limit: Scalars["Float"]["input"];
  offset: InputMaybe<Scalars["Int"]["input"]>;
  serialNo: Scalars["Float"]["input"];
};

export type QueryRigDataArgs = {
  serialNo: Scalars["Int"]["input"];
};

export type QuerySearchHubOrDeviceArgs = {
  serialNo: Scalars["BigInt"]["input"];
};

export type QueryUserArgs = {
  id: Scalars["String"]["input"];
};

export type QueryZappi1ConfigArgs = {
  serialNo: Scalars["Float"]["input"];
};

export type QueryZappi2ConfigArgs = {
  serialNo: Scalars["Float"]["input"];
};

export type RapidZappiConfig = {
  __typename?: "RapidZappiConfig";
  autoPhaseSwitching: Scalars["Boolean"]["output"];
  batteryDischargeEnabled: Scalars["Boolean"]["output"];
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Array<ConfigReplyBoostTimer>;
  chargeComplete: Rgb;
  chargeCompleteDelay: Scalars["Int"]["output"];
  chargeWhenPINLocked: Scalars["Boolean"]["output"];
  compatibilityModeActive: Scalars["Boolean"]["output"];
  compatibilityModeMinPWM: Scalars["Float"]["output"];
  compatibilityModePowerFactor: Scalars["Float"]["output"];
  ct1GroupLimit: Scalars["Int"]["output"];
  ct1Subtype: Maybe<CtSubtype>;
  ct1Type: Maybe<CtTypes>;
  ct2GroupLimit: Scalars["Int"]["output"];
  ct2Subtype: Maybe<CtSubtype>;
  ct2Type: Maybe<CtTypes>;
  ct3GroupLimit: Scalars["Int"]["output"];
  ct3Subtype: Maybe<CtSubtype>;
  ct3Type: Maybe<CtTypes>;
  ct4GroupLimit: Scalars["Int"]["output"];
  ctDetection: Scalars["Boolean"]["output"];
  ctExternal1Group: Scalars["Int"]["output"];
  ctExternal2Group: Scalars["Int"]["output"];
  ctExternal3Group: Scalars["Int"]["output"];
  ctInternal1Group: Scalars["Int"]["output"];
  ctInternal2Group: Scalars["Int"]["output"];
  ctInternal3Group: Scalars["Int"]["output"];
  ctPrimary: Scalars["Int"]["output"];
  dateFormat: Maybe<DateFormat>;
  defaultSmartChargingMode: RapidZappiDefaultMode;
  deviceLimit: Scalars["Float"]["output"];
  deviceLimitAmps: Scalars["Float"]["output"];
  dirtyCharging: Rgb;
  dstOn: Scalars["Boolean"]["output"];
  eSenseInput: Maybe<ESenseInput>;
  earthing: Maybe<Earthing>;
  ecopStopDelay: Scalars["Int"]["output"];
  exportLimit: Scalars["Int"]["output"];
  exportMargin: Scalars["Int"]["output"];
  fault: Rgb;
  greenCharging: Rgb;
  gridLimit: Scalars["Int"]["output"];
  gridPowerLimit: Scalars["Int"]["output"];
  icons: Maybe<GenTypeIconZappi>;
  language: Maybe<Language>;
  ledBrightness: Scalars["Int"]["output"];
  lockAutohide: Scalars["Boolean"]["output"];
  lockCode: Scalars["String"]["output"];
  lockEVPluggedIn: Scalars["Boolean"]["output"];
  lockEVUnplugged: Scalars["Boolean"]["output"];
  lockSolenoidPWM: Scalars["Int"]["output"];
  lockTimeout: Scalars["Int"]["output"];
  mainSwitchPWM: Scalars["Int"]["output"];
  manualBoost: Scalars["Int"]["output"];
  masterLostDetection: Scalars["Boolean"]["output"];
  masterLostThreshold: Scalars["Int"]["output"];
  minGreenLevel: Scalars["Int"]["output"];
  mixedCharging: Rgb;
  monitoringStatus: Scalars["Boolean"]["output"];
  neutralLimit: Scalars["Int"]["output"];
  pERelayPWM: Scalars["Int"]["output"];
  passcode: Scalars["String"]["output"];
  phaseReturn: Maybe<PhaseReturn>;
  plugInCharge: Scalars["Boolean"]["output"];
  preconEnergy: Scalars["Float"]["output"];
  preconOn: Scalars["Boolean"]["output"];
  randomDelayStart: Scalars["Int"]["output"];
  relay1PWM: Scalars["Int"]["output"];
  relay2PWM: Scalars["Int"]["output"];
  setBuzzer: Scalars["Boolean"]["output"];
  signature: Scalars["Int"]["output"];
  /** for firmware 3.148 and higher this is the EcopStartDelay */
  startStopDelay: Scalars["Int"]["output"];
  stateB: Rgb;
  timeFromCloud: Scalars["Boolean"]["output"];
  timeZone: Maybe<TimeZone>;
  weldedRelayCheckDelay: Scalars["Int"]["output"];
};

export type RapidZappiConfigPartial = {
  __typename?: "RapidZappiConfigPartial";
  deviceConfigTime: Scalars["BigInt"]["output"];
  g100LockoutState: G100LockoutState;
  id: Scalars["ID"]["output"];
  serverConfigTime: Maybe<Scalars["BigInt"]["output"]>;
};

/** RapidZappiDefaultMode */
export enum RapidZappiDefaultMode {
  ECO_PLUS = "ECO_PLUS",
  FAST = "FAST",
  PREVIOUS = "PREVIOUS",
}

export type RapidZappiEditableConfigInput = {
  batteryDischargeEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  batteryMode?: InputMaybe<BatteryMode>;
  boostTimers?: InputMaybe<Array<Zappi2EditableBoostTimerInput>>;
  chargeComplete?: InputMaybe<Zappi2EditableRgbInput>;
  chargeCompleteDelay?: InputMaybe<Scalars["Float"]["input"]>;
  chargeWhenPINLocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  compatibilityModeActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  compatibilityModeMinPWM?: InputMaybe<Scalars["Float"]["input"]>;
  compatibilityModePowerFactor?: InputMaybe<Scalars["Float"]["input"]>;
  ct1GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct1Type?: InputMaybe<CtTypes>;
  ct2GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct2Type?: InputMaybe<CtTypes>;
  ct3GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct3Type?: InputMaybe<CtTypes>;
  ct4GroupLimit?: InputMaybe<Scalars["Float"]["input"]>;
  ctDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  ctExternal1Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctExternal2Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctExternal3Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctInternal1Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctInternal2Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctInternal3Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctPrimary?: InputMaybe<Scalars["Float"]["input"]>;
  dateFormat?: InputMaybe<DateFormat>;
  defaultSmartChargingMode?: InputMaybe<RapidZappiDefaultMode>;
  deviceLimitAmps?: InputMaybe<Scalars["Float"]["input"]>;
  dirtyCharging?: InputMaybe<Zappi2EditableRgbInput>;
  dstOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  eSenseInput?: InputMaybe<ESenseInput>;
  earthing?: InputMaybe<Earthing>;
  ecopStopDelay?: InputMaybe<Scalars["Float"]["input"]>;
  esenseLimitPWM?: InputMaybe<Scalars["Float"]["input"]>;
  exportLimit?: InputMaybe<Scalars["Int"]["input"]>;
  exportMargin?: InputMaybe<Scalars["Float"]["input"]>;
  fault?: InputMaybe<Zappi2EditableRgbInput>;
  greenCharging?: InputMaybe<Zappi2EditableRgbInput>;
  gridLimit?: InputMaybe<Scalars["Int"]["input"]>;
  gridPowerLimit?: InputMaybe<Scalars["Float"]["input"]>;
  icons?: InputMaybe<GenTypeIconZappi>;
  language?: InputMaybe<Language>;
  ledBrightness?: InputMaybe<Scalars["Float"]["input"]>;
  lockAutohide?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockCode?: InputMaybe<Scalars["String"]["input"]>;
  lockEVPluggedIn?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockEVUnplugged?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockSolenoidPWM?: InputMaybe<Scalars["Float"]["input"]>;
  lockTimeout?: InputMaybe<Scalars["Float"]["input"]>;
  mainSwitchPWM?: InputMaybe<Scalars["Float"]["input"]>;
  manualBoost?: InputMaybe<Scalars["Float"]["input"]>;
  masterLostDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  masterLostThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  minGreenLevel?: InputMaybe<Scalars["Float"]["input"]>;
  mixedCharging?: InputMaybe<Zappi2EditableRgbInput>;
  monitoringStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
  neutralLimit?: InputMaybe<Scalars["Int"]["input"]>;
  pERelayPWM?: InputMaybe<Scalars["Float"]["input"]>;
  passcode?: InputMaybe<Scalars["String"]["input"]>;
  phaseReturn?: InputMaybe<PhaseReturn>;
  plugInCharge?: InputMaybe<Scalars["Boolean"]["input"]>;
  powerLimit?: InputMaybe<Scalars["Int"]["input"]>;
  preconEnergy?: InputMaybe<Scalars["Float"]["input"]>;
  preconOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  randomDelayStart?: InputMaybe<Scalars["Float"]["input"]>;
  relay1PWM?: InputMaybe<Scalars["Float"]["input"]>;
  relay2PWM?: InputMaybe<Scalars["Float"]["input"]>;
  setBuzzer?: InputMaybe<Scalars["Boolean"]["input"]>;
  startStopDelay?: InputMaybe<Scalars["Float"]["input"]>;
  stateB?: InputMaybe<Zappi2EditableRgbInput>;
  timeFromCloud?: InputMaybe<Scalars["Boolean"]["input"]>;
  timeZone?: InputMaybe<TimeZone>;
  weldedRelayCheckDelay?: InputMaybe<Scalars["Float"]["input"]>;
};

export type RateIncreaseCriteria = {
  numberOfNotifiedThings?: InputMaybe<Scalars["Int"]["input"]>;
  numberOfSucceededThings?: InputMaybe<Scalars["Int"]["input"]>;
};

/** Recurring charge slot */
export enum Recurring {
  /** Daily */
  DAILY = "DAILY",
  /** Every two weeks */
  FORTNIGHTLY = "FORTNIGHTLY",
  /** Off */
  OFF = "OFF",
  /** Every week */
  WEEKLY = "WEEKLY",
}

export type RelayBoardData = {
  __typename?: "RelayBoardData";
  relayBoardDataBoardConnected: Maybe<Scalars["Boolean"]["output"]>;
  relayBoardDataEsenseActive: Maybe<Scalars["Boolean"]["output"]>;
  relayBoardDataRelay1Active: Maybe<Scalars["Boolean"]["output"]>;
  relayBoardDataRelay1BoostType: Maybe<Scalars["String"]["output"]>;
  relayBoardDataRelay2Active: Maybe<Scalars["Boolean"]["output"]>;
  relayBoardDataRelay2BoostType: Maybe<Scalars["String"]["output"]>;
};

export enum RelayBoardPreset {
  AUX_HEATER = "AUX_HEATER",
  CUSTOM = "CUSTOM",
  DESTRAT = "DESTRAT",
  DESTRAT_AUX_HEATER = "DESTRAT_AUX_HEATER",
  DESTRAT_LEGIONELLA = "DESTRAT_LEGIONELLA",
  HEATPUMP = "HEATPUMP",
  RELAYS_OFF = "RELAYS_OFF",
}

export enum RelayHeating {
  DESTRAT_1 = "DESTRAT_1",
  DESTRAT_2 = "DESTRAT_2",
  DISABLED = "DISABLED",
  HEATER_1 = "HEATER_1",
  HEATER_1_AND_2 = "HEATER_1_AND_2",
  HEATER_2 = "HEATER_2",
}

export enum RelayMode {
  BOOST_TIMER = "BOOST_TIMER",
  DISABLED = "DISABLED",
  EXPORT = "EXPORT",
  FAULT = "FAULT",
  FOLLOW_RELAY = "FOLLOW_RELAY",
  HEATING = "HEATING",
  IMPORT = "IMPORT",
}

export type RenewableEnergy = {
  __typename?: "RenewableEnergy";
  hasBattery: Maybe<Scalars["Boolean"]["output"]>;
  hasElectricStorageHeating: Maybe<Scalars["Boolean"]["output"]>;
  hasHydroelectric: Maybe<Scalars["Boolean"]["output"]>;
  hasSolarPanel: Maybe<Scalars["Boolean"]["output"]>;
  hasWindTurbine: Maybe<Scalars["Boolean"]["output"]>;
  none: Maybe<Scalars["Boolean"]["output"]>;
  other: Maybe<Scalars["Boolean"]["output"]>;
};

export type Rgb = {
  __typename?: "Rgb";
  blue: Scalars["Int"]["output"];
  green: Scalars["Int"]["output"];
  red: Scalars["Int"]["output"];
};

export type RigData = {
  __typename?: "RigData";
  blePin: Maybe<Scalars["String"]["output"]>;
  fpc: Maybe<Scalars["String"]["output"]>;
  lastPassTime: Maybe<Scalars["String"]["output"]>;
  pcbQr: Maybe<Scalars["String"]["output"]>;
  provisionedAt: Maybe<Scalars["String"]["output"]>;
  rigId: Maybe<Scalars["Int"]["output"]>;
  serialNo: Scalars["Int"]["output"];
  uid: Maybe<Scalars["String"]["output"]>;
  upc: Maybe<Scalars["String"]["output"]>;
};

export type SearchResult = {
  __typename?: "SearchResult";
  deviceName: Maybe<Scalars["String"]["output"]>;
  deviceSerialNo: Maybe<Scalars["BigInt"]["output"]>;
  serialNo: Maybe<Scalars["BigInt"]["output"]>;
};

export type Server = {
  __typename?: "Server";
  id: Scalars["ID"]["output"];
  ip: Scalars["String"]["output"];
  isActive: Scalars["Boolean"]["output"];
  isDefault: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  shard: Maybe<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

export type SetDeviceChannelInput = {
  channel: Scalars["String"]["input"];
  notes: Scalars["String"]["input"];
  serialNo: Scalars["Int"]["input"];
  setByEmail: Scalars["String"]["input"];
  upc: Scalars["String"]["input"];
};

export type SetDeviceConfigIssue = {
  __typename?: "SetDeviceConfigIssue";
  message: Scalars["String"]["output"];
  path: Maybe<Array<Scalars["String"]["output"]>>;
};

export type SetDeviceConfigResult = {
  __typename?: "SetDeviceConfigResult";
  success: Scalars["Boolean"]["output"];
  validationIssues: Maybe<Array<SetDeviceConfigIssue>>;
};

export type SetOcppConfigResult = {
  __typename?: "SetOcppConfigResult";
  success: Scalars["Boolean"]["output"];
};

export enum SetZappiModeCommand {
  DONT_CHANGE = "DONT_CHANGE",
  ECO = "ECO",
  ECO_PLUS = "ECO_PLUS",
  FAST = "FAST",
  STOP = "STOP",
}

export type SmartRegulationDelayData = {
  __typename?: "SmartRegulationDelayData";
  /** Deprecated: Unix time of when delay expires */
  ChargeDelayTimeoutTime: Maybe<Scalars["Int"]["output"]>;
  /** Unix time of when delay expires V2 since ChargeDelayTimeoutTime is only 4bit which is not enough to store in the DB */
  ChargeDelayTimeoutTimeV2: Maybe<Scalars["Int"]["output"]>;
  /** Number of seconds before delay expires */
  ChargeDelayTimer: Maybe<Scalars["Int"]["output"]>;
  /** Charge delay status */
  Flags: Maybe<Scalars["Int"]["output"]>;
};

export type StartFirmwareReleaseInput = {
  rolloutConfig?: InputMaybe<JobRolloutConfig>;
  targetChannels: Array<Scalars["String"]["input"]>;
  targetFile: Scalars["String"]["input"];
  upc: Scalars["String"]["input"];
};

export type SupplyAndLimits = {
  __typename?: "SupplyAndLimits";
  deviceLimit: Maybe<Scalars["Int"]["output"]>;
  exportLimit: Maybe<Scalars["Int"]["output"]>;
  importLimit: Maybe<Scalars["Int"]["output"]>;
};

export type TargetTimeGql = {
  hour: Scalars["Float"]["input"];
  minute: Scalars["Float"]["input"];
};

export type ThingConnectivity = {
  __typename?: "ThingConnectivity";
  connected: Maybe<Scalars["Boolean"]["output"]>;
  disconnectReason: Maybe<Scalars["String"]["output"]>;
  timestamp: Maybe<Scalars["String"]["output"]>;
};

export type ThirdPartyClient = {
  __typename?: "ThirdPartyClient";
  accessTokenLifetime: Scalars["Int"]["output"];
  allowedScopes: Maybe<Array<Scalars["String"]["output"]>>;
  clientId: Scalars["String"]["output"];
  clientName: Scalars["String"]["output"];
  clientSecret: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  grantTypes: Array<Scalars["String"]["output"]>;
  numberOfDevices: Scalars["Int"]["output"];
  redirectUris: Array<Scalars["String"]["output"]>;
  refreshTokenLifetime: Scalars["Int"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type ThirdPartyClientConnection = {
  __typename?: "ThirdPartyClientConnection";
  userId: Scalars["String"]["output"];
};

export type ThirdPartyClientConnections = {
  __typename?: "ThirdPartyClientConnections";
  connections: Array<ThirdPartyClientConnection>;
  cursor: Maybe<Scalars["String"]["output"]>;
};

export type ThirdPartyClientConnectionsInput = {
  clientId: Scalars["String"]["input"];
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ThirdPartyClients = {
  __typename?: "ThirdPartyClients";
  clientId: Scalars["String"]["output"];
  clientName: Scalars["String"]["output"];
  numberOfDevices: Scalars["Int"]["output"];
  numberOfUsers: Scalars["Int"]["output"];
};

export type ThirdPartyConnections = {
  __typename?: "ThirdPartyConnections";
  clientId: Scalars["String"]["output"];
  clientName: Scalars["String"]["output"];
  createdAt: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

export type ThirdPartyCreateClientInput = {
  client_name: Scalars["String"]["input"];
  redirect_uris: Array<Scalars["String"]["input"]>;
};

export type ThirdPartyDeleteResponse = {
  __typename?: "ThirdPartyDeleteResponse";
  clientId: Scalars["String"]["output"];
  clientName: Scalars["String"]["output"];
  redirectUris: Array<Scalars["String"]["output"]>;
};

export type ThirdPartyRotateSecretResponse = {
  __typename?: "ThirdPartyRotateSecretResponse";
  clientId: Scalars["String"]["output"];
  clientSecret: Scalars["String"]["output"];
};

export type ThirdPartyUpdateClientInput = {
  client_name?: InputMaybe<Scalars["String"]["input"]>;
  redirect_uris?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ThirdPartyUpdateResponse = {
  __typename?: "ThirdPartyUpdateResponse";
  clientId: Scalars["String"]["output"];
  clientName: Scalars["String"]["output"];
  redirectUris: Array<Scalars["String"]["output"]>;
};

export type ThirdPartyWebhooksAndIntegratorGql = {
  __typename?: "ThirdPartyWebhooksAndIntegratorGql";
  integratorData: IntegratorDataGql;
  integrators: Maybe<Array<IntegratorsGql>>;
  webhooks: Array<WebhookGql>;
};

export enum TimeZone {
  AUS_ACDT = "AUS_ACDT",
  AUS_ACST = "AUS_ACST",
  AUS_AEDT = "AUS_AEDT",
  AUS_AESTT = "AUS_AESTT",
  AUS_AWST = "AUS_AWST",
  Britain_BST = "Britain_BST",
  Europe_CEST = "Europe_CEST",
  Europe_EEST = "Europe_EEST",
  Europe_WEST = "Europe_WEST",
  Ireland_IST = "Ireland_IST",
  NZ_CHADT = "NZ_CHADT",
  NZ_NZDT = "NZ_NZDT",
  UAE_GST = "UAE_GST",
}

export type UpdatedHubInput = {
  blockedReason?: InputMaybe<Scalars["String"]["input"]>;
  cloudIPOverrideServerId?: InputMaybe<Scalars["Int"]["input"]>;
  isBlocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  serialNo: Scalars["BigInt"]["input"];
};

export type UploadFirmwareUrl = {
  __typename?: "UploadFirmwareUrl";
  url: Scalars["String"]["output"];
};

export type User = {
  __typename?: "User";
  access: UserAccess;
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  initCommands: Array<Command>;
  lastLogin: Scalars["DateTime"]["output"];
  name: Scalars["String"]["output"];
  socialTokenExp: Scalars["DateTime"]["output"];
};

export type UserAccess = {
  __typename?: "UserAccess";
  id: Scalars["ID"]["output"];
  permissions: Array<Maybe<Permission>>;
  type: Scalars["String"]["output"];
};

export type VoltageData = {
  __typename?: "VoltageData";
  voltage1: Scalars["Float"]["output"];
  voltage2: Scalars["Float"]["output"];
  voltage3: Scalars["Float"]["output"];
};

export type WebhookGql = {
  __typename?: "WebhookGql";
  createdAt: Scalars["String"]["output"];
  deviceClass: Scalars["String"]["output"];
  deviceSerialNo: Scalars["Float"]["output"];
  eventType: Scalars["String"]["output"];
  updatedAt: Scalars["String"]["output"];
};

export type Zappi = {
  __typename?: "Zappi";
  beingTamperedWith: Scalars["Boolean"]["output"];
  boostManual: Maybe<Scalars["Boolean"]["output"]>;
  boostSmart: Maybe<Scalars["Boolean"]["output"]>;
  boostTimed: Maybe<Scalars["Boolean"]["output"]>;
  bootLoaderVersion: Maybe<Scalars["Int"]["output"]>;
  chargeEnergy: Maybe<Scalars["Float"]["output"]>;
  commandSeqNo: Scalars["Int"]["output"];
  configReply: Maybe<ZappiConfigReply>;
  connectivityStatus: Maybe<ThingConnectivity>;
  createdAt: Scalars["DateTime"]["output"];
  ct1: Maybe<CtData>;
  ct2: Maybe<CtData>;
  ct3: Maybe<CtData>;
  ct4: Maybe<CtData>;
  ct5: Maybe<CtData>;
  ct6: Maybe<CtData>;
  currentVersion: Maybe<Scalars["Int"]["output"]>;
  deviceAddressRaw: Scalars["Int"]["output"];
  deviceClass: Scalars["String"]["output"];
  deviceConfigTime: Maybe<Scalars["BigInt"]["output"]>;
  deviceInfo: DeviceInfo;
  deviceInstance: Maybe<Scalars["Int"]["output"]>;
  diverted: Scalars["Int"]["output"];
  dsrData: DsrData;
  ethernetLink: Maybe<Scalars["Boolean"]["output"]>;
  frequency: Maybe<Scalars["Int"]["output"]>;
  generatorPower: Maybe<Scalars["Int"]["output"]>;
  gridCTPhase1Fitted: Scalars["Boolean"]["output"];
  gridCTPhase2Fitted: Scalars["Boolean"]["output"];
  gridCTPhase3Fitted: Scalars["Boolean"]["output"];
  gridPower: Maybe<Scalars["Int"]["output"]>;
  highPower: Maybe<Scalars["Boolean"]["output"]>;
  isThreePhase: Scalars["Boolean"]["output"];
  lockedStatus: ZappiLockedStatus;
  maxPower: Maybe<Scalars["Int"]["output"]>;
  melibVersion: Maybe<Scalars["Int"]["output"]>;
  melinkVersion: Maybe<Scalars["Int"]["output"]>;
  minPower: Maybe<Scalars["Int"]["output"]>;
  newAppAvailable: Maybe<Scalars["Boolean"]["output"]>;
  newBootloaderAvailable: Maybe<Scalars["Boolean"]["output"]>;
  normalBoostKwh: Maybe<Scalars["Int"]["output"]>;
  phase: Maybe<Scalars["Int"]["output"]>;
  pilotState: Maybe<Scalars["String"]["output"]>;
  priority: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use deviceInfo.productCode instead */
  productCode: Maybe<Scalars["Int"]["output"]>;
  /** Pulse with Modulation extra data */
  pwmData: PulseWidthModulationData;
  serialNo: Scalars["BigInt"]["output"];
  serverConfigTime: Maybe<Scalars["BigInt"]["output"]>;
  smartBoostHour: Maybe<Scalars["Int"]["output"]>;
  smartBoostKwh: Maybe<Scalars["Int"]["output"]>;
  smartBoostMinute: Maybe<Scalars["Int"]["output"]>;
  /** Smart Regulation Delay */
  smartRegulationDelayData: SmartRegulationDelayData;
  state: Maybe<Scalars["String"]["output"]>;
  stubLoaderVersion: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Use isThreePhase instead */
  threePhase: Scalars["Boolean"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  vHub: Maybe<Scalars["Boolean"]["output"]>;
  voltage: Maybe<Scalars["Int"]["output"]>;
  voltage2: Maybe<Scalars["Int"]["output"]>;
  voltage3: Maybe<Scalars["Int"]["output"]>;
  wifiFirmwareVersion: Maybe<Scalars["Int"]["output"]>;
  wifiLink: Maybe<Scalars["Boolean"]["output"]>;
  zappiMode: Maybe<Scalars["String"]["output"]>;
};

export type Zappi1Config = {
  __typename?: "Zappi1Config";
  backlight: Scalars["Int"]["output"];
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Array<ConfigReplyBoostTimer>;
  chargeCompleteDelay: Scalars["Int"]["output"];
  compatibilityModeActive: Scalars["Boolean"]["output"];
  compatibilityModeInfinitePWM: Scalars["Boolean"]["output"];
  compatibilityModeMinPWM: Scalars["Float"]["output"];
  compatibilityModePowerFactor: Scalars["Float"]["output"];
  contrast: Scalars["Int"]["output"];
  /** @deprecated  Use `ctInternal1Group` instead */
  ct1Group: Scalars["Int"]["output"];
  ct1GroupLimit: Scalars["Int"]["output"];
  ct1Subtype: Maybe<CtSubtype>;
  ct1Type: Maybe<CtTypes>;
  /** @deprecated  Use `ctExternal1Group` instead */
  ct2Group: Scalars["Int"]["output"];
  ct2GroupLimit: Scalars["Int"]["output"];
  ct2Subtype: Maybe<CtSubtype>;
  ct2Type: Maybe<CtTypes>;
  /** @deprecated  Use `ctExternal2Group` instead */
  ct3Group: Scalars["Int"]["output"];
  ct3GroupLimit: Scalars["Int"]["output"];
  ctExternal1Group: Scalars["Int"]["output"];
  ctExternal2Group: Scalars["Int"]["output"];
  ctInternal1Group: Scalars["Int"]["output"];
  dateFormat: Maybe<DateFormat>;
  defaultMode: Maybe<DefaultMode>;
  deviceLimit: Scalars["Float"]["output"];
  dstOn: Scalars["Boolean"]["output"];
  eSenseInput: Maybe<ESenseInput>;
  exportMargin: Scalars["Int"]["output"];
  gridLimit: Scalars["Int"]["output"];
  language: Maybe<Language>;
  lockCode: Scalars["String"]["output"];
  lockEVUnplugged: Scalars["Boolean"]["output"];
  lockTimeout: Scalars["Int"]["output"];
  manualBoost: Scalars["Int"]["output"];
  minGreenLevel: Scalars["Int"]["output"];
  monitoringStatus: Scalars["Boolean"]["output"];
  passcode: Scalars["String"]["output"];
  plugInCharge: Scalars["Int"]["output"];
  preconditioning: Maybe<Preconditioning>;
  setBuzzer: Scalars["Boolean"]["output"];
  smartBoostEnergy: Scalars["Int"]["output"];
  smartBoostHour: Scalars["Int"]["output"];
  smartBoostMinute: Scalars["Int"]["output"];
  timeFromCloud: Scalars["Boolean"]["output"];
  timeZone: Maybe<TimeZone>;
  triPhaseOn: Scalars["Boolean"]["output"];
};

export type Zappi1ConfigPartial = {
  __typename?: "Zappi1ConfigPartial";
  deviceConfigTime: Scalars["BigInt"]["output"];
  id: Scalars["ID"]["output"];
};

export type Zappi2Config = {
  __typename?: "Zappi2Config";
  autoPhaseSwitching: Scalars["Boolean"]["output"];
  backlight: Scalars["Int"]["output"];
  batteryDischargeEnabled: Scalars["Boolean"]["output"];
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Array<ConfigReplyBoostTimer>;
  chargeComplete: Rgb;
  chargeCompleteDelay: Scalars["Int"]["output"];
  chargeIn3phase: Scalars["Boolean"]["output"];
  chargeWhenPINLocked: Scalars["Boolean"]["output"];
  compatibilityModeActive: Scalars["Boolean"]["output"];
  compatibilityModeMinPWM: Scalars["Float"]["output"];
  compatibilityModePowerFactor: Scalars["Float"]["output"];
  contrast: Scalars["Int"]["output"];
  ct1GroupLimit: Scalars["Int"]["output"];
  ct1Subtype: Maybe<CtSubtype>;
  ct1Type: Maybe<CtTypes>;
  ct2GroupLimit: Scalars["Int"]["output"];
  ct2Subtype: Maybe<CtSubtype>;
  ct2Type: Maybe<CtTypes>;
  ct3GroupLimit: Scalars["Int"]["output"];
  ct3Subtype: Maybe<CtSubtype>;
  ct3Type: Maybe<CtTypes>;
  ct4GroupLimit: Scalars["Int"]["output"];
  ctDetection: Scalars["Boolean"]["output"];
  ctExternal1Group: Scalars["Int"]["output"];
  ctExternal2Group: Scalars["Int"]["output"];
  ctExternal3Group: Scalars["Int"]["output"];
  ctInternal1Group: Scalars["Int"]["output"];
  ctInternal2Group: Scalars["Int"]["output"];
  ctInternal3Group: Scalars["Int"]["output"];
  ctPrimary: Scalars["Int"]["output"];
  dateFormat: Maybe<DateFormat>;
  defaultMode: Maybe<DefaultMode>;
  deviceLimit: Scalars["Float"]["output"];
  deviceLimitAmps: Scalars["Float"]["output"];
  dirtyCharging: Rgb;
  dstOn: Scalars["Boolean"]["output"];
  eSenseInput: Maybe<ESenseInput>;
  earthing: Maybe<Earthing>;
  ecoMode: ZappiEcoModePhaseSetting;
  ecopStopDelay: Scalars["Int"]["output"];
  exportLimit: Scalars["Int"]["output"];
  exportMargin: Scalars["Int"]["output"];
  fault: Rgb;
  greenCharging: Rgb;
  gridLimit: Scalars["Int"]["output"];
  gridPowerLimit: Scalars["Int"]["output"];
  icons: Maybe<GenTypeIconZappi>;
  language: Maybe<Language>;
  ledBrightness: Scalars["Int"]["output"];
  lockAutohide: Scalars["Boolean"]["output"];
  lockCode: Scalars["String"]["output"];
  lockEVPluggedIn: Scalars["Boolean"]["output"];
  lockEVUnplugged: Scalars["Boolean"]["output"];
  lockSolenoidPWM: Scalars["Int"]["output"];
  lockTimeout: Scalars["Int"]["output"];
  mainSwitchPWM: Scalars["Int"]["output"];
  manualBoost: Scalars["Int"]["output"];
  masterLostDetection: Scalars["Boolean"]["output"];
  masterLostThreshold: Scalars["Int"]["output"];
  minGreenLevel: Scalars["Int"]["output"];
  mixedCharging: Rgb;
  monitoringStatus: Scalars["Boolean"]["output"];
  neutralLimit: Scalars["Int"]["output"];
  pERelayPWM: Scalars["Int"]["output"];
  passcode: Scalars["String"]["output"];
  phaseReturn: Maybe<PhaseReturn>;
  plugInCharge: Scalars["Boolean"]["output"];
  preconEnergy: Scalars["Float"]["output"];
  preconOn: Scalars["Boolean"]["output"];
  randomDelayStart: Scalars["Int"]["output"];
  relay1PWM: Scalars["Int"]["output"];
  relay2PWM: Scalars["Int"]["output"];
  setBuzzer: Scalars["Boolean"]["output"];
  signature: Scalars["Int"]["output"];
  smartBoostEnergy: Scalars["Int"]["output"];
  smartBoostHour: Scalars["Int"]["output"];
  smartBoostMinute: Scalars["Int"]["output"];
  /** for firmware 3.148 and higher this is the EcopStartDelay */
  startStopDelay: Scalars["Int"]["output"];
  stateB: Rgb;
  timeFromCloud: Scalars["Boolean"]["output"];
  timeZone: Maybe<TimeZone>;
  weldedRelayCheckDelay: Scalars["Int"]["output"];
};

export type Zappi2ConfigPartial = {
  __typename?: "Zappi2ConfigPartial";
  deviceConfigTime: Scalars["BigInt"]["output"];
  g100LockoutState: G100LockoutState;
  id: Scalars["ID"]["output"];
  serverConfigTime: Maybe<Scalars["BigInt"]["output"]>;
};

export type Zappi2EditableBoostTimer = {
  __typename?: "Zappi2EditableBoostTimer";
  duration: Maybe<Scalars["Float"]["output"]>;
  fridayOn: Maybe<Scalars["Boolean"]["output"]>;
  mondayOn: Maybe<Scalars["Boolean"]["output"]>;
  saturdayOn: Maybe<Scalars["Boolean"]["output"]>;
  slot: Scalars["Int"]["output"];
  startHour: Maybe<Scalars["Float"]["output"]>;
  startMinute: Maybe<Scalars["Float"]["output"]>;
  sundayOn: Maybe<Scalars["Boolean"]["output"]>;
  thursdayOn: Maybe<Scalars["Boolean"]["output"]>;
  tuesdayOn: Maybe<Scalars["Boolean"]["output"]>;
  wednesdayOn: Maybe<Scalars["Boolean"]["output"]>;
};

export type Zappi2EditableBoostTimerInput = {
  duration?: InputMaybe<Scalars["Float"]["input"]>;
  fridayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  mondayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  saturdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  slot: Scalars["Int"]["input"];
  startHour?: InputMaybe<Scalars["Float"]["input"]>;
  startMinute?: InputMaybe<Scalars["Float"]["input"]>;
  sundayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  thursdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  tuesdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  wednesdayOn?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Zappi2EditableConfig = {
  __typename?: "Zappi2EditableConfig";
  backlight: Maybe<Scalars["Float"]["output"]>;
  batteryDischargeEnabled: Maybe<Scalars["Boolean"]["output"]>;
  batteryMode: Maybe<BatteryMode>;
  boostTimers: Maybe<Array<Zappi2EditableBoostTimer>>;
  chargeComplete: Maybe<Zappi2EditableRgb>;
  chargeCompleteDelay: Maybe<Scalars["Float"]["output"]>;
  chargeWhenPINLocked: Maybe<Scalars["Boolean"]["output"]>;
  compatibilityModeActive: Maybe<Scalars["Boolean"]["output"]>;
  compatibilityModeMinPWM: Maybe<Scalars["Float"]["output"]>;
  compatibilityModePowerFactor: Maybe<Scalars["Float"]["output"]>;
  contrast: Maybe<Scalars["Float"]["output"]>;
  ct1GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct1Type: Maybe<CtTypes>;
  ct2GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct2Type: Maybe<CtTypes>;
  ct3GroupLimit: Maybe<Scalars["Int"]["output"]>;
  ct3Type: Maybe<CtTypes>;
  ct4GroupLimit: Maybe<Scalars["Float"]["output"]>;
  ctDetection: Maybe<Scalars["Boolean"]["output"]>;
  ctExternal1Group: Maybe<Scalars["Float"]["output"]>;
  ctExternal2Group: Maybe<Scalars["Float"]["output"]>;
  ctExternal3Group: Maybe<Scalars["Float"]["output"]>;
  ctInternal1Group: Maybe<Scalars["Float"]["output"]>;
  ctInternal2Group: Maybe<Scalars["Float"]["output"]>;
  ctInternal3Group: Maybe<Scalars["Float"]["output"]>;
  ctPrimary: Maybe<Scalars["Float"]["output"]>;
  dateFormat: Maybe<DateFormat>;
  defaultMode: Maybe<DefaultMode>;
  deviceLimitAmps: Maybe<Scalars["Float"]["output"]>;
  dirtyCharging: Maybe<Zappi2EditableRgb>;
  dstOn: Maybe<Scalars["Boolean"]["output"]>;
  eSenseInput: Maybe<ESenseInput>;
  earthing: Maybe<Earthing>;
  ecoMode: Maybe<ZappiEcoModePhaseSetting>;
  ecopStopDelay: Maybe<Scalars["Float"]["output"]>;
  esenseLimitPWM: Maybe<Scalars["Float"]["output"]>;
  exportLimit: Maybe<Scalars["Int"]["output"]>;
  exportMargin: Maybe<Scalars["Float"]["output"]>;
  fault: Maybe<Zappi2EditableRgb>;
  greenCharging: Maybe<Zappi2EditableRgb>;
  gridLimit: Maybe<Scalars["Int"]["output"]>;
  gridPowerLimit: Maybe<Scalars["Float"]["output"]>;
  icons: Maybe<GenTypeIconZappi>;
  language: Maybe<Language>;
  ledBrightness: Maybe<Scalars["Float"]["output"]>;
  lockAutohide: Maybe<Scalars["Boolean"]["output"]>;
  lockCode: Maybe<Scalars["String"]["output"]>;
  lockEVPluggedIn: Maybe<Scalars["Boolean"]["output"]>;
  lockEVUnplugged: Maybe<Scalars["Boolean"]["output"]>;
  lockSolenoidPWM: Maybe<Scalars["Float"]["output"]>;
  lockTimeout: Maybe<Scalars["Float"]["output"]>;
  mainSwitchPWM: Maybe<Scalars["Float"]["output"]>;
  manualBoost: Maybe<Scalars["Float"]["output"]>;
  masterLostDetection: Maybe<Scalars["Boolean"]["output"]>;
  masterLostThreshold: Maybe<Scalars["Int"]["output"]>;
  minGreenLevel: Maybe<Scalars["Float"]["output"]>;
  mixedCharging: Maybe<Zappi2EditableRgb>;
  monitoringStatus: Maybe<Scalars["Boolean"]["output"]>;
  neutralLimit: Maybe<Scalars["Int"]["output"]>;
  pERelayPWM: Maybe<Scalars["Float"]["output"]>;
  passcode: Maybe<Scalars["String"]["output"]>;
  phaseReturn: Maybe<PhaseReturn>;
  plugInCharge: Maybe<Scalars["Boolean"]["output"]>;
  powerLimit: Maybe<Scalars["Int"]["output"]>;
  preconEnergy: Maybe<Scalars["Float"]["output"]>;
  preconOn: Maybe<Scalars["Boolean"]["output"]>;
  randomDelayStart: Maybe<Scalars["Float"]["output"]>;
  relay1PWM: Maybe<Scalars["Float"]["output"]>;
  relay2PWM: Maybe<Scalars["Float"]["output"]>;
  setBuzzer: Maybe<Scalars["Boolean"]["output"]>;
  smartBoostEnergy: Maybe<Scalars["Float"]["output"]>;
  smartBoostHour: Maybe<Scalars["Float"]["output"]>;
  smartBoostMinute: Maybe<Scalars["Float"]["output"]>;
  startStopDelay: Maybe<Scalars["Float"]["output"]>;
  stateB: Maybe<Zappi2EditableRgb>;
  timeFromCloud: Maybe<Scalars["Boolean"]["output"]>;
  timeZone: Maybe<TimeZone>;
  weldedRelayCheckDelay: Maybe<Scalars["Float"]["output"]>;
};

export type Zappi2EditableConfigInput = {
  backlight?: InputMaybe<Scalars["Float"]["input"]>;
  batteryDischargeEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  batteryMode?: InputMaybe<BatteryMode>;
  boostTimers?: InputMaybe<Array<Zappi2EditableBoostTimerInput>>;
  chargeComplete?: InputMaybe<Zappi2EditableRgbInput>;
  chargeCompleteDelay?: InputMaybe<Scalars["Float"]["input"]>;
  chargeWhenPINLocked?: InputMaybe<Scalars["Boolean"]["input"]>;
  compatibilityModeActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  compatibilityModeMinPWM?: InputMaybe<Scalars["Float"]["input"]>;
  compatibilityModePowerFactor?: InputMaybe<Scalars["Float"]["input"]>;
  contrast?: InputMaybe<Scalars["Float"]["input"]>;
  ct1GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct1Type?: InputMaybe<CtTypes>;
  ct2GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct2Type?: InputMaybe<CtTypes>;
  ct3GroupLimit?: InputMaybe<Scalars["Int"]["input"]>;
  ct3Type?: InputMaybe<CtTypes>;
  ct4GroupLimit?: InputMaybe<Scalars["Float"]["input"]>;
  ctDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  ctExternal1Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctExternal2Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctExternal3Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctInternal1Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctInternal2Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctInternal3Group?: InputMaybe<Scalars["Float"]["input"]>;
  ctPrimary?: InputMaybe<Scalars["Float"]["input"]>;
  dateFormat?: InputMaybe<DateFormat>;
  defaultMode?: InputMaybe<DefaultMode>;
  deviceLimitAmps?: InputMaybe<Scalars["Float"]["input"]>;
  dirtyCharging?: InputMaybe<Zappi2EditableRgbInput>;
  dstOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  eSenseInput?: InputMaybe<ESenseInput>;
  earthing?: InputMaybe<Earthing>;
  ecoMode?: InputMaybe<ZappiEcoModePhaseSetting>;
  ecopStopDelay?: InputMaybe<Scalars["Float"]["input"]>;
  esenseLimitPWM?: InputMaybe<Scalars["Float"]["input"]>;
  exportLimit?: InputMaybe<Scalars["Int"]["input"]>;
  exportMargin?: InputMaybe<Scalars["Float"]["input"]>;
  fault?: InputMaybe<Zappi2EditableRgbInput>;
  greenCharging?: InputMaybe<Zappi2EditableRgbInput>;
  gridLimit?: InputMaybe<Scalars["Int"]["input"]>;
  gridPowerLimit?: InputMaybe<Scalars["Float"]["input"]>;
  icons?: InputMaybe<GenTypeIconZappi>;
  language?: InputMaybe<Language>;
  ledBrightness?: InputMaybe<Scalars["Float"]["input"]>;
  lockAutohide?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockCode?: InputMaybe<Scalars["String"]["input"]>;
  lockEVPluggedIn?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockEVUnplugged?: InputMaybe<Scalars["Boolean"]["input"]>;
  lockSolenoidPWM?: InputMaybe<Scalars["Float"]["input"]>;
  lockTimeout?: InputMaybe<Scalars["Float"]["input"]>;
  mainSwitchPWM?: InputMaybe<Scalars["Float"]["input"]>;
  manualBoost?: InputMaybe<Scalars["Float"]["input"]>;
  masterLostDetection?: InputMaybe<Scalars["Boolean"]["input"]>;
  masterLostThreshold?: InputMaybe<Scalars["Int"]["input"]>;
  minGreenLevel?: InputMaybe<Scalars["Float"]["input"]>;
  mixedCharging?: InputMaybe<Zappi2EditableRgbInput>;
  monitoringStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
  neutralLimit?: InputMaybe<Scalars["Int"]["input"]>;
  pERelayPWM?: InputMaybe<Scalars["Float"]["input"]>;
  passcode?: InputMaybe<Scalars["String"]["input"]>;
  phaseReturn?: InputMaybe<PhaseReturn>;
  plugInCharge?: InputMaybe<Scalars["Boolean"]["input"]>;
  powerLimit?: InputMaybe<Scalars["Int"]["input"]>;
  preconEnergy?: InputMaybe<Scalars["Float"]["input"]>;
  preconOn?: InputMaybe<Scalars["Boolean"]["input"]>;
  randomDelayStart?: InputMaybe<Scalars["Float"]["input"]>;
  relay1PWM?: InputMaybe<Scalars["Float"]["input"]>;
  relay2PWM?: InputMaybe<Scalars["Float"]["input"]>;
  setBuzzer?: InputMaybe<Scalars["Boolean"]["input"]>;
  smartBoostEnergy?: InputMaybe<Scalars["Float"]["input"]>;
  smartBoostHour?: InputMaybe<Scalars["Float"]["input"]>;
  smartBoostMinute?: InputMaybe<Scalars["Float"]["input"]>;
  startStopDelay?: InputMaybe<Scalars["Float"]["input"]>;
  stateB?: InputMaybe<Zappi2EditableRgbInput>;
  timeFromCloud?: InputMaybe<Scalars["Boolean"]["input"]>;
  timeZone?: InputMaybe<TimeZone>;
  weldedRelayCheckDelay?: InputMaybe<Scalars["Float"]["input"]>;
};

export type Zappi2EditableRgb = {
  __typename?: "Zappi2EditableRgb";
  blue: Maybe<Scalars["Int"]["output"]>;
  green: Maybe<Scalars["Int"]["output"]>;
  red: Maybe<Scalars["Int"]["output"]>;
};

export type Zappi2EditableRgbInput = {
  blue?: InputMaybe<Scalars["Int"]["input"]>;
  green?: InputMaybe<Scalars["Int"]["input"]>;
  red?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ZappiConfigReply = {
  __typename?: "ZappiConfigReply";
  id: Scalars["ID"]["output"];
  rapidZappiConfigReplyData: Maybe<RapidZappiConfigPartial>;
  zappi1ConfigReplyData: Maybe<Zappi1ConfigPartial>;
  zappi2ConfigReplyData: Maybe<Zappi2ConfigPartial>;
};

export enum ZappiEcoModePhaseSetting {
  ECO_SINGLE_AND_ECO_PLUS_AUTO = "ECO_SINGLE_AND_ECO_PLUS_AUTO",
  ECO_SINGLE_AND_ECO_PLUS_SINGLE = "ECO_SINGLE_AND_ECO_PLUS_SINGLE",
  ECO_THREE_AND_ECO_PLUS_AUTO = "ECO_THREE_AND_ECO_PLUS_AUTO",
  ECO_THREE_AND_ECO_PLUS_THREE = "ECO_THREE_AND_ECO_PLUS_THREE",
}

export type ZappiLockedStatus = {
  __typename?: "ZappiLockedStatus";
  chargeSessionAllowed: Maybe<Scalars["Boolean"]["output"]>;
  chargeWhenLocked: Maybe<Scalars["Boolean"]["output"]>;
  lockWhenPluggedIn: Maybe<Scalars["Boolean"]["output"]>;
  lockWhenUnplugged: Maybe<Scalars["Boolean"]["output"]>;
  lockedNow: Maybe<Scalars["Boolean"]["output"]>;
  microprocessorTI: Maybe<Scalars["Boolean"]["output"]>;
};

export type ZappiModeInput = {
  boostOn: BoostEnum;
  commandModeNo: SetZappiModeCommand;
  kWh: Scalars["Float"]["input"];
  targetTime: TargetTimeGql;
};

export type ZappiMonitoringJStatus = {
  __typename?: "ZappiMonitoringJStatus";
  batteryDischargeEnabled: Scalars["Boolean"]["output"];
  beingTamperedWith: Maybe<Scalars["Boolean"]["output"]>;
  bsm: Maybe<Scalars["Int"]["output"]>;
  bss: Maybe<Scalars["Int"]["output"]>;
  bst: Maybe<Scalars["Int"]["output"]>;
  che: Maybe<Scalars["Int"]["output"]>;
  dat: Scalars["String"]["output"];
  deviceClass: Scalars["String"]["output"];
  div: Maybe<Scalars["Int"]["output"]>;
  dst: Maybe<Scalars["Int"]["output"]>;
  ect1p: Maybe<Scalars["Int"]["output"]>;
  ect2p: Maybe<Scalars["Int"]["output"]>;
  ect3p: Maybe<Scalars["Int"]["output"]>;
  ectp1: Maybe<Scalars["Int"]["output"]>;
  ectp2: Maybe<Scalars["Int"]["output"]>;
  ectp3: Maybe<Scalars["Int"]["output"]>;
  ectp4: Maybe<Scalars["Int"]["output"]>;
  ectp5: Maybe<Scalars["Int"]["output"]>;
  ectp6: Maybe<Scalars["Int"]["output"]>;
  ectt1: Maybe<Scalars["String"]["output"]>;
  ectt2: Maybe<Scalars["String"]["output"]>;
  ectt3: Maybe<Scalars["String"]["output"]>;
  ectt4: Maybe<Scalars["String"]["output"]>;
  ectt5: Maybe<Scalars["String"]["output"]>;
  ectt6: Maybe<Scalars["String"]["output"]>;
  frq: Maybe<Scalars["Float"]["output"]>;
  g100LockoutState: G100LockoutState;
  gen: Maybe<Scalars["Int"]["output"]>;
  grd: Maybe<Scalars["Int"]["output"]>;
  lck: Maybe<Scalars["Int"]["output"]>;
  mgl: Maybe<Scalars["Int"]["output"]>;
  pha: Maybe<Scalars["Int"]["output"]>;
  pri: Maybe<Scalars["Int"]["output"]>;
  pst: Maybe<Scalars["String"]["output"]>;
  pwm: Maybe<Scalars["Int"]["output"]>;
  rac: Maybe<Scalars["Int"]["output"]>;
  rdc: Maybe<Scalars["Int"]["output"]>;
  rrac: Maybe<Scalars["Int"]["output"]>;
  sbh: Maybe<Scalars["Int"]["output"]>;
  sbk: Maybe<Scalars["Int"]["output"]>;
  sbm: Maybe<Scalars["Int"]["output"]>;
  sno: Scalars["Int"]["output"];
  sta: Maybe<Scalars["Int"]["output"]>;
  tbk: Maybe<Scalars["Int"]["output"]>;
  tim: Scalars["String"]["output"];
  tz: Maybe<Scalars["Int"]["output"]>;
  vol: Maybe<Scalars["Int"]["output"]>;
  zmo: Maybe<Scalars["Int"]["output"]>;
  zs: Maybe<Scalars["Int"]["output"]>;
  zsh: Maybe<Scalars["Int"]["output"]>;
  zsl: Maybe<Scalars["Int"]["output"]>;
};

export enum ZappiVariant {
  ZAPPI_1 = "ZAPPI_1",
  ZAPPI_2 = "ZAPPI_2",
}

export type HarviMonitoringJStatus = {
  __typename?: "harviMonitoringJStatus";
  bsm: Maybe<Scalars["Int"]["output"]>;
  bst: Maybe<Scalars["Int"]["output"]>;
  dat: Scalars["String"]["output"];
  deviceClass: Scalars["String"]["output"];
  div: Maybe<Scalars["Int"]["output"]>;
  ect1p: Maybe<Scalars["Int"]["output"]>;
  ect2p: Maybe<Scalars["Int"]["output"]>;
  ect3p: Maybe<Scalars["Int"]["output"]>;
  ectp1: Maybe<Scalars["Int"]["output"]>;
  ectp2: Maybe<Scalars["Int"]["output"]>;
  ectp3: Maybe<Scalars["Int"]["output"]>;
  ectp4: Maybe<Scalars["Int"]["output"]>;
  ectp5: Maybe<Scalars["Int"]["output"]>;
  ectp6: Maybe<Scalars["Int"]["output"]>;
  ectt1: Maybe<Scalars["String"]["output"]>;
  ectt2: Maybe<Scalars["String"]["output"]>;
  ectt3: Maybe<Scalars["String"]["output"]>;
  ectt4: Maybe<Scalars["String"]["output"]>;
  ectt5: Maybe<Scalars["String"]["output"]>;
  ectt6: Maybe<Scalars["String"]["output"]>;
  frq: Maybe<Scalars["Float"]["output"]>;
  gen: Maybe<Scalars["Int"]["output"]>;
  grd: Maybe<Scalars["Int"]["output"]>;
  pha: Maybe<Scalars["Int"]["output"]>;
  pri: Maybe<Scalars["Int"]["output"]>;
  sno: Scalars["Int"]["output"];
  sta: Maybe<Scalars["Int"]["output"]>;
  tim: Scalars["String"]["output"];
  tz: Maybe<Scalars["Int"]["output"]>;
  vol: Maybe<Scalars["Int"]["output"]>;
};

export type GetHubProductDetailsQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetHubProductDetailsQuery = {
  __typename?: "Query";
  hubDetails: {
    __typename?: "Hub";
    serialNo: any;
    currentVersion: number | null;
    updatedAt: any;
    eddis: Array<{
      __typename?: "Eddi";
      serialNo: any;
      currentVersion: number | null;
      updatedAt: any;
      deviceInfo: { __typename?: "DeviceInfo"; deviceName: string };
    }>;
    zappis: Array<{
      __typename?: "Zappi";
      serialNo: any;
      currentVersion: number | null;
      updatedAt: any;
      deviceInfo: { __typename?: "DeviceInfo"; deviceName: string };
    }>;
    harvis: Array<{
      __typename?: "Harvi";
      serialNo: any;
      currentVersion: number | null;
      updatedAt: any;
      deviceInfo: { __typename?: "DeviceInfo"; deviceName: string };
    }>;
    libbis: Array<{
      __typename?: "Libbi";
      serialNo: any;
      currentVersion: number | null;
      updatedAt: any;
      deviceInfo: { __typename?: "DeviceInfo"; deviceName: string };
    }>;
  } | null;
};

export type GetDashboardInfoQueryVariables = Exact<{
  timezone: Scalars["String"]["input"];
}>;

export type GetDashboardInfoQuery = {
  __typename?: "Query";
  dashboardInfo: {
    __typename?: "DashBoardInfo";
    activeAppUsers: number;
    numberOfHubs: number;
    numberOfZappis: number;
    numberOfEddis: number;
    numberOfLibbis: number;
    numberOfHarvis: number;
    numberOfLiveHubs: number;
    numberOfLiveZappis: number;
    numberOfLiveEddis: number;
    numberOfLiveLibbis: number;
    numberOfLiveHarvis: number;
    numberOfYesterdayHubs: number;
    numberOfYesterdayZappis: number;
    numberOfYesterdayEddis: number;
    numberOfYesterdayLibbis: number;
    numberOfYesterdayHarvis: number;
    numberOfLastWeekHubs: number;
    numberOfLastWeekZappis: number;
    numberOfLastWeekEddis: number;
    numberOfLastWeekHarvis: number;
    numberOfLastWeekLibbis: number;
  };
};

export type SetDeviceChannelMutationVariables = Exact<{
  input: SetDeviceChannelInput;
}>;

export type SetDeviceChannelMutation = {
  __typename?: "Mutation";
  setDeviceChannel: boolean;
};

export type ManageFileApprovalMutationVariables = Exact<{
  input: ManageFileApprovalInput;
}>;

export type ManageFileApprovalMutation = {
  __typename?: "Mutation";
  manageFileApproval: boolean;
};

export type StartFirmwareReleaseMutationVariables = Exact<{
  input: StartFirmwareReleaseInput;
}>;

export type StartFirmwareReleaseMutation = {
  __typename?: "Mutation";
  startFirmwareRelease: string;
};

export type EndFirmwareReleaseMutationVariables = Exact<{
  input: EndFirmwareReleaseInput;
}>;

export type EndFirmwareReleaseMutation = {
  __typename?: "Mutation";
  endFirmwareRelease: string;
};

export type GetUploadFirmwareUrlQueryVariables = Exact<{
  fileName: Scalars["String"]["input"];
  md5Base64: Scalars["String"]["input"];
}>;

export type GetUploadFirmwareUrlQuery = {
  __typename?: "Query";
  getUploadFirmwareUrl: { __typename?: "UploadFirmwareUrl"; url: string };
};

export type GetFirmwareFilesQueryVariables = Exact<{
  upc: Scalars["String"]["input"];
  limit: InputMaybe<Scalars["Int"]["input"]>;
  cursor: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetFirmwareFilesQuery = {
  __typename?: "Query";
  getFirmwareFiles: {
    __typename?: "FirmwareFilesResult";
    cursor: string | null;
    results: Array<{
      __typename?: "FirmwareFile";
      fileName: string;
      fileMd5: string;
      version: string;
      sizeBytes: number;
      releaseNotes: string | null;
      createdAt: string;
      approval: {
        __typename?: "Approval";
        state: string;
        history: Array<{
          __typename?: "FirmwareFileApprovalHistory";
          state: string;
          userEmail: string;
          date: string;
          reason: string | null;
        }>;
      };
    }>;
  };
};

export type GetDeviceChannelsQueryVariables = Exact<{
  upc: Scalars["String"]["input"];
  channel: Scalars["String"]["input"];
  limit: Scalars["Int"]["input"];
  cursor: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetDeviceChannelsQuery = {
  __typename?: "Query";
  getDeviceChannels: {
    __typename?: "DeviceChannelsResult";
    cursor: string | null;
    results: Array<{
      __typename?: "DeviceChannel";
      uid: string;
      serialNo: number;
      notes: string | null;
      setByEmail: string;
    }>;
  };
};

export type GetProductsFirmwareVersionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetProductsFirmwareVersionsQuery = {
  __typename?: "Query";
  getProductsFirmwareVersions: {
    __typename?: "GetProductsFirmwareVersionsResult";
    results: Array<any>;
  };
};

export type MutateHubMutationVariables = Exact<{
  updatedHub: UpdatedHubInput;
}>;

export type MutateHubMutation = { __typename?: "Mutation"; mutateHub: boolean };

export type HubDeregisterMutationVariables = Exact<{
  serialNo: Scalars["BigInt"]["input"];
}>;

export type HubDeregisterMutation = {
  __typename?: "Mutation";
  hubDeregister: boolean;
};

export type DeleteDeviceMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  deviceType: DeviceType;
}>;

export type DeleteDeviceMutation = {
  __typename?: "Mutation";
  deleteDevice: boolean;
};

export type DeleteInitialCommandsMutationVariables = Exact<{
  deviceName: DeviceName;
  serialNo: Scalars["Int"]["input"];
  hubSerialNo: Scalars["Int"]["input"];
}>;

export type DeleteInitialCommandsMutation = {
  __typename?: "Mutation";
  deleteInitialCommands: {
    __typename?: "InitialCommandsDeletionResult";
    deletedFromRedisCount: number;
    deletedFromPostgresCount: number;
  };
};

export type DownloadBootloaderMutationVariables = Exact<{
  serialNo: Scalars["BigInt"]["input"];
  deviceName: DeviceName;
}>;

export type DownloadBootloaderMutation = {
  __typename?: "Mutation";
  downloadBootloader: boolean;
};

export type ForceRebootMutationVariables = Exact<{
  serialNo: Scalars["BigInt"]["input"];
  deviceName: DeviceName;
}>;

export type ForceRebootMutation = {
  __typename?: "Mutation";
  forceReboot: boolean;
};

export type ForceBackgroundDownloadMutationVariables = Exact<{
  serialNo: Scalars["BigInt"]["input"];
  deviceName: DeviceName;
}>;

export type ForceBackgroundDownloadMutation = {
  __typename?: "Mutation";
  forceBackgroundDownload: boolean;
};

export type ForceInstallMutationVariables = Exact<{
  serialNo: Scalars["BigInt"]["input"];
  deviceName: DeviceName;
}>;

export type ForceInstallMutation = {
  __typename?: "Mutation";
  forceInstallApp: boolean;
};

export type LibbiInverterCommandMutationVariables = Exact<{
  commandType: LibbiInverterCommandType;
  serialNo: Scalars["Float"]["input"];
}>;

export type LibbiInverterCommandMutation = {
  __typename?: "Mutation";
  setLibbiInverterCommand: boolean;
};

export type SetLibbiCombinedInverterUpdateCommandMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  updateType: BaudRateInstallType;
}>;

export type SetLibbiCombinedInverterUpdateCommandMutation = {
  __typename?: "Mutation";
  setLibbiCombinedInverterUpdateCommand: boolean;
};

export type ForceInstallBootloaderMutationVariables = Exact<{
  serialNo: Scalars["BigInt"]["input"];
  deviceName: DeviceName;
}>;

export type ForceInstallBootloaderMutation = {
  __typename?: "Mutation";
  installBootloader: boolean;
};

export type G100ResetMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  deviceName: DeviceName;
  resetType: G100ResetType;
}>;

export type G100ResetMutation = { __typename?: "Mutation"; g100Reset: boolean };

export type SetLibbiConfigMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  config: LibbiEditableConfigInput;
}>;

export type SetLibbiConfigMutation = {
  __typename?: "Mutation";
  setLibbiConfig: {
    __typename?: "SetDeviceConfigResult";
    success: boolean;
    validationIssues: Array<{
      __typename?: "SetDeviceConfigIssue";
      path: Array<string> | null;
      message: string;
    }> | null;
  };
};

export type SetZappi2ConfigMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  config: Zappi2EditableConfigInput;
}>;

export type SetZappi2ConfigMutation = {
  __typename?: "Mutation";
  setZappi2Config: {
    __typename?: "SetDeviceConfigResult";
    success: boolean;
    validationIssues: Array<{
      __typename?: "SetDeviceConfigIssue";
      path: Array<string> | null;
      message: string;
    }> | null;
  };
};

export type SetRapidZappiConfigMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  config: RapidZappiEditableConfigInput;
}>;

export type SetRapidZappiConfigMutation = {
  __typename?: "Mutation";
  setRapidZappiConfig: {
    __typename?: "SetDeviceConfigResult";
    success: boolean;
    validationIssues: Array<{
      __typename?: "SetDeviceConfigIssue";
      path: Array<string> | null;
      message: string;
    }> | null;
  };
};

export type SetEddiConfigMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  config: EddiEditableConfigInput;
}>;

export type SetEddiConfigMutation = {
  __typename?: "Mutation";
  setEddiConfig: {
    __typename?: "SetDeviceConfigResult";
    success: boolean;
    validationIssues: Array<{
      __typename?: "SetDeviceConfigIssue";
      path: Array<string> | null;
      message: string;
    }> | null;
  };
};

export type SetEddiPlusConfigMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  config: EddiPlusEditableConfigInput;
}>;

export type SetEddiPlusConfigMutation = {
  __typename?: "Mutation";
  setEddiPlusConfig: {
    __typename?: "SetDeviceConfigResult";
    success: boolean;
    validationIssues: Array<{
      __typename?: "SetDeviceConfigIssue";
      path: Array<string> | null;
      message: string;
    }> | null;
  };
};

export type SetMonitoringConfigMutationVariables = Exact<{
  hubSerial: Scalars["Float"]["input"];
  active: Scalars["Boolean"]["input"];
  extendTimeDays: Scalars["Float"]["input"];
}>;

export type SetMonitoringConfigMutation = {
  __typename?: "Mutation";
  setMonitoringConfig: string;
};

export type ReadG100EventsMutationVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  deviceName: DeviceName;
}>;

export type ReadG100EventsMutation = {
  __typename?: "Mutation";
  readG100Events: boolean;
};

export type SetOcppConfigMutationVariables = Exact<{
  input: OcppConfigurationInput;
}>;

export type SetOcppConfigMutation = {
  __typename?: "Mutation";
  setOcppConfig: { __typename?: "SetOcppConfigResult"; success: boolean };
};

export type DeleteOcppChargingProfileMutationVariables = Exact<{
  input: DeleteOcppChargingProfileInput;
}>;

export type DeleteOcppChargingProfileMutation = {
  __typename?: "Mutation";
  deleteOcppChargingProfile: {
    __typename?: "DeleteOcppChargingProfileResult";
    success: string;
  };
};

export type ForceConfigReadMutationVariables = Exact<{
  serialNo: Scalars["Int"]["input"];
  deviceType: DeviceType;
  structureId: Scalars["String"]["input"];
}>;

export type ForceConfigReadMutation = {
  __typename?: "Mutation";
  forceConfigRead: boolean;
};

export type GetHubsQueryVariables = Exact<{
  input: PaginatedSearchInput;
}>;

export type GetHubsQuery = {
  __typename?: "Query";
  hubs: {
    __typename?: "PaginatedSearchFindHubRowGqlResponse";
    totalCount: number;
    rows: Array<{
      __typename?: "FindHubRowGql";
      serialNo: any;
      currentVersion: number | null;
      isBlocked: boolean;
      registered: boolean;
      productCode: string;
      eddis: Array<{
        __typename?: "FindHubRowEddi";
        serialNo: any;
        variant: EddiVariant;
      }>;
      zappis: Array<{
        __typename?: "FindHubRowZappi";
        serialNo: any;
        variant: ZappiVariant;
      }>;
      harvis: Array<{ __typename?: "FindHubRowHarvi"; serialNo: any }>;
      libbis: Array<{ __typename?: "FindHubRowLibbi"; serialNo: any }>;
    }>;
  };
};

export type DsrFragmentFragment = {
  __typename?: "DsrData";
  load: number | null;
  seconds: number | null;
  csn: number | null;
  ack: boolean | null;
  lce: boolean | null;
  lca: boolean | null;
  fue: boolean | null;
  fde: boolean | null;
  fua: boolean | null;
  fda: boolean | null;
  fun: boolean | null;
  fdn: boolean | null;
  daf: number | null;
  ddf: number | null;
  uaf: number | null;
  udf: number | null;
};

export type CtFragmentFragment = {
  __typename?: "CtData";
  ctNumber: number;
  phase: string | null;
  type: string | null;
  current: number | null;
  power: number | null;
  isValid: boolean | null;
};

export type GetHubDetailsQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetHubDetailsQuery = {
  __typename?: "Query";
  hubDetails: {
    __typename?: "Hub";
    encrypted: boolean;
    serialNo: any;
    createdAt: any;
    updatedAt: any;
    regPassword: string;
    registrationDate: any | null;
    uptime: number | null;
    serverLastHeard: number | null;
    currentVersion: number | null;
    lastAuth: any | null;
    isBlocked: boolean;
    blockedReason: string | null;
    networkId: number;
    noDevices: number | null;
    port: number;
    iPAddress: string | null;
    keyValueStore: any | null;
    australia: boolean;
    radioChannel: number | null;
    vHub: boolean | null;
    hasBeenConnected: boolean;
    masterDeviceRawAddress: number | null;
    deviceInfo: {
      __typename?: "DeviceInfo";
      deviceName: string;
      productCode: string;
    };
    hubFirmwareVersions: Array<{
      __typename?: "HubFirmwareVersions";
      optionCode: number;
      versionCode: number;
      productName: string;
      productCode: number;
    }> | null;
    loadControl: {
      __typename?: "LoadControl";
      updatedAt: any | null;
      gridImportExport: number | null;
      generation: number | null;
      deviceLoads: Array<{
        __typename?: "DeviceLoad";
        serialNo: number;
        setLoad: number;
      }>;
      flags: { __typename?: "LoadControlFlags"; netPhases: boolean | null };
    };
    cloudIPOverrideServer: { __typename?: "Server"; id: string } | null;
    frequencyResponse: {
      __typename?: "FrequencyResponse";
      DAF: number;
      DDF: number;
      UAF: number;
      UDF: number;
    };
    eddis: Array<{
      __typename?: "Eddi";
      newAppAvailable: boolean | null;
      newBootloaderAvailable: boolean | null;
      currentVersion: number | null;
      wifiFirmwareVersion: number | null;
      melibVersion: number | null;
      melinkVersion: number | null;
      stubLoaderVersion: number | null;
      bootLoaderVersion: number | null;
      deviceAddressRaw: number;
      serialNo: any;
      updatedAt: any;
      createdAt: any;
      gridPower: number | null;
      generatorPower: number | null;
      ethernetLink: boolean | null;
      wifiLink: boolean | null;
      deviceConfigTime: any | null;
      serverConfigTime: any | null;
      diverted: number;
      voltage: number | null;
      frequency: number | null;
      commandSeqNo: number;
      state: string | null;
      vHub: boolean | null;
      microprocessorTI: boolean | null;
      gridCTPhase1Fitted: boolean;
      gridCTPhase2Fitted: boolean;
      gridCTPhase3Fitted: boolean;
      isThreePhase: boolean;
      priority: number | null;
      heaterType1: string | null;
      heaterType2: string | null;
      deviceInfo: {
        __typename?: "DeviceInfo";
        deviceName: string;
        productCode: string;
      };
      configReply: {
        __typename?: "EddiConfigReply";
        id: string;
        eddiConfigReplyData: {
          __typename?: "EddiConfigPartial";
          id: string;
          serverConfigTime: any | null;
          deviceConfigTime: any;
          g100LockoutState: G100LockoutState;
        } | null;
        eddiPlusConfigReplyData: {
          __typename?: "EddiPlusConfigPartial";
          id: string;
          serverConfigTime: any | null;
          deviceConfigTime: any;
          g100LockoutState: G100LockoutState;
          heatersAvailableCount: number;
        } | null;
      } | null;
      dsrData: {
        __typename?: "DsrData";
        load: number | null;
        seconds: number | null;
        csn: number | null;
        ack: boolean | null;
        lce: boolean | null;
        lca: boolean | null;
        fue: boolean | null;
        fde: boolean | null;
        fua: boolean | null;
        fda: boolean | null;
        fun: boolean | null;
        fdn: boolean | null;
        daf: number | null;
        ddf: number | null;
        uaf: number | null;
        udf: number | null;
      };
      ct1: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct2: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct3: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct4: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct5: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct6: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      pt1: {
        __typename?: "PtData";
        ptNumber: number;
        temp: number | null;
      } | null;
      pt2: {
        __typename?: "PtData";
        ptNumber: number;
        temp: number | null;
      } | null;
    }>;
    zappis: Array<{
      __typename?: "Zappi";
      newAppAvailable: boolean | null;
      newBootloaderAvailable: boolean | null;
      serialNo: any;
      currentVersion: number | null;
      wifiFirmwareVersion: number | null;
      melibVersion: number | null;
      melinkVersion: number | null;
      stubLoaderVersion: number | null;
      bootLoaderVersion: number | null;
      deviceAddressRaw: number;
      updatedAt: any;
      createdAt: any;
      chargeEnergy: number | null;
      diverted: number;
      voltage: number | null;
      frequency: number | null;
      commandSeqNo: number;
      pilotState: string | null;
      zappiMode: string | null;
      priority: number | null;
      state: string | null;
      gridPower: number | null;
      generatorPower: number | null;
      ethernetLink: boolean | null;
      wifiLink: boolean | null;
      vHub: boolean | null;
      gridCTPhase1Fitted: boolean;
      gridCTPhase2Fitted: boolean;
      gridCTPhase3Fitted: boolean;
      isThreePhase: boolean;
      deviceInfo: {
        __typename?: "DeviceInfo";
        deviceName: string;
        productCode: string;
      };
      connectivityStatus: {
        __typename?: "ThingConnectivity";
        connected: boolean | null;
        disconnectReason: string | null;
        timestamp: string | null;
      } | null;
      dsrData: {
        __typename?: "DsrData";
        load: number | null;
        seconds: number | null;
        csn: number | null;
        ack: boolean | null;
        lce: boolean | null;
        lca: boolean | null;
        fue: boolean | null;
        fde: boolean | null;
        fua: boolean | null;
        fda: boolean | null;
        fun: boolean | null;
        fdn: boolean | null;
        daf: number | null;
        ddf: number | null;
        uaf: number | null;
        udf: number | null;
      };
      lockedStatus: {
        __typename?: "ZappiLockedStatus";
        microprocessorTI: boolean | null;
        lockedNow: boolean | null;
      };
      configReply: {
        __typename?: "ZappiConfigReply";
        id: string;
        zappi1ConfigReplyData: {
          __typename?: "Zappi1ConfigPartial";
          id: string;
          deviceConfigTime: any;
        } | null;
        zappi2ConfigReplyData: {
          __typename?: "Zappi2ConfigPartial";
          id: string;
          serverConfigTime: any | null;
          deviceConfigTime: any;
          g100LockoutState: G100LockoutState;
        } | null;
        rapidZappiConfigReplyData: {
          __typename?: "RapidZappiConfigPartial";
          id: string;
          serverConfigTime: any | null;
          deviceConfigTime: any;
          g100LockoutState: G100LockoutState;
        } | null;
      } | null;
      ct1: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct2: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct3: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct4: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct5: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct6: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      pwmData: {
        __typename?: "PulseWidthModulationData";
        stateCpu: number | null;
        stateRCDBoard: number | null;
        pulseWidthModulationInPercentage: number | null;
        rcdDCInNanoAmps: number | null;
        rcdACInNanoAmps: number | null;
        returnRcdACInNanoAmps: number | null;
        state: string | null;
        stateEngineVersion: number | null;
      };
    }>;
    harvis: Array<{
      __typename?: "Harvi";
      currentVersion: number | null;
      serialNo: any;
      updatedAt: any;
      createdAt: any;
      deviceInfo: {
        __typename?: "DeviceInfo";
        deviceName: string;
        productCode: string;
      };
      ct1: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct2: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct3: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct4: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct5: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct6: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
    }>;
    libbis: Array<{
      __typename?: "Libbi";
      newAppAvailable: boolean;
      newBootloaderAvailable: boolean;
      serialNo: any;
      currentVersion: number | null;
      armVersion: number | null;
      dspVersion: number | null;
      deviceAddressRaw: number;
      maxBatteryCapacity: number | null;
      maxInverterCapacity: number | null;
      wifiFirmwareVersion: number | null;
      updatedAt: any;
      commandSeqNo: number;
      diverted: number;
      chargeRate: number;
      dischargeRate: number;
      frequency: number;
      priority: number;
      voltage: number | null;
      state: string;
      statusCode: number;
      stateOfCharge: number;
      normalisedStateOfCharge: number;
      chargeAmount: number;
      vHub: boolean;
      ethernetLink: boolean;
      wifiLink: boolean;
      gridPower: number | null;
      generatorPower: number | null;
      libbiMode: string;
      deviceConfigTime: any | null;
      createdAt: any;
      backupEnabled: boolean;
      pvConnected: boolean;
      gridCTPhase1Fitted: boolean;
      gridCTPhase2Fitted: boolean;
      gridCTPhase3Fitted: boolean;
      bmsVersion: {
        __typename?: "BMSVersion";
        version1: number;
        version2: number;
        version3: number;
        version4: number;
      } | null;
      configReply: {
        __typename?: "LibbiConfigReply";
        id: string;
        libbiConfigReplyData: {
          __typename?: "LibbiConfigPartial";
          id: string;
          wizardState: InstallerWizardState;
          calibrationChargeComplete: boolean;
          g100LockoutState: G100LockoutState;
          lastArmVersion: number;
          lastDspVersion: number;
          lastInverterFwInstallType: InverterFwInstallType;
          lastBaudRateInstallType: BaudRateInstallType;
        } | null;
      } | null;
      deviceInfo: {
        __typename?: "DeviceInfo";
        deviceName: string;
        productCode: string;
      };
      ct1: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct2: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct3: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct4: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct5: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
      ct6: {
        __typename?: "CtData";
        ctNumber: number;
        phase: string | null;
        type: string | null;
        current: number | null;
        power: number | null;
        isValid: boolean | null;
      } | null;
    }>;
  } | null;
};

export type GetHubFirmwareVersionsQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetHubFirmwareVersionsQuery = {
  __typename?: "Query";
  hubDetails: {
    __typename?: "Hub";
    serialNo: any;
    currentVersion: number | null;
    deviceInfo: {
      __typename?: "DeviceInfo";
      deviceName: string;
      productCode: string;
    };
    eddis: Array<{
      __typename?: "Eddi";
      serialNo: any;
      currentVersion: number | null;
      deviceInfo: {
        __typename?: "DeviceInfo";
        deviceName: string;
        productCode: string;
      };
    }>;
    zappis: Array<{
      __typename?: "Zappi";
      serialNo: any;
      currentVersion: number | null;
      deviceInfo: {
        __typename?: "DeviceInfo";
        deviceName: string;
        productCode: string;
      };
    }>;
    harvis: Array<{
      __typename?: "Harvi";
      serialNo: any;
      currentVersion: number | null;
      deviceInfo: {
        __typename?: "DeviceInfo";
        deviceName: string;
        productCode: string;
      };
    }>;
    libbis: Array<{
      __typename?: "Libbi";
      serialNo: any;
      currentVersion: number | null;
      deviceInfo: {
        __typename?: "DeviceInfo";
        deviceName: string;
        productCode: string;
      };
    }>;
  } | null;
};

export type GetErrorHistoryQueryVariables = Exact<{
  deviceType: DeviceType;
  serialNo: Scalars["Float"]["input"];
}>;

export type GetErrorHistoryQuery = {
  __typename?: "Query";
  errorHistory: Array<{
    __typename?: "DeviceError";
    code: number;
    firstOccurred: string;
    lastOccurred: string;
  }>;
};

export type GetG100EventsQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  deviceName: DeviceName;
}>;

export type GetG100EventsQuery = {
  __typename?: "Query";
  g100Events: {
    __typename?: "G100Events";
    events: Array<{ __typename?: "G100Event"; type: string; time: string }>;
    eventCounters: Array<{
      __typename?: "G100EventCounter";
      type: string;
      value: number;
    }>;
  };
};

export type GetLibbiMinuteQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetLibbiMinuteQuery = {
  __typename?: "Query";
  libbiMinute: {
    __typename?: "LibbiMinute";
    batteryTemp: number;
    batteryRadiatorTemp: number;
    inverterTemperature: number;
    ambientTemp: number;
    controllerTemp: number;
    dcPowerRecords: { __typename?: "LibbiDcPowerRecords"; pvPower1: number };
    batteries: Array<{
      __typename?: "Battery";
      number: number;
      heatFoilStatus: boolean | null;
      cycles: number | null;
    }>;
  };
};

export type GetZappi1ConfigQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetZappi1ConfigQuery = {
  __typename?: "Query";
  zappi1Config: {
    __typename?: "Zappi1Config";
    manualBoost: number;
    smartBoostEnergy: number;
    smartBoostHour: number;
    smartBoostMinute: number;
    minGreenLevel: number;
    plugInCharge: number;
    defaultMode: DefaultMode | null;
    language: Language | null;
    backlight: number;
    contrast: number;
    setBuzzer: boolean;
    dateFormat: DateFormat | null;
    dstOn: boolean;
    timeFromCloud: boolean;
    lockCode: string;
    lockEVUnplugged: boolean;
    lockTimeout: number;
    compatibilityModeMinPWM: number;
    deviceLimit: number;
    compatibilityModePowerFactor: number;
    exportMargin: number;
    gridLimit: number;
    passcode: string;
    chargeCompleteDelay: number;
    eSenseInput: ESenseInput | null;
    ct1Type: CtTypes | null;
    ct1Subtype: CtSubtype | null;
    ct2Type: CtTypes | null;
    ct2Subtype: CtSubtype | null;
    compatibilityModeActive: boolean;
    compatibilityModeInfinitePWM: boolean;
    batteryMode: BatteryMode | null;
    ct1GroupLimit: number;
    ct2GroupLimit: number;
    ct3GroupLimit: number;
    ctInternal1Group: number;
    ctExternal1Group: number;
    ctExternal2Group: number;
    preconditioning: Preconditioning | null;
    boostTimers: Array<{
      __typename?: "ConfigReplyBoostTimer";
      id: string;
      heaterType: EddiBoostTimerHeaterType | null;
      slot: number;
      duration: number;
      startHour: number;
      startMinute: number;
      mondayOn: boolean;
      tuesdayOn: boolean;
      wednesdayOn: boolean;
      thursdayOn: boolean;
      fridayOn: boolean;
      saturdayOn: boolean;
      sundayOn: boolean;
      economy: boolean;
    }>;
  };
};

export type GetZappiConfigQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetZappiConfigQuery = {
  __typename?: "Query";
  zappi2Config: {
    __typename?: "Zappi2Config";
    manualBoost: number;
    smartBoostEnergy: number;
    smartBoostHour: number;
    smartBoostMinute: number;
    minGreenLevel: number;
    startStopDelay: number;
    ecopStopDelay: number;
    plugInCharge: boolean;
    defaultMode: DefaultMode | null;
    language: Language | null;
    icons: GenTypeIconZappi | null;
    backlight: number;
    contrast: number;
    setBuzzer: boolean;
    ledBrightness: number;
    timeZone: TimeZone | null;
    dateFormat: DateFormat | null;
    dstOn: boolean;
    timeFromCloud: boolean;
    lockCode: string;
    lockEVPluggedIn: boolean;
    lockEVUnplugged: boolean;
    lockTimeout: number;
    lockAutohide: boolean;
    chargeWhenPINLocked: boolean;
    compatibilityModeMinPWM: number;
    deviceLimit: number;
    deviceLimitAmps: number;
    compatibilityModePowerFactor: number;
    exportMargin: number;
    gridLimit: number;
    passcode: string;
    chargeCompleteDelay: number;
    eSenseInput: ESenseInput | null;
    ctPrimary: number;
    ct1Type: CtTypes | null;
    ct1Subtype: CtSubtype | null;
    ct2Type: CtTypes | null;
    ct2Subtype: CtSubtype | null;
    compatibilityModeActive: boolean;
    batteryMode: BatteryMode | null;
    earthing: Earthing | null;
    gridPowerLimit: number;
    exportLimit: number;
    batteryDischargeEnabled: boolean;
    masterLostDetection: boolean;
    masterLostThreshold: number;
    ctDetection: boolean;
    ct3Type: CtTypes | null;
    ct3Subtype: CtSubtype | null;
    ct1GroupLimit: number;
    ct2GroupLimit: number;
    ct3GroupLimit: number;
    ct4GroupLimit: number;
    ctInternal1Group: number;
    ctInternal2Group: number;
    ctInternal3Group: number;
    ctExternal1Group: number;
    ctExternal2Group: number;
    ctExternal3Group: number;
    neutralLimit: number;
    phaseReturn: PhaseReturn | null;
    relay1PWM: number;
    relay2PWM: number;
    mainSwitchPWM: number;
    lockSolenoidPWM: number;
    weldedRelayCheckDelay: number;
    pERelayPWM: number;
    preconOn: boolean;
    preconEnergy: number;
    randomDelayStart: number;
    ecoMode: ZappiEcoModePhaseSetting;
    autoPhaseSwitching: boolean;
    boostTimers: Array<{
      __typename?: "ConfigReplyBoostTimer";
      id: string;
      heaterType: EddiBoostTimerHeaterType | null;
      slot: number;
      duration: number;
      startHour: number;
      startMinute: number;
      mondayOn: boolean;
      tuesdayOn: boolean;
      wednesdayOn: boolean;
      thursdayOn: boolean;
      fridayOn: boolean;
      saturdayOn: boolean;
      sundayOn: boolean;
      economy: boolean;
    }>;
    fault: { __typename?: "Rgb"; red: number; green: number; blue: number };
    greenCharging: {
      __typename?: "Rgb";
      red: number;
      green: number;
      blue: number;
    };
    mixedCharging: {
      __typename?: "Rgb";
      red: number;
      green: number;
      blue: number;
    };
    dirtyCharging: {
      __typename?: "Rgb";
      red: number;
      green: number;
      blue: number;
    };
    chargeComplete: {
      __typename?: "Rgb";
      red: number;
      green: number;
      blue: number;
    };
    stateB: { __typename?: "Rgb"; red: number; green: number; blue: number };
  };
};

export type GetRapidZappiConfigQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetRapidZappiConfigQuery = {
  __typename?: "Query";
  rapidZappiConfig: {
    __typename?: "RapidZappiConfig";
    manualBoost: number;
    minGreenLevel: number;
    startStopDelay: number;
    ecopStopDelay: number;
    plugInCharge: boolean;
    defaultSmartChargingMode: RapidZappiDefaultMode;
    language: Language | null;
    icons: GenTypeIconZappi | null;
    setBuzzer: boolean;
    ledBrightness: number;
    timeZone: TimeZone | null;
    dateFormat: DateFormat | null;
    dstOn: boolean;
    timeFromCloud: boolean;
    lockCode: string;
    lockEVPluggedIn: boolean;
    lockEVUnplugged: boolean;
    lockTimeout: number;
    lockAutohide: boolean;
    chargeWhenPINLocked: boolean;
    compatibilityModeMinPWM: number;
    deviceLimit: number;
    deviceLimitAmps: number;
    compatibilityModePowerFactor: number;
    exportMargin: number;
    gridLimit: number;
    passcode: string;
    chargeCompleteDelay: number;
    eSenseInput: ESenseInput | null;
    ctPrimary: number;
    ct1Type: CtTypes | null;
    ct1Subtype: CtSubtype | null;
    ct2Type: CtTypes | null;
    ct2Subtype: CtSubtype | null;
    compatibilityModeActive: boolean;
    batteryMode: BatteryMode | null;
    earthing: Earthing | null;
    gridPowerLimit: number;
    exportLimit: number;
    batteryDischargeEnabled: boolean;
    masterLostDetection: boolean;
    masterLostThreshold: number;
    ctDetection: boolean;
    ct3Type: CtTypes | null;
    ct3Subtype: CtSubtype | null;
    ct1GroupLimit: number;
    ct2GroupLimit: number;
    ct3GroupLimit: number;
    ct4GroupLimit: number;
    ctInternal1Group: number;
    ctInternal2Group: number;
    ctInternal3Group: number;
    ctExternal1Group: number;
    ctExternal2Group: number;
    ctExternal3Group: number;
    neutralLimit: number;
    phaseReturn: PhaseReturn | null;
    relay1PWM: number;
    relay2PWM: number;
    mainSwitchPWM: number;
    lockSolenoidPWM: number;
    weldedRelayCheckDelay: number;
    pERelayPWM: number;
    preconOn: boolean;
    preconEnergy: number;
    randomDelayStart: number;
    autoPhaseSwitching: boolean;
    boostTimers: Array<{
      __typename?: "ConfigReplyBoostTimer";
      id: string;
      heaterType: EddiBoostTimerHeaterType | null;
      slot: number;
      duration: number;
      startHour: number;
      startMinute: number;
      mondayOn: boolean;
      tuesdayOn: boolean;
      wednesdayOn: boolean;
      thursdayOn: boolean;
      fridayOn: boolean;
      saturdayOn: boolean;
      sundayOn: boolean;
      economy: boolean;
    }>;
    fault: { __typename?: "Rgb"; red: number; green: number; blue: number };
    greenCharging: {
      __typename?: "Rgb";
      red: number;
      green: number;
      blue: number;
    };
    mixedCharging: {
      __typename?: "Rgb";
      red: number;
      green: number;
      blue: number;
    };
    dirtyCharging: {
      __typename?: "Rgb";
      red: number;
      green: number;
      blue: number;
    };
    chargeComplete: {
      __typename?: "Rgb";
      red: number;
      green: number;
      blue: number;
    };
    stateB: { __typename?: "Rgb"; red: number; green: number; blue: number };
  };
};

export type GetEddiConfigQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetEddiConfigQuery = {
  __typename?: "Query";
  eddiConfig: {
    __typename?: "EddiConfig";
    exportLimit: number;
    neutralLimit: number;
    powerLimit: number;
    masterLostDetection: boolean;
    masterLostThreshold: number;
    ctDetection: boolean;
    heaterPriority: number;
    priorityCheckPeriod: number;
    timeZone: TimeZone | null;
    dateFormat: DateFormat | null;
    dstOn: boolean;
    timeFromCloud: boolean;
    language: Language | null;
    icons: GenTypeIconEddi | null;
    backlight: number;
    contrast: number;
    ct1Type: CtTypes | null;
    ct1Subtype: CtSubtype | null;
    ct2Type: CtTypes | null;
    ct2Subtype: CtSubtype | null;
    ct1GroupLimit: number;
    ct2GroupLimit: number;
    ct3GroupLimit: number;
    ctInternal1Group: number;
    ctExternal1Group: number;
    ctExternal2Group: number;
    batteryMode: BatteryMode | null;
    deviceLimit: number;
    exportMargin: number;
    gridLimit: number;
    passcode: string;
    hotTime: number;
    minimumExport: number;
    minimumExportTime: number;
    boostTimers: Array<{
      __typename?: "ConfigReplyBoostTimer";
      id: string;
      heaterType: EddiBoostTimerHeaterType | null;
      slot: number;
      duration: number;
      startHour: number;
      startMinute: number;
      temperature: number | null;
      mondayOn: boolean;
      tuesdayOn: boolean;
      wednesdayOn: boolean;
      thursdayOn: boolean;
      fridayOn: boolean;
      saturdayOn: boolean;
      sundayOn: boolean;
      economy: boolean;
    }>;
    expRelay1: {
      __typename?: "EddiExpansionRelayData";
      onThreshold: number;
      offThreshold: number;
      mode: RelayMode | null;
      boostType: BoostType;
      heating: RelayHeating | null;
      includeDiverted: boolean;
      minimumOffTime: number;
      minimumOnTime: number;
    };
    expRelay2: {
      __typename?: "EddiExpansionRelayData";
      onThreshold: number;
      offThreshold: number;
      mode: RelayMode | null;
      boostType: BoostType;
      heating: RelayHeating | null;
      includeDiverted: boolean;
      minimumOffTime: number;
      minimumOnTime: number;
    };
    esense: {
      __typename?: "EsenseData";
      mode: ESenseMode | null;
      boostMode: ESenseBoostMode | null;
      heaterEnableMode: ESenseHeaterEnableMode | null;
      boostEnableMode: ESenseBoostEnableMode | null;
      relayControlMode: ESenseRelayControlMode | null;
    };
  };
};

export type GetEddiPlusConfigQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetEddiPlusConfigQuery = {
  __typename?: "Query";
  eddiPlusConfig: {
    __typename?: "EddiPlusConfig";
    exportLimit: number;
    neutralLimit: number;
    powerLimit: number;
    masterLostDetection: boolean;
    masterLostThreshold: number;
    ctDetection: boolean;
    heaterPriority: number;
    heatersAvailableCount: number;
    priorityCheckPeriod: number;
    timeZone: TimeZone | null;
    dateFormat: DateFormat | null;
    dstOn: boolean;
    timeFromCloud: boolean;
    language: Language | null;
    icons: GenTypeIconEddi | null;
    backlight: number;
    contrast: number;
    ct1Type: CtTypes | null;
    ct1Subtype: CtSubtype | null;
    ct2Type: CtTypes | null;
    ct2Subtype: CtSubtype | null;
    ct3Type: CtTypes | null;
    ct3Subtype: CtSubtype | null;
    ct1GroupLimit: number;
    ct2GroupLimit: number;
    ct3GroupLimit: number;
    ctInternal1Group: number;
    ctInternal2Group: number;
    ctInternal3Group: number;
    ctExternal1Group: number;
    ctExternal2Group: number;
    ctExternal3Group: number;
    batteryMode: BatteryMode | null;
    deviceLimit: number;
    exportMargin: number;
    gridLimit: number;
    passcode: string;
    hotTime: number;
    minimumExport: number;
    minimumExportTime: number;
    boostTimers: Array<{
      __typename?: "ConfigReplyBoostTimer";
      id: string;
      heaterType: EddiBoostTimerHeaterType | null;
      slot: number;
      duration: number;
      startHour: number;
      startMinute: number;
      temperature: number | null;
      mondayOn: boolean;
      tuesdayOn: boolean;
      wednesdayOn: boolean;
      thursdayOn: boolean;
      fridayOn: boolean;
      saturdayOn: boolean;
      sundayOn: boolean;
      economy: boolean;
    }>;
    expRelay1: {
      __typename?: "EddiExpansionRelayData";
      onThreshold: number;
      offThreshold: number;
      mode: RelayMode | null;
      boostType: BoostType;
      heating: RelayHeating | null;
      includeDiverted: boolean;
      minimumOffTime: number;
      minimumOnTime: number;
    };
    expRelay2: {
      __typename?: "EddiExpansionRelayData";
      onThreshold: number;
      offThreshold: number;
      mode: RelayMode | null;
      boostType: BoostType;
      heating: RelayHeating | null;
      includeDiverted: boolean;
      minimumOffTime: number;
      minimumOnTime: number;
    };
    esense: {
      __typename?: "EsenseData";
      mode: ESenseMode | null;
      boostMode: ESenseBoostMode | null;
      heaterEnableMode: ESenseHeaterEnableMode | null;
      boostEnableMode: ESenseBoostEnableMode | null;
      relayControlMode: ESenseRelayControlMode | null;
    };
  };
};

export type GetLibbiConfigQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetLibbiConfigQuery = {
  __typename?: "Query";
  libbiConfig: {
    __typename?: "LibbiConfigReplyData";
    minReserveSoc: number;
    maxReserveSoc: number;
    timeZone: TimeZone;
    dateFormat: DateFormat;
    dstOn: boolean;
    timeFromCloud: boolean;
    genTypeIcon: GenTypeIconLibbi;
    language: LibbiLanguage;
    countryCode: LibbiCountryCode;
    backlightOnTime: number;
    contrastLevel: number;
    passcode: string;
    phaseReturn: PhaseReturn;
    chargeLimit: number;
    dischargeLimit: number;
    modbusTimeoutEnabled: boolean;
    threePhaseMonitoring: boolean;
    ctDetection: boolean;
    masterLostDetection: boolean;
    masterLostThreshold: number;
    exportLimit: number;
    neutralLimit: number;
    earthing: Earthing;
    powerLimit: number;
    exportMargin: number;
    gridLimit: number;
    ct1Type: CtTypes;
    ct2Type: CtTypes;
    ct3Type: CtTypes;
    ctPrimary: number;
    ctInternal1Group: number;
    ctExternal1Group: number;
    ctExternal2Group: number;
    ctExternal3Group: number;
    ct1GroupLimit: number;
    ct2GroupLimit: number;
    ct3GroupLimit: number;
    ct4GroupLimit: number;
    batteryMode: BatteryMode;
    gridSubdivide: GridSubdivisionCountryCode;
    pvInputMode: PvMpptInputMode;
    calibrationChargeComplete: boolean;
    boostTimers: Array<{
      __typename?: "ConfigReplyBoostTimer";
      id: string;
      slot: number;
      duration: number;
      startHour: number;
      startMinute: number;
      mondayOn: boolean;
      tuesdayOn: boolean;
      wednesdayOn: boolean;
      thursdayOn: boolean;
      fridayOn: boolean;
      saturdayOn: boolean;
      sundayOn: boolean;
      energyTarget: number | null;
      rate: number | null;
      mode: LibbiBoostTimerMode | null;
    }>;
  };
};

export type GetHubIdBySerialNumberQueryVariables = Exact<{
  serialNo: Scalars["BigInt"]["input"];
}>;

export type GetHubIdBySerialNumberQuery = {
  __typename?: "Query";
  searchHubOrDevice: {
    __typename?: "SearchResult";
    serialNo: any | null;
    deviceSerialNo: any | null;
    deviceName: string | null;
  };
};

export type CommandFragmentFragment = {
  __typename?: "Command";
  id: string;
  destinationDeviceSerialNo: any;
  commandTries: number;
  commandLastSent: any | null;
  commandInitiated: any;
  commandType: CommandType | null;
  commandState: CommandState | null;
  commandInitiatorService: CommandInitiatorService | null;
  commandInitiatorContext: string | null;
  commandParametersJson: string | null;
  commandParameters: {
    __typename?: "CommandParameters";
    dsrSetLoad: {
      __typename?: "DsrSetLoadCommandParams";
      deviceAddresses: Array<number>;
      ttl: number;
      value: any;
    } | null;
  } | null;
};

export type GetRecentCommandsQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  hubSerialNo: Scalars["Float"]["input"];
  limit: Scalars["Float"]["input"];
  deviceName: DeviceName;
  hubDeviceName: DeviceName;
}>;

export type GetRecentCommandsQuery = {
  __typename?: "Query";
  recentCommands: Array<{
    __typename?: "Command";
    id: string;
    destinationDeviceSerialNo: any;
    commandTries: number;
    commandLastSent: any | null;
    commandInitiated: any;
    commandType: CommandType | null;
    commandState: CommandState | null;
    commandInitiatorService: CommandInitiatorService | null;
    commandInitiatorContext: string | null;
    commandParametersJson: string | null;
    commandParameters: {
      __typename?: "CommandParameters";
      dsrSetLoad: {
        __typename?: "DsrSetLoadCommandParams";
        deviceAddresses: Array<number>;
        ttl: number;
        value: any;
      } | null;
    } | null;
  }>;
  recentHubCommands: Array<{
    __typename?: "Command";
    id: string;
    destinationDeviceSerialNo: any;
    commandTries: number;
    commandLastSent: any | null;
    commandInitiated: any;
    commandType: CommandType | null;
    commandState: CommandState | null;
    commandInitiatorService: CommandInitiatorService | null;
    commandInitiatorContext: string | null;
    commandParametersJson: string | null;
    commandParameters: {
      __typename?: "CommandParameters";
      dsrSetLoad: {
        __typename?: "DsrSetLoadCommandParams";
        deviceAddresses: Array<number>;
        ttl: number;
        value: any;
      } | null;
    } | null;
  }>;
};

export type GetDeviceConnectionsQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  deviceType: DeviceType;
  limit: Scalars["Float"]["input"];
}>;

export type GetDeviceConnectionsQuery = {
  __typename?: "Query";
  deviceConnections: Array<{
    __typename?: "DeviceConnection";
    connectionTime: string;
    disconnectionTime: string | null;
  }>;
};

export type GetExecutionContextIdQueryVariables = Exact<{
  commandId: Scalars["String"]["input"];
}>;

export type GetExecutionContextIdQuery = {
  __typename?: "Query";
  executionContextId: {
    __typename?: "ExecutionContextId";
    client: {
      __typename?: "Client";
      ip: string | null;
      port: number | null;
      xForwardedFor: string | null;
      xForwardedPort: number | null;
      userAgent: string | null;
    } | null;
  };
};

export type GetHasPendingCommandsQueryVariables = Exact<{
  deviceType: DeviceType;
  serialNo: Scalars["Int"]["input"];
  hubSerialNo: Scalars["Int"]["input"];
}>;

export type GetHasPendingCommandsQuery = {
  __typename?: "Query";
  hasPendingCommands: boolean;
};

export type GetMonitoringConfigQueryVariables = Exact<{
  hubSerial: Scalars["Float"]["input"];
}>;

export type GetMonitoringConfigQuery = {
  __typename?: "Query";
  getMonitoringConfig: {
    __typename?: "MonitoringConfig";
    serialNumber: number;
    active: boolean;
    endTime: any;
    startTime: any;
  } | null;
};

export type GetOcppConfigQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
}>;

export type GetOcppConfigQuery = {
  __typename?: "Query";
  ocppConfig: {
    __typename?: "OcppConfiguration";
    device_serial_no: number;
    wss_uri: string;
    username: string;
    AuthorizationKey: string | null;
    HeartbeatInterval: number;
    ClockAlignedDataInterval: number;
    ConnectionTimeOut: number;
    LocalAuthorizeOffline: boolean;
    LocalPreAuthorize: boolean;
    MeterValuesAlignedData: string;
    MeterValuesSampledData: string;
    MeterValueSampleInterval: number;
    NumberOfConnectors: number;
    ResetRetries: number;
    ConnectorPhaseRotation: string | null;
    StopTransactionOnEVSideDisconnect: boolean;
    StopTransactionOnInvalidId: boolean;
    StopTxnAlignedData: string;
    StopTxnSampledData: string;
    SupportedFeatureProfiles: string;
    TransactionMessageAttempts: number;
    TransactionMessageRetryInterval: number;
    UnlockConnectorOnEVSideDisconnect: boolean;
    LocalAuthListEnabled: boolean;
    LocalAuthListMaxLength: number;
    SendLocalListMaxLength: number;
    OCPPChargeMode: string;
    RandomSmartChargeDelay: number;
    FreeCharging: boolean;
    PlugAndChargeID: string | null;
    ocppEnabled: boolean;
    CommercialMode: boolean | null;
    MaintenanceMode: boolean | null;
    HasPaymentTerminal: boolean | null;
    FreeVendScreen: boolean | null;
    PricekWh: number | null;
    PriceMinute: number | null;
    IdleFee: number | null;
    ConnectionFee: number | null;
    TariffType: string | null;
    AppName: string | null;
    SupportContact: string | null;
    IsOperative: boolean | null;
    PaymentURL: string | null;
    Currency: string | null;
    CurrencyAfterValue: boolean | null;
    AllowPINCode: boolean | null;
    ChargerName: string | null;
    ChargerID: string | null;
  } | null;
  ocppStatus: { __typename?: "OcppStatus"; ocppStatus: string };
};

export type GetOcppLogMessagesQueryVariables = Exact<{
  deviceSerialNo: Scalars["Float"]["input"];
}>;

export type GetOcppLogMessagesQuery = {
  __typename?: "Query";
  getOcppLogMessages: Array<{
    __typename?: "OcppLogMessage";
    type: string;
    group: string | null;
    timestamp: string;
    payload: string;
  }>;
};

export type GetOcppChargingProfilesQueryVariables = Exact<{
  deviceSerialNo: Scalars["Float"]["input"];
}>;

export type GetOcppChargingProfilesQuery = {
  __typename?: "Query";
  getOcppChargingProfiles: Array<{
    __typename?: "OcppChargingProfile";
    deviceSerialNo: number;
    chargingProfileId: number;
    slotIds: Array<number>;
    transactionId: number;
    rawChargingProfile: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetWebhooksByDeviceSerialNoQueryVariables = Exact<{
  deviceSerialNo: Scalars["String"]["input"];
}>;

export type GetWebhooksByDeviceSerialNoQuery = {
  __typename?: "Query";
  getWebhooksByDeviceSerialNo: {
    __typename?: "ThirdPartyWebhooksAndIntegratorGql";
    integrators: Array<{
      __typename?: "IntegratorsGql";
      integratorData: {
        __typename?: "IntegratorDataGql";
        integratorId: string;
        integratorName: string;
      };
      webhooks: Array<{
        __typename?: "WebhookGql";
        deviceSerialNo: number;
        deviceClass: string;
        eventType: string;
        createdAt: string;
        updatedAt: string;
      }>;
    }> | null;
  };
};

export type GetThirdPartyConnectionsByCognitoSubsQueryVariables = Exact<{
  cognitoSubs: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type GetThirdPartyConnectionsByCognitoSubsQuery = {
  __typename?: "Query";
  getThirdPartyConnectionsByCognitoSubs: Array<{
    __typename?: "ThirdPartyConnections";
    id: string;
    clientId: string;
    clientName: string;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GetDeviceRigDataQueryVariables = Exact<{
  deviceSerialNo: Scalars["Int"]["input"];
}>;

export type GetDeviceRigDataQuery = {
  __typename?: "Query";
  rigData: {
    __typename?: "RigData";
    serialNo: number;
    blePin: string | null;
    uid: string | null;
    upc: string | null;
    rigId: number | null;
    pcbQr: string | null;
    fpc: string | null;
    lastPassTime: string | null;
    provisionedAt: string | null;
  } | null;
};

export type GetDeviceHistoryQueryVariables = Exact<{
  serialNo: Scalars["Float"]["input"];
  deviceType: DeviceType;
  resolution: HistoryResolution;
  start: Scalars["String"]["input"];
  end: Scalars["String"]["input"];
}>;

export type GetDeviceHistoryQuery = {
  __typename?: "Query";
  history: { __typename?: "History"; historyJson: string };
};

export type GetDeviceInstallationQueryVariables = Exact<{
  serialNo: Scalars["BigInt"]["input"];
  deviceType: DeviceType;
}>;

export type GetDeviceInstallationQuery = {
  __typename?: "Query";
  installation: {
    __typename?: "Installation";
    installationDetails: {
      __typename?: "InstallationDetails";
      isComplete: boolean | null;
      existingDevice: {
        __typename?: "ExistingDevice";
        masterDeviceType: DeviceType | null;
        masterDeviceSerialNumber: string | null;
        hubDeviceType: DeviceType | null;
        hubDeviceSerialNumber: string | null;
        isPaired: boolean | null;
      } | null;
      renewableEnergy: {
        __typename?: "RenewableEnergy";
        none: boolean | null;
        hasSolarPanel: boolean | null;
        hasWindTurbine: boolean | null;
        hasHydroelectric: boolean | null;
        hasElectricStorageHeating: boolean | null;
        hasBattery: boolean | null;
        other: boolean | null;
      } | null;
    } | null;
    supplyAndLimits: {
      __typename?: "SupplyAndLimits";
      deviceLimit: number | null;
      importLimit: number | null;
      exportLimit: number | null;
    } | null;
    otherSettings: {
      __typename?: "OtherSettings";
      earthingArrangement: EarthingArrangement | null;
      mpan: string | null;
      radioChannelId: number | null;
      vHub: boolean | null;
    } | null;
    installer: {
      __typename?: "Installer";
      name: string | null;
      acceptedTermsOn: string | null;
      acceptedPrivacyOn: string | null;
      appVersion: string | null;
      createdOn: string | null;
    } | null;
  } | null;
};

export type GetChargeSessionsQueryVariables = Exact<{
  serialNo: Scalars["Int"]["input"];
  start: Scalars["String"]["input"];
  end: Scalars["String"]["input"];
  offset: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
}>;

export type GetChargeSessionsQuery = {
  __typename?: "Query";
  chargeSessions: {
    __typename?: "ChargeSessionsGQL";
    totalCount: number;
    totalElectricity: number;
    totalGreenElectricity: number;
    data: Array<{
      __typename?: "ChargeSessionDataGQL";
      id: string;
      authType: number;
      chargeDuration: number;
      chargeEnd: string;
      chargeStart: string;
      electricity: number;
      greenElectricity: number;
      isBusiness: boolean;
      pluggedIn: string;
      unplugged: string;
      zappiSerialNo: number;
      friendlyName: string;
    }>;
  } | null;
};

export type GetMqttConnectionHistoryQueryVariables = Exact<{
  serialNo: Scalars["Int"]["input"];
  limit: Scalars["Int"]["input"];
  cursor: InputMaybe<Scalars["String"]["input"]>;
}>;

export type GetMqttConnectionHistoryQuery = {
  __typename?: "Query";
  getMqttConnectionHistory: {
    __typename?: "MqttConnectionResult";
    cursor: string | null;
    results: Array<{
      __typename?: "MqttConnection";
      connected: boolean;
      disconnectReason: string | null;
      timestamp: string;
    }>;
  };
};

export type GetEnabledOcppConfigsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetEnabledOcppConfigsQuery = {
  __typename?: "Query";
  getEnabledOcppConfigs: Array<{
    __typename?: "OcppConfiguration";
    id: number;
    wss_uri: string;
    device_serial_no: number;
    created_at: string;
  }> | null;
};

export type MutateServerInfoMutationVariables = Exact<{
  input: ChangeServerInput;
}>;

export type MutateServerInfoMutation = {
  __typename?: "Mutation";
  mutateServerInfo: { __typename?: "Server"; id: string };
};

export type MutateAlternateServersMutationVariables = Exact<{
  input: ChangeAlternateServersInput;
}>;

export type MutateAlternateServersMutation = {
  __typename?: "Mutation";
  mutateAlternateServers: boolean;
};

export type GetServersInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetServersInfoQuery = {
  __typename?: "Query";
  getServersInfo: Array<{
    __typename?: "Server";
    id: string;
    name: string;
    shard: string | null;
    ip: string;
    url: string;
    isDefault: boolean;
    isActive: boolean;
  }>;
};

export type GetAlternateServersInfoQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetAlternateServersInfoQuery = {
  __typename?: "Query";
  getAlternateServersInfo: {
    __typename?: "AlternateServers";
    serverA: {
      __typename?: "Server";
      id: string;
      ip: string;
      name: string;
    } | null;
    serverB: {
      __typename?: "Server";
      id: string;
      ip: string;
      name: string;
    } | null;
  };
};

export type AddIntegratorMutationVariables = Exact<{
  input: ThirdPartyCreateClientInput;
}>;

export type AddIntegratorMutation = {
  __typename?: "Mutation";
  createThirdPartyIntegrator: {
    __typename?: "ThirdPartyClient";
    clientId: string;
    clientSecret: string;
    clientName: string;
  };
};

export type UpdateIntegratorMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  input: ThirdPartyUpdateClientInput;
}>;

export type UpdateIntegratorMutation = {
  __typename?: "Mutation";
  updateThirdPartyIntegrator: {
    __typename?: "ThirdPartyUpdateResponse";
    clientName: string;
    clientId: string;
  };
};

export type RotateClientSecretMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type RotateClientSecretMutation = {
  __typename?: "Mutation";
  rotateClientSecret: {
    __typename?: "ThirdPartyRotateSecretResponse";
    clientId: string;
    clientSecret: string;
  };
};

export type DeleteIntegratorMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteIntegratorMutation = {
  __typename?: "Mutation";
  deleteThirdPartyIntegrator: {
    __typename?: "ThirdPartyDeleteResponse";
    clientId: string;
    clientName: string;
  };
};

export type GetIntegratorsQueryVariables = Exact<{ [key: string]: never }>;

export type GetIntegratorsQuery = {
  __typename?: "Query";
  getThirdPartyIntegrators: Array<{
    __typename?: "ThirdPartyClients";
    clientId: string;
    clientName: string;
    numberOfDevices: number;
  }>;
};

export type GetIntegratorByIdQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetIntegratorByIdQuery = {
  __typename?: "Query";
  getThirdPartyIntegrator: {
    __typename?: "ThirdPartyClient";
    clientId: string;
    clientName: string;
    clientSecret: string;
    redirectUris: Array<string>;
    createdAt: any;
    updatedAt: any;
  };
};

export type DeleteUserMutationVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type DeleteUserMutation = {
  __typename?: "Mutation";
  deleteUser: string;
};

export type MutateUserMutationVariables = Exact<{
  input: ChangeUserInput;
}>;

export type MutateUserMutation = {
  __typename?: "Mutation";
  mutateUser: boolean;
};

export type CreateUserMutationVariables = Exact<{
  newUser: CreateUserInput;
}>;

export type CreateUserMutation = {
  __typename?: "Mutation";
  createUser: {
    __typename?: "User";
    id: string;
    email: string;
    name: string;
    lastLogin: any;
    access: {
      __typename?: "UserAccess";
      id: string;
      type: string;
      permissions: Array<Permission | null>;
    };
  };
};

export type MutatePermissionsMutationVariables = Exact<{
  input: ChangeRolePermissionsInput;
}>;

export type MutatePermissionsMutation = {
  __typename?: "Mutation";
  mutatePermissions: {
    __typename?: "UserAccess";
    id: string;
    type: string;
    permissions: Array<Permission | null>;
  };
};

export type GetUserDetailsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type GetUserDetailsQuery = {
  __typename?: "Query";
  user: {
    __typename?: "User";
    id: string;
    email: string;
    name: string;
    lastLogin: any;
    access: {
      __typename?: "UserAccess";
      id: string;
      type: string;
      permissions: Array<Permission | null>;
    };
  };
};

export type GetUsersAndRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUsersAndRolesQuery = {
  __typename?: "Query";
  users: Array<{
    __typename?: "User";
    id: string;
    email: string;
    name: string;
    lastLogin: any;
    access: {
      __typename?: "UserAccess";
      id: string;
      type: string;
      permissions: Array<Permission | null>;
    };
  }>;
  getUserRoles: Array<{
    __typename?: "UserAccess";
    id: string;
    type: string;
    permissions: Array<Permission | null>;
  }>;
};

export type GetUserRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserRolesQuery = {
  __typename?: "Query";
  getUserRoles: Array<{ __typename?: "UserAccess"; id: string; type: string }>;
};

export type GetUserRolesAndPermissionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserRolesAndPermissionsQuery = {
  __typename?: "Query";
  getUserRoles: Array<{
    __typename?: "UserAccess";
    id: string;
    type: string;
    permissions: Array<Permission | null>;
  }>;
};

export const DsrFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "dsrFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DsrData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "load" } },
          { kind: "Field", name: { kind: "Name", value: "seconds" } },
          { kind: "Field", name: { kind: "Name", value: "csn" } },
          { kind: "Field", name: { kind: "Name", value: "ack" } },
          { kind: "Field", name: { kind: "Name", value: "lce" } },
          { kind: "Field", name: { kind: "Name", value: "lca" } },
          { kind: "Field", name: { kind: "Name", value: "fue" } },
          { kind: "Field", name: { kind: "Name", value: "fde" } },
          { kind: "Field", name: { kind: "Name", value: "fua" } },
          { kind: "Field", name: { kind: "Name", value: "fda" } },
          { kind: "Field", name: { kind: "Name", value: "fun" } },
          { kind: "Field", name: { kind: "Name", value: "fdn" } },
          { kind: "Field", name: { kind: "Name", value: "daf" } },
          { kind: "Field", name: { kind: "Name", value: "ddf" } },
          { kind: "Field", name: { kind: "Name", value: "uaf" } },
          { kind: "Field", name: { kind: "Name", value: "udf" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DsrFragmentFragment, unknown>;
export const CtFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ctFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CtData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "ctNumber" } },
          { kind: "Field", name: { kind: "Name", value: "phase" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "current" } },
          { kind: "Field", name: { kind: "Name", value: "power" } },
          { kind: "Field", name: { kind: "Name", value: "isValid" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CtFragmentFragment, unknown>;
export const CommandFragmentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommandFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Command" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "destinationDeviceSerialNo" },
          },
          { kind: "Field", name: { kind: "Name", value: "commandTries" } },
          { kind: "Field", name: { kind: "Name", value: "commandLastSent" } },
          { kind: "Field", name: { kind: "Name", value: "commandInitiated" } },
          { kind: "Field", name: { kind: "Name", value: "commandType" } },
          { kind: "Field", name: { kind: "Name", value: "commandState" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "commandInitiatorService" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commandInitiatorContext" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commandParametersJson" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commandParameters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dsrSetLoad" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceAddresses" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "ttl" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommandFragmentFragment, unknown>;
export const GetHubProductDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHubProductDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hubDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "serialNo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentVersion" },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eddis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "zappis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "harvis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "libbis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetHubProductDetailsQuery,
  GetHubProductDetailsQueryVariables
>;
export const GetDashboardInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDashboardInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "timezone" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "dashboardInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "timezone" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "timezone" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "activeAppUsers" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfHubs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfZappis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfEddis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLibbis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfHarvis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLiveHubs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLiveZappis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLiveEddis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLiveLibbis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLiveHarvis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfYesterdayHubs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfYesterdayZappis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfYesterdayEddis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfYesterdayLibbis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfYesterdayHarvis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLastWeekHubs" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLastWeekZappis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLastWeekEddis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLastWeekHarvis" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfLastWeekLibbis" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDashboardInfoQuery,
  GetDashboardInfoQueryVariables
>;
export const SetDeviceChannelDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetDeviceChannel" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SetDeviceChannelInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setDeviceChannel" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetDeviceChannelMutation,
  SetDeviceChannelMutationVariables
>;
export const ManageFileApprovalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "manageFileApproval" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ManageFileApprovalInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "manageFileApproval" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ManageFileApprovalMutation,
  ManageFileApprovalMutationVariables
>;
export const StartFirmwareReleaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "startFirmwareRelease" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StartFirmwareReleaseInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startFirmwareRelease" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartFirmwareReleaseMutation,
  StartFirmwareReleaseMutationVariables
>;
export const EndFirmwareReleaseDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "endFirmwareRelease" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EndFirmwareReleaseInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "endFirmwareRelease" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EndFirmwareReleaseMutation,
  EndFirmwareReleaseMutationVariables
>;
export const GetUploadFirmwareUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUploadFirmwareUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "fileName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "md5Base64" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUploadFirmwareUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "fileName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "fileName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "md5Base64" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "md5Base64" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUploadFirmwareUrlQuery,
  GetUploadFirmwareUrlQueryVariables
>;
export const GetFirmwareFilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetFirmwareFiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "upc" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cursor" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getFirmwareFiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "upc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "upc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cursor" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cursor" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "results" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileMd5" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "version" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sizeBytes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "approval" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "state" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "history" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "state" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "userEmail" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "date" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "reason" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "releaseNotes" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cursor" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFirmwareFilesQuery,
  GetFirmwareFilesQueryVariables
>;
export const GetDeviceChannelsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDeviceChannels" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "upc" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "channel" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cursor" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getDeviceChannels" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "upc" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "upc" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "channel" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "channel" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cursor" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cursor" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "results" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uid" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "notes" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "setByEmail" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cursor" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDeviceChannelsQuery,
  GetDeviceChannelsQueryVariables
>;
export const GetProductsFirmwareVersionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetProductsFirmwareVersions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getProductsFirmwareVersions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "results" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetProductsFirmwareVersionsQuery,
  GetProductsFirmwareVersionsQueryVariables
>;
export const MutateHubDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MutateHub" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updatedHub" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdatedHubInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateHub" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "updatedHub" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updatedHub" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutateHubMutation, MutateHubMutationVariables>;
export const HubDeregisterDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "HubDeregister" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hubDeregister" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HubDeregisterMutation,
  HubDeregisterMutationVariables
>;
export const DeleteDeviceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteDevice" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteDevice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceType" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteDeviceMutation,
  DeleteDeviceMutationVariables
>;
export const DeleteInitialCommandsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteInitialCommands" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hubSerialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteInitialCommands" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hubSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hubSerialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deletedFromRedisCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deletedFromPostgresCount" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteInitialCommandsMutation,
  DeleteInitialCommandsMutationVariables
>;
export const DownloadBootloaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DownloadBootloader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "downloadBootloader" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadBootloaderMutation,
  DownloadBootloaderMutationVariables
>;
export const ForceRebootDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ForceReboot" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forceReboot" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ForceRebootMutation, ForceRebootMutationVariables>;
export const ForceBackgroundDownloadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ForceBackgroundDownload" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forceBackgroundDownload" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForceBackgroundDownloadMutation,
  ForceBackgroundDownloadMutationVariables
>;
export const ForceInstallDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ForceInstall" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forceInstallApp" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForceInstallMutation,
  ForceInstallMutationVariables
>;
export const LibbiInverterCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LibbiInverterCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "commandType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LibbiInverterCommandType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setLibbiInverterCommand" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "commandType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "commandType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LibbiInverterCommandMutation,
  LibbiInverterCommandMutationVariables
>;
export const SetLibbiCombinedInverterUpdateCommandDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "setLibbiCombinedInverterUpdateCommand" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "updateType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BaudRateInstallType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "setLibbiCombinedInverterUpdateCommand",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "updateType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "updateType" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetLibbiCombinedInverterUpdateCommandMutation,
  SetLibbiCombinedInverterUpdateCommandMutationVariables
>;
export const ForceInstallBootloaderDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ForceInstallBootloader" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "installBootloader" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForceInstallBootloaderMutation,
  ForceInstallBootloaderMutationVariables
>;
export const G100ResetDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "G100Reset" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "resetType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "G100ResetType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "g100Reset" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "resetType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "resetType" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<G100ResetMutation, G100ResetMutationVariables>;
export const SetLibbiConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetLibbiConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "config" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LibbiEditableConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setLibbiConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "config" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "validationIssues" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetLibbiConfigMutation,
  SetLibbiConfigMutationVariables
>;
export const SetZappi2ConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetZappi2Config" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "config" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Zappi2EditableConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setZappi2Config" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "config" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "validationIssues" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetZappi2ConfigMutation,
  SetZappi2ConfigMutationVariables
>;
export const SetRapidZappiConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetRapidZappiConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "config" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RapidZappiEditableConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setRapidZappiConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "config" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "validationIssues" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetRapidZappiConfigMutation,
  SetRapidZappiConfigMutationVariables
>;
export const SetEddiConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetEddiConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "config" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EddiEditableConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setEddiConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "config" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "validationIssues" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetEddiConfigMutation,
  SetEddiConfigMutationVariables
>;
export const SetEddiPlusConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetEddiPlusConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "config" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EddiPlusEditableConfigInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setEddiPlusConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "config" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "config" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "validationIssues" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "path" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "message" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetEddiPlusConfigMutation,
  SetEddiPlusConfigMutationVariables
>;
export const SetMonitoringConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetMonitoringConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hubSerial" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "active" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "extendTimeDays" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setMonitoringConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "hubSerial" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hubSerial" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "active" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "active" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "extendTimeDays" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "extendTimeDays" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetMonitoringConfigMutation,
  SetMonitoringConfigMutationVariables
>;
export const ReadG100EventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "readG100Events" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "readG100Events" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReadG100EventsMutation,
  ReadG100EventsMutationVariables
>;
export const SetOcppConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SetOcppConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "OcppConfigurationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setOcppConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetOcppConfigMutation,
  SetOcppConfigMutationVariables
>;
export const DeleteOcppChargingProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteOcppChargingProfile" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteOcppChargingProfileInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteOcppChargingProfile" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "success" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteOcppChargingProfileMutation,
  DeleteOcppChargingProfileMutationVariables
>;
export const ForceConfigReadDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "forceConfigRead" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "structureId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "forceConfigRead" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "structureId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "structureId" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForceConfigReadMutation,
  ForceConfigReadMutationVariables
>;
export const GetHubsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHubs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PaginatedSearchInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hubs" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rows" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isBlocked" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "registered" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "productCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "eddis" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "serialNo" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "variant" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "zappis" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "serialNo" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "variant" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "harvis" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "serialNo" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "libbis" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "serialNo" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHubsQuery, GetHubsQueryVariables>;
export const GetHubDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHubDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hubDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "encrypted" } },
                { kind: "Field", name: { kind: "Name", value: "serialNo" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "regPassword" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "registrationDate" },
                },
                { kind: "Field", name: { kind: "Name", value: "uptime" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serverLastHeard" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentVersion" },
                },
                { kind: "Field", name: { kind: "Name", value: "lastAuth" } },
                { kind: "Field", name: { kind: "Name", value: "isBlocked" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "blockedReason" },
                },
                { kind: "Field", name: { kind: "Name", value: "networkId" } },
                { kind: "Field", name: { kind: "Name", value: "noDevices" } },
                { kind: "Field", name: { kind: "Name", value: "port" } },
                { kind: "Field", name: { kind: "Name", value: "iPAddress" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "keyValueStore" },
                },
                { kind: "Field", name: { kind: "Name", value: "australia" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "radioChannel" },
                },
                { kind: "Field", name: { kind: "Name", value: "vHub" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasBeenConnected" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deviceInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "productCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hubFirmwareVersions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "optionCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "versionCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "productName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "productCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "loadControl" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceLoads" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "serialNo" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "setLoad" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridImportExport" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "flags" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "netPhases" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterDeviceRawAddress" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cloudIPOverrideServer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "frequencyResponse" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "DAF" } },
                      { kind: "Field", name: { kind: "Name", value: "DDF" } },
                      { kind: "Field", name: { kind: "Name", value: "UAF" } },
                      { kind: "Field", name: { kind: "Name", value: "UDF" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eddis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "newAppAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "newBootloaderAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wifiFirmwareVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "melibVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "melinkVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stubLoaderVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bootLoaderVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceAddressRaw" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCode" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridPower" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generatorPower" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ethernetLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wifiLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceConfigTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serverConfigTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "diverted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "voltage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "frequency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commandSeqNo" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      { kind: "Field", name: { kind: "Name", value: "vHub" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "microprocessorTI" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase1Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase2Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase3Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isThreePhase" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "configReply" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "eddiConfigReplyData",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "serverConfigTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "deviceConfigTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "g100LockoutState",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "eddiPlusConfigReplyData",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "serverConfigTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "deviceConfigTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "g100LockoutState",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "heatersAvailableCount",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priority" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterType1" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterType2" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dsrData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "dsrFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct1" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct2" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct3" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct4" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct5" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct6" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pt1" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ptNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "temp" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pt2" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ptNumber" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "temp" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "zappis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "newAppAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "newBootloaderAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wifiFirmwareVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "melibVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "melinkVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stubLoaderVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bootLoaderVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceAddressRaw" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCode" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "connectivityStatus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "connected" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "disconnectReason" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "timestamp" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dsrData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "dsrFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargeEnergy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "diverted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "voltage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "frequency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commandSeqNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pilotState" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "zappiMode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priority" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridPower" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generatorPower" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ethernetLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wifiLink" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "vHub" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase1Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase2Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase3Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lockedStatus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "microprocessorTI" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lockedNow" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "configReply" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "zappi1ConfigReplyData",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "deviceConfigTime",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "zappi2ConfigReplyData",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "serverConfigTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "deviceConfigTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "g100LockoutState",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "rapidZappiConfigReplyData",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "serverConfigTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "deviceConfigTime",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "g100LockoutState",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct1" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct2" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct3" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct4" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct5" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct6" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isThreePhase" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pwmData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateCpu" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "stateRCDBoard" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "pulseWidthModulationInPercentage",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rcdDCInNanoAmps" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "rcdACInNanoAmps" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "returnRcdACInNanoAmps",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "state" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "stateEngineVersion",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "harvis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCode" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct1" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct2" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct3" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct4" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct5" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct6" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "libbis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "newAppAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "newBootloaderAvailable" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "armVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dspVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "bmsVersion" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "version1" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "version2" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "version3" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "version4" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceAddressRaw" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "configReply" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "libbiConfigReplyData",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "wizardState",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "calibrationChargeComplete",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "g100LockoutState",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastArmVersion",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastDspVersion",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastInverterFwInstallType",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "lastBaudRateInstallType",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxBatteryCapacity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "maxInverterCapacity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wifiFirmwareVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "commandSeqNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "diverted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargeRate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dischargeRate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "frequency" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "priority" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "voltage" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "state" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusCode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "stateOfCharge" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "normalisedStateOfCharge",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargeAmount" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "vHub" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ethernetLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wifiLink" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCode" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridPower" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "generatorPower" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "libbiMode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceConfigTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "backupEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pvConnected" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase1Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase2Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "gridCTPhase3Fitted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct1" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct2" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct3" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct4" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct5" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ct6" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ctFragment" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "dsrFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "DsrData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "load" } },
          { kind: "Field", name: { kind: "Name", value: "seconds" } },
          { kind: "Field", name: { kind: "Name", value: "csn" } },
          { kind: "Field", name: { kind: "Name", value: "ack" } },
          { kind: "Field", name: { kind: "Name", value: "lce" } },
          { kind: "Field", name: { kind: "Name", value: "lca" } },
          { kind: "Field", name: { kind: "Name", value: "fue" } },
          { kind: "Field", name: { kind: "Name", value: "fde" } },
          { kind: "Field", name: { kind: "Name", value: "fua" } },
          { kind: "Field", name: { kind: "Name", value: "fda" } },
          { kind: "Field", name: { kind: "Name", value: "fun" } },
          { kind: "Field", name: { kind: "Name", value: "fdn" } },
          { kind: "Field", name: { kind: "Name", value: "daf" } },
          { kind: "Field", name: { kind: "Name", value: "ddf" } },
          { kind: "Field", name: { kind: "Name", value: "uaf" } },
          { kind: "Field", name: { kind: "Name", value: "udf" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ctFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CtData" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "ctNumber" } },
          { kind: "Field", name: { kind: "Name", value: "phase" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "current" } },
          { kind: "Field", name: { kind: "Name", value: "power" } },
          { kind: "Field", name: { kind: "Name", value: "isValid" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetHubDetailsQuery, GetHubDetailsQueryVariables>;
export const GetHubFirmwareVersionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHubFirmwareVersions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hubDetails" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "serialNo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "currentVersion" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deviceInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "productCode" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eddis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCode" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "zappis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCode" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "harvis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCode" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "libbis" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "serialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "currentVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "productCode" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetHubFirmwareVersionsQuery,
  GetHubFirmwareVersionsQueryVariables
>;
export const GetErrorHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetErrorHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "errorHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "code" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "firstOccurred" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastOccurred" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetErrorHistoryQuery,
  GetErrorHistoryQueryVariables
>;
export const GetG100EventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetG100Events" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "g100Events" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "events" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "time" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "eventCounters" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetG100EventsQuery, GetG100EventsQueryVariables>;
export const GetLibbiMinuteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLibbiMinute" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "libbiMinute" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "batteryTemp" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batteryRadiatorTemp" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "inverterTemperature" },
                },
                { kind: "Field", name: { kind: "Name", value: "ambientTemp" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "controllerTemp" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dcPowerRecords" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pvPower1" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batteries" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "number" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heatFoilStatus" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cycles" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLibbiMinuteQuery, GetLibbiMinuteQueryVariables>;
export const GetZappi1ConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetZappi1Config" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "zappi1Config" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "boostTimers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "slot" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMinute" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mondayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tuesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wednesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thursdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fridayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "saturdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sundayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "economy" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "manualBoost" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "smartBoostEnergy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "smartBoostHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "smartBoostMinute" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minGreenLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plugInCharge" },
                },
                { kind: "Field", name: { kind: "Name", value: "defaultMode" } },
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "backlight" } },
                { kind: "Field", name: { kind: "Name", value: "contrast" } },
                { kind: "Field", name: { kind: "Name", value: "setBuzzer" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
                { kind: "Field", name: { kind: "Name", value: "dstOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timeFromCloud" },
                },
                { kind: "Field", name: { kind: "Name", value: "lockCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockEVUnplugged" },
                },
                { kind: "Field", name: { kind: "Name", value: "lockTimeout" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModeMinPWM" },
                },
                { kind: "Field", name: { kind: "Name", value: "deviceLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModePowerFactor" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportMargin" },
                },
                { kind: "Field", name: { kind: "Name", value: "gridLimit" } },
                { kind: "Field", name: { kind: "Name", value: "passcode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargeCompleteDelay" },
                },
                { kind: "Field", name: { kind: "Name", value: "eSenseInput" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Subtype" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Subtype" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModeActive" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModeInfinitePWM" },
                },
                { kind: "Field", name: { kind: "Name", value: "batteryMode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct1GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct2GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct3GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal2Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preconditioning" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetZappi1ConfigQuery,
  GetZappi1ConfigQueryVariables
>;
export const GetZappiConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetZappiConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "zappi2Config" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "boostTimers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "slot" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMinute" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mondayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tuesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wednesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thursdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fridayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "saturdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sundayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "economy" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "manualBoost" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "smartBoostEnergy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "smartBoostHour" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "smartBoostMinute" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minGreenLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startStopDelay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ecopStopDelay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plugInCharge" },
                },
                { kind: "Field", name: { kind: "Name", value: "defaultMode" } },
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "icons" } },
                { kind: "Field", name: { kind: "Name", value: "backlight" } },
                { kind: "Field", name: { kind: "Name", value: "contrast" } },
                { kind: "Field", name: { kind: "Name", value: "setBuzzer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fault" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "greenCharging" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mixedCharging" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dirtyCharging" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargeComplete" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stateB" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ledBrightness" },
                },
                { kind: "Field", name: { kind: "Name", value: "timeZone" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
                { kind: "Field", name: { kind: "Name", value: "dstOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timeFromCloud" },
                },
                { kind: "Field", name: { kind: "Name", value: "lockCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockEVPluggedIn" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockEVUnplugged" },
                },
                { kind: "Field", name: { kind: "Name", value: "lockTimeout" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockAutohide" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargeWhenPINLocked" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModeMinPWM" },
                },
                { kind: "Field", name: { kind: "Name", value: "deviceLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deviceLimitAmps" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModePowerFactor" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportMargin" },
                },
                { kind: "Field", name: { kind: "Name", value: "gridLimit" } },
                { kind: "Field", name: { kind: "Name", value: "passcode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargeCompleteDelay" },
                },
                { kind: "Field", name: { kind: "Name", value: "eSenseInput" } },
                { kind: "Field", name: { kind: "Name", value: "ctPrimary" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Subtype" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Subtype" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModeActive" },
                },
                { kind: "Field", name: { kind: "Name", value: "batteryMode" } },
                { kind: "Field", name: { kind: "Name", value: "earthing" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gridPowerLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "exportLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batteryDischargeEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostDetection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostThreshold" },
                },
                { kind: "Field", name: { kind: "Name", value: "ctDetection" } },
                { kind: "Field", name: { kind: "Name", value: "ct3Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct3Subtype" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct1GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct2GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct3GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct4GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal2Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal3Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal2Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal3Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "neutralLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "phaseReturn" } },
                { kind: "Field", name: { kind: "Name", value: "relay1PWM" } },
                { kind: "Field", name: { kind: "Name", value: "relay2PWM" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mainSwitchPWM" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockSolenoidPWM" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weldedRelayCheckDelay" },
                },
                { kind: "Field", name: { kind: "Name", value: "pERelayPWM" } },
                { kind: "Field", name: { kind: "Name", value: "preconOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preconEnergy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "randomDelayStart" },
                },
                { kind: "Field", name: { kind: "Name", value: "ecoMode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "autoPhaseSwitching" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetZappiConfigQuery, GetZappiConfigQueryVariables>;
export const GetRapidZappiConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRapidZappiConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rapidZappiConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "boostTimers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "slot" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMinute" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mondayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tuesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wednesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thursdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fridayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "saturdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sundayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "economy" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "manualBoost" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minGreenLevel" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "startStopDelay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ecopStopDelay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "plugInCharge" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "defaultSmartChargingMode" },
                },
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "icons" } },
                { kind: "Field", name: { kind: "Name", value: "setBuzzer" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fault" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "greenCharging" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mixedCharging" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dirtyCharging" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargeComplete" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "stateB" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "red" } },
                      { kind: "Field", name: { kind: "Name", value: "green" } },
                      { kind: "Field", name: { kind: "Name", value: "blue" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ledBrightness" },
                },
                { kind: "Field", name: { kind: "Name", value: "timeZone" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
                { kind: "Field", name: { kind: "Name", value: "dstOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timeFromCloud" },
                },
                { kind: "Field", name: { kind: "Name", value: "lockCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockEVPluggedIn" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockEVUnplugged" },
                },
                { kind: "Field", name: { kind: "Name", value: "lockTimeout" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockAutohide" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargeWhenPINLocked" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModeMinPWM" },
                },
                { kind: "Field", name: { kind: "Name", value: "deviceLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deviceLimitAmps" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModePowerFactor" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportMargin" },
                },
                { kind: "Field", name: { kind: "Name", value: "gridLimit" } },
                { kind: "Field", name: { kind: "Name", value: "passcode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargeCompleteDelay" },
                },
                { kind: "Field", name: { kind: "Name", value: "eSenseInput" } },
                { kind: "Field", name: { kind: "Name", value: "ctPrimary" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Subtype" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Subtype" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "compatibilityModeActive" },
                },
                { kind: "Field", name: { kind: "Name", value: "batteryMode" } },
                { kind: "Field", name: { kind: "Name", value: "earthing" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gridPowerLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "exportLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "batteryDischargeEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostDetection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostThreshold" },
                },
                { kind: "Field", name: { kind: "Name", value: "ctDetection" } },
                { kind: "Field", name: { kind: "Name", value: "ct3Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct3Subtype" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct1GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct2GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct3GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct4GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal2Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal3Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal2Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal3Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "neutralLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "phaseReturn" } },
                { kind: "Field", name: { kind: "Name", value: "relay1PWM" } },
                { kind: "Field", name: { kind: "Name", value: "relay2PWM" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mainSwitchPWM" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lockSolenoidPWM" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "weldedRelayCheckDelay" },
                },
                { kind: "Field", name: { kind: "Name", value: "pERelayPWM" } },
                { kind: "Field", name: { kind: "Name", value: "preconOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preconEnergy" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "randomDelayStart" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "autoPhaseSwitching" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRapidZappiConfigQuery,
  GetRapidZappiConfigQueryVariables
>;
export const GetEddiConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEddiConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eddiConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "boostTimers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "slot" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMinute" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "temperature" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mondayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tuesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wednesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thursdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fridayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "saturdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sundayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "economy" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "exportLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "neutralLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "powerLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostDetection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostThreshold" },
                },
                { kind: "Field", name: { kind: "Name", value: "ctDetection" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heaterPriority" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityCheckPeriod" },
                },
                { kind: "Field", name: { kind: "Name", value: "timeZone" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
                { kind: "Field", name: { kind: "Name", value: "dstOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timeFromCloud" },
                },
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "icons" } },
                { kind: "Field", name: { kind: "Name", value: "backlight" } },
                { kind: "Field", name: { kind: "Name", value: "contrast" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Subtype" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Subtype" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct1GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct2GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct3GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal2Group" },
                },
                { kind: "Field", name: { kind: "Name", value: "batteryMode" } },
                { kind: "Field", name: { kind: "Name", value: "deviceLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportMargin" },
                },
                { kind: "Field", name: { kind: "Name", value: "gridLimit" } },
                { kind: "Field", name: { kind: "Name", value: "passcode" } },
                { kind: "Field", name: { kind: "Name", value: "hotTime" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumExport" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumExportTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expRelay1" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onThreshold" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offThreshold" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "mode" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boostType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "includeDiverted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumOffTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumOnTime" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expRelay2" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onThreshold" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offThreshold" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "mode" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boostType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "includeDiverted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumOffTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumOnTime" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "esense" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "mode" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boostMode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterEnableMode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boostEnableMode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relayControlMode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEddiConfigQuery, GetEddiConfigQueryVariables>;
export const GetEddiPlusConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEddiPlusConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "eddiPlusConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "boostTimers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterType" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "slot" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMinute" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "temperature" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mondayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tuesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wednesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thursdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fridayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "saturdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sundayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "economy" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "exportLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "neutralLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "powerLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostDetection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostThreshold" },
                },
                { kind: "Field", name: { kind: "Name", value: "ctDetection" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heaterPriority" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "heatersAvailableCount" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "priorityCheckPeriod" },
                },
                { kind: "Field", name: { kind: "Name", value: "timeZone" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
                { kind: "Field", name: { kind: "Name", value: "dstOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timeFromCloud" },
                },
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "icons" } },
                { kind: "Field", name: { kind: "Name", value: "backlight" } },
                { kind: "Field", name: { kind: "Name", value: "contrast" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Subtype" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Subtype" } },
                { kind: "Field", name: { kind: "Name", value: "ct3Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct3Subtype" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct1GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct2GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct3GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal2Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal3Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal2Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal3Group" },
                },
                { kind: "Field", name: { kind: "Name", value: "batteryMode" } },
                { kind: "Field", name: { kind: "Name", value: "deviceLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportMargin" },
                },
                { kind: "Field", name: { kind: "Name", value: "gridLimit" } },
                { kind: "Field", name: { kind: "Name", value: "passcode" } },
                { kind: "Field", name: { kind: "Name", value: "hotTime" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumExport" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minimumExportTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expRelay1" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onThreshold" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offThreshold" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "mode" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boostType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "includeDiverted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumOffTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumOnTime" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "expRelay2" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "onThreshold" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "offThreshold" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "mode" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boostType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "includeDiverted" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumOffTime" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "minimumOnTime" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "esense" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "mode" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boostMode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "heaterEnableMode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "boostEnableMode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "relayControlMode" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEddiPlusConfigQuery,
  GetEddiPlusConfigQueryVariables
>;
export const GetLibbiConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetLibbiConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "libbiConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "boostTimers" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slot" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "duration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startHour" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "startMinute" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mondayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "tuesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "wednesdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "thursdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fridayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "saturdayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sundayOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "energyTarget" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "rate" } },
                      { kind: "Field", name: { kind: "Name", value: "mode" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "minReserveSoc" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "maxReserveSoc" },
                },
                { kind: "Field", name: { kind: "Name", value: "timeZone" } },
                { kind: "Field", name: { kind: "Name", value: "dateFormat" } },
                { kind: "Field", name: { kind: "Name", value: "dstOn" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "timeFromCloud" },
                },
                { kind: "Field", name: { kind: "Name", value: "genTypeIcon" } },
                { kind: "Field", name: { kind: "Name", value: "language" } },
                { kind: "Field", name: { kind: "Name", value: "countryCode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "backlightOnTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "contrastLevel" },
                },
                { kind: "Field", name: { kind: "Name", value: "passcode" } },
                { kind: "Field", name: { kind: "Name", value: "phaseReturn" } },
                { kind: "Field", name: { kind: "Name", value: "chargeLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dischargeLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "modbusTimeoutEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "threePhaseMonitoring" },
                },
                { kind: "Field", name: { kind: "Name", value: "ctDetection" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostDetection" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "masterLostThreshold" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dischargeLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "exportLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "neutralLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "earthing" } },
                { kind: "Field", name: { kind: "Name", value: "powerLimit" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "exportMargin" },
                },
                { kind: "Field", name: { kind: "Name", value: "gridLimit" } },
                { kind: "Field", name: { kind: "Name", value: "ct1Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct2Type" } },
                { kind: "Field", name: { kind: "Name", value: "ct3Type" } },
                { kind: "Field", name: { kind: "Name", value: "ctPrimary" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctInternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal1Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal2Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ctExternal3Group" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct1GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct2GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct3GroupLimit" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ct4GroupLimit" },
                },
                { kind: "Field", name: { kind: "Name", value: "batteryMode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "gridSubdivide" },
                },
                { kind: "Field", name: { kind: "Name", value: "pvInputMode" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "calibrationChargeComplete" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLibbiConfigQuery, GetLibbiConfigQueryVariables>;
export const GetHubIdBySerialNumberDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHubIdBySerialNumber" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "searchHubOrDevice" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "serialNo" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deviceSerialNo" },
                },
                { kind: "Field", name: { kind: "Name", value: "deviceName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetHubIdBySerialNumberQuery,
  GetHubIdBySerialNumberQueryVariables
>;
export const GetRecentCommandsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetRecentCommands" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hubSerialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hubDeviceName" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceName" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "recentCommands" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hubSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hubSerialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommandFragment" },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "recentHubCommands" },
            name: { kind: "Name", value: "recentCommands" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hubSerialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceName" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hubDeviceName" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hubSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hubSerialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CommandFragment" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommandFragment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Command" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "destinationDeviceSerialNo" },
          },
          { kind: "Field", name: { kind: "Name", value: "commandTries" } },
          { kind: "Field", name: { kind: "Name", value: "commandLastSent" } },
          { kind: "Field", name: { kind: "Name", value: "commandInitiated" } },
          { kind: "Field", name: { kind: "Name", value: "commandType" } },
          { kind: "Field", name: { kind: "Name", value: "commandState" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "commandInitiatorService" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commandInitiatorContext" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commandParametersJson" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "commandParameters" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "dsrSetLoad" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceAddresses" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "ttl" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRecentCommandsQuery,
  GetRecentCommandsQueryVariables
>;
export const GetDeviceConnectionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDeviceConnections" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deviceConnections" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "connectionTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "disconnectionTime" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDeviceConnectionsQuery,
  GetDeviceConnectionsQueryVariables
>;
export const GetExecutionContextIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetExecutionContextId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "commandId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "executionContextId" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "commandId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "commandId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "client" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "ip" } },
                      { kind: "Field", name: { kind: "Name", value: "port" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "xForwardedFor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "xForwardedPort" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "userAgent" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetExecutionContextIdQuery,
  GetExecutionContextIdQueryVariables
>;
export const GetHasPendingCommandsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetHasPendingCommands" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hubSerialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "hasPendingCommands" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "hubSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hubSerialNo" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetHasPendingCommandsQuery,
  GetHasPendingCommandsQueryVariables
>;
export const GetMonitoringConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMonitoringConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "hubSerial" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMonitoringConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "hubSerial" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "hubSerial" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serialNumber" },
                },
                { kind: "Field", name: { kind: "Name", value: "active" } },
                { kind: "Field", name: { kind: "Name", value: "endTime" } },
                { kind: "Field", name: { kind: "Name", value: "startTime" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMonitoringConfigQuery,
  GetMonitoringConfigQueryVariables
>;
export const GetOcppConfigDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOcppConfig" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "ocppConfig" },
            name: { kind: "Name", value: "getOcppConfig" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "device_serial_no" },
                },
                { kind: "Field", name: { kind: "Name", value: "wss_uri" } },
                { kind: "Field", name: { kind: "Name", value: "username" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "AuthorizationKey" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "HeartbeatInterval" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ClockAlignedDataInterval" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConnectionTimeOut" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "LocalAuthorizeOffline" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "LocalPreAuthorize" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "MeterValuesAlignedData" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "MeterValuesSampledData" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "MeterValueSampleInterval" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "NumberOfConnectors" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ResetRetries" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConnectorPhaseRotation" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "StopTransactionOnEVSideDisconnect",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "StopTransactionOnInvalidId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "StopTxnAlignedData" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "StopTxnSampledData" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "SupportedFeatureProfiles" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "TransactionMessageAttempts" },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "TransactionMessageRetryInterval",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "UnlockConnectorOnEVSideDisconnect",
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "LocalAuthListEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "LocalAuthListMaxLength" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "SendLocalListMaxLength" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "OCPPChargeMode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "RandomSmartChargeDelay" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "FreeCharging" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "PlugAndChargeID" },
                },
                { kind: "Field", name: { kind: "Name", value: "ocppEnabled" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "CommercialMode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "MaintenanceMode" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "HasPaymentTerminal" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "FreeVendScreen" },
                },
                { kind: "Field", name: { kind: "Name", value: "PricekWh" } },
                { kind: "Field", name: { kind: "Name", value: "PriceMinute" } },
                { kind: "Field", name: { kind: "Name", value: "IdleFee" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "ConnectionFee" },
                },
                { kind: "Field", name: { kind: "Name", value: "TariffType" } },
                { kind: "Field", name: { kind: "Name", value: "AppName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "SupportContact" },
                },
                { kind: "Field", name: { kind: "Name", value: "IsOperative" } },
                { kind: "Field", name: { kind: "Name", value: "PaymentURL" } },
                { kind: "Field", name: { kind: "Name", value: "Currency" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "CurrencyAfterValue" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "AllowPINCode" },
                },
                { kind: "Field", name: { kind: "Name", value: "ChargerName" } },
                { kind: "Field", name: { kind: "Name", value: "ChargerID" } },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "ocppStatus" },
            name: { kind: "Name", value: "getOcppStatus" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "ocppStatus" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOcppConfigQuery, GetOcppConfigQueryVariables>;
export const GetOcppLogMessagesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOcppLogMessages" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceSerialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOcppLogMessages" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceSerialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "group" } },
                { kind: "Field", name: { kind: "Name", value: "timestamp" } },
                { kind: "Field", name: { kind: "Name", value: "payload" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOcppLogMessagesQuery,
  GetOcppLogMessagesQueryVariables
>;
export const GetOcppChargingProfilesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetOcppChargingProfiles" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceSerialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getOcppChargingProfiles" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceSerialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "deviceSerialNo" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "chargingProfileId" },
                },
                { kind: "Field", name: { kind: "Name", value: "slotIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "transactionId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "rawChargingProfile" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetOcppChargingProfilesQuery,
  GetOcppChargingProfilesQueryVariables
>;
export const GetWebhooksByDeviceSerialNoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetWebhooksByDeviceSerialNo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceSerialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getWebhooksByDeviceSerialNo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceSerialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceSerialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "integrators" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "integratorData" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "integratorId" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "integratorName" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "webhooks" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceSerialNo" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "deviceClass" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "eventType" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "createdAt" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "updatedAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetWebhooksByDeviceSerialNoQuery,
  GetWebhooksByDeviceSerialNoQueryVariables
>;
export const GetThirdPartyConnectionsByCognitoSubsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetThirdPartyConnectionsByCognitoSubs" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cognitoSubs" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "ListType",
              type: {
                kind: "NonNullType",
                type: {
                  kind: "NamedType",
                  name: { kind: "Name", value: "String" },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "getThirdPartyConnectionsByCognitoSubs",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "cognitoSubs" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cognitoSubs" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                { kind: "Field", name: { kind: "Name", value: "clientName" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetThirdPartyConnectionsByCognitoSubsQuery,
  GetThirdPartyConnectionsByCognitoSubsQueryVariables
>;
export const GetDeviceRigDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDeviceRigData" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceSerialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rigData" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceSerialNo" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "serialNo" } },
                { kind: "Field", name: { kind: "Name", value: "blePin" } },
                { kind: "Field", name: { kind: "Name", value: "uid" } },
                { kind: "Field", name: { kind: "Name", value: "upc" } },
                { kind: "Field", name: { kind: "Name", value: "rigId" } },
                { kind: "Field", name: { kind: "Name", value: "pcbQr" } },
                { kind: "Field", name: { kind: "Name", value: "fpc" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "lastPassTime" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "provisionedAt" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDeviceRigDataQuery,
  GetDeviceRigDataQueryVariables
>;
export const GetDeviceHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDeviceHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Float" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "resolution" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "HistoryResolution" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "start" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "end" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "history" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceType" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "resolution" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "resolution" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "start" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "start" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "end" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "end" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "historyJson" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDeviceHistoryQuery,
  GetDeviceHistoryQueryVariables
>;
export const GetDeviceInstallationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetDeviceInstallation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "BigInt" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "deviceType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeviceType" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "installation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "deviceType" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "deviceType" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "installationDetails" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isComplete" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "existingDevice" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "masterDeviceType" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "masterDeviceSerialNumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hubDeviceType" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "hubDeviceSerialNumber",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "isPaired" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "renewableEnergy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "none" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasSolarPanel" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasWindTurbine" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasHydroelectric" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "hasElectricStorageHeating",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "hasBattery" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "other" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supplyAndLimits" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "deviceLimit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "importLimit" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "exportLimit" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "otherSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "earthingArrangement" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "mpan" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "radioChannelId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "vHub" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "installer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "acceptedTermsOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "acceptedPrivacyOn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "appVersion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "createdOn" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetDeviceInstallationQuery,
  GetDeviceInstallationQueryVariables
>;
export const GetChargeSessionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetChargeSessions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "start" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "end" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "chargeSessions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "start" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "start" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "end" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "end" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "data" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "authType" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargeDuration" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargeEnd" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "chargeStart" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "electricity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "greenElectricity" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "isBusiness" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pluggedIn" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "unplugged" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "zappiSerialNo" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "friendlyName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalElectricity" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "totalGreenElectricity" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetChargeSessionsQuery,
  GetChargeSessionsQueryVariables
>;
export const GetMqttConnectionHistoryDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetMqttConnectionHistory" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "serialNo" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "cursor" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getMqttConnectionHistory" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "serialNo" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "serialNo" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "cursor" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "cursor" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "results" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "connected" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "disconnectReason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timestamp" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "cursor" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetMqttConnectionHistoryQuery,
  GetMqttConnectionHistoryQueryVariables
>;
export const GetEnabledOcppConfigsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetEnabledOcppConfigs" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getEnabledOcppConfigs" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "wss_uri" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "device_serial_no" },
                },
                { kind: "Field", name: { kind: "Name", value: "created_at" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetEnabledOcppConfigsQuery,
  GetEnabledOcppConfigsQueryVariables
>;
export const MutateServerInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MutateServerInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ChangeServerInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateServerInfo" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateServerInfoMutation,
  MutateServerInfoMutationVariables
>;
export const MutateAlternateServersDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MutateAlternateServers" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ChangeAlternateServersInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateAlternateServers" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutateAlternateServersMutation,
  MutateAlternateServersMutationVariables
>;
export const GetServersInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetServersInfo" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getServersInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "shard" } },
                { kind: "Field", name: { kind: "Name", value: "ip" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
                { kind: "Field", name: { kind: "Name", value: "isDefault" } },
                { kind: "Field", name: { kind: "Name", value: "isActive" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetServersInfoQuery, GetServersInfoQueryVariables>;
export const GetAlternateServersInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetAlternateServersInfo" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getAlternateServersInfo" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serverA" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "ip" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "serverB" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "ip" } },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAlternateServersInfoQuery,
  GetAlternateServersInfoQueryVariables
>;
export const AddIntegratorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AddIntegrator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ThirdPartyCreateClientInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createThirdPartyIntegrator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clientSecret" },
                },
                { kind: "Field", name: { kind: "Name", value: "clientName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AddIntegratorMutation,
  AddIntegratorMutationVariables
>;
export const UpdateIntegratorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateIntegrator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ThirdPartyUpdateClientInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateThirdPartyIntegrator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientName" } },
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateIntegratorMutation,
  UpdateIntegratorMutationVariables
>;
export const RotateClientSecretDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RotateClientSecret" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rotateClientSecret" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clientSecret" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RotateClientSecretMutation,
  RotateClientSecretMutationVariables
>;
export const DeleteIntegratorDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "DeleteIntegrator" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteThirdPartyIntegrator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                { kind: "Field", name: { kind: "Name", value: "clientName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteIntegratorMutation,
  DeleteIntegratorMutationVariables
>;
export const GetIntegratorsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetIntegrators" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getThirdPartyIntegrators" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                { kind: "Field", name: { kind: "Name", value: "clientName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "numberOfDevices" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIntegratorsQuery, GetIntegratorsQueryVariables>;
export const GetIntegratorByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetIntegratorById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getThirdPartyIntegrator" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientId" } },
                { kind: "Field", name: { kind: "Name", value: "clientName" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clientSecret" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "redirectUris" },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetIntegratorByIdQuery,
  GetIntegratorByIdQueryVariables
>;
export const DeleteUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const MutateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "mutateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ChangeUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutateUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutateUserMutation, MutateUserMutationVariables>;
export const CreateUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CreateUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "newUser" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateUserInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "newUser" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "newUser" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "lastLogin" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "access" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const MutatePermissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MutatePermissions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ChangeRolePermissionsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutatePermissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "permissions" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutatePermissionsMutation,
  MutatePermissionsMutationVariables
>;
export const GetUserDetailsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserDetails" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "lastLogin" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "access" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserDetailsQuery, GetUserDetailsQueryVariables>;
export const GetUsersAndRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUsersAndRoles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "users" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "lastLogin" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "access" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "permissions" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "permissions" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUsersAndRolesQuery,
  GetUsersAndRolesQueryVariables
>;
export const GetUserRolesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserRoles" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserRolesQuery, GetUserRolesQueryVariables>;
export const GetUserRolesAndPermissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "GetUserRolesAndPermissions" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getUserRoles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "permissions" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetUserRolesAndPermissionsQuery,
  GetUserRolesAndPermissionsQueryVariables
>;
